export const originalActionTextMapper = {
  'English': {
    'CustomText': 'Custom Text',
    'WatchNow': 'Watch Now',
    'WatchMore': 'Watch More',
    'Watch': 'Watch',
    'VoteNow': 'Vote Now',
    'ViewPlans': 'View Plans',
    'ViewNow': 'View Now',
    'ViewCars': 'View Cars',
    'TryNow': 'Try Now',
    'TestDrive': 'Test Drive',
    'Subscribe': 'Subscribe',
    'StartNow': 'Start Now',
    'SignUp': 'Sign Up',
    'SignIn': 'Sign In',
    'Showtimes': 'Showtimes',
    'ShopNow': 'Shop Now',
    'SellNow': 'Sell Now',
    'SeeOffer': 'See Offer',
    'SeeMenu': 'See Menu',
    'Schedule': 'Schedule',
    'SaveNow': 'Save Now',
    'Sale': 'See Sale',
    'Reserve': 'Reserve',
    'RentNow': 'Rent Now',
    'RentACar': 'Rent A Car',
    'Register': 'Register',
    'PostJob': 'Post Job',
    'PlayNow': 'Play Now',
    'PlayGame': 'Play Game',
    'OrderNow': 'Order Now',
    'LogIn': 'Log In',
    'ListenNow': 'Listen Now',
    'LearnMore': 'Learn More',
    'JoinNow': 'Join Now',
    'GetQuote': 'Get Quote',
    'GetOffer': 'Get Offer',
    'GetDeals': 'Get Deals',
    'FreeTrial': 'Free Trial',
    'FreeQuote': 'Free Quote',
    'FreePlay': 'Free Play',
    'FindJob': 'Find Job',
    'FileNow': 'File Now',
    'EnrollNow': 'Enroll Now',
    'EmailNow': 'Email Now',
    'Download': 'Download',
    'Donate': 'Donate',
    'Coupon': 'Get Coupon',
    'ContactUs': 'Contact Us',
    'Compare': 'Compare',
    'ChatNow': 'Chat Now',
    'BuyNow': 'Buy Now',
    'BookNow': 'Book Now',
    'BookHotel': 'Book Hotel',
    'BookACar': 'Book A Car',
    'BidNow': 'Bid Now',
    'BetNow': 'Bet Now',
    'ApplyNow': 'Apply Now',
    'ActNow': 'Act Now',
    'Directions': 'Directions',
    'FindStore': 'Find Store',
    'SwitchNow': 'Switch Now',
    'VisitStore': 'Visit Store',
    'RenewNow': 'Renew Now',
    'Reorder': 'Reorder',
    'Browse': 'Browse',
    'VisitSite': 'Visit Site',
    'Explore': 'Explore',
    'SeeMore': 'See More',
    'StartFree': 'Start Free',
    'NewCars': 'New Cars',
    'UsedCars': 'Used Cars',
    'Message': 'Message',
  },
  'Danish': {
    'CustomText': 'Brugerdefineret tekst',
    'WatchNow': 'Se nu',
    'WatchMore': 'Se mere',
    'Watch': 'Se',
    'VoteNow': 'Stem nu',
    'ViewPlans': 'Vis planer',
    'ViewCars': 'Se biler',
    'TryNow': 'Prøv nu',
    'TestDrive': 'Prøvetur',
    'Subscribe': 'Abonner',
    'StartNow': 'Start nu',
    'SignUp': 'Tilmeld dig',
    'SignIn': 'Log på',
    'Showtimes': 'Spilletider',
    'ShopNow': 'Shop nu',
    'SellNow': 'Sælg nu',
    'SeeOffer': 'Se tilbud',
    'SeeMenu': 'Se menu',
    'Schedule': 'Spilleplan',
    'SaveNow': 'Gem nu',
    'Sale': 'Se udsalg',
    'Reserve': 'Reservér',
    'RentNow': 'Lej nu',
    'RentACar': 'Lej en bil',
    'Register': 'Registrer',
    'PostJob': 'Opslå job',
    'PlayNow': 'Spil nu',
    'PlayGame': 'Spil spil',
    'OrderNow': 'Bestil nu',
    'LogIn': 'Log på',
    'ListenNow': 'Lyt nu',
    'LearnMore': 'Få mere at vide',
    'JoinNow': 'Deltag nu',
    'GetQuote': 'Få et tilbud',
    'GetOffer': 'Få tilbud',
    'GetDeals': 'Få tilbud',
    'FreeTrial': 'Gratis prøve',
    'FreeQuote': 'Gratis tilbud',
    'FreePlay': 'Gratis spil',
    'FindJob': 'Find job',
    'FileNow': 'Anmeld nu',
    'EnrollNow': 'Tilmeld dig nu',
    'EmailNow': 'Send e-mail nu',
    'Download': 'Download',
    'Donate': 'Doner',
    'Coupon': 'Få kupon',
    'ContactUs': 'Kontakt os',
    'Compare': 'Sammenlign nu',
    'ChatNow': 'Chat nu',
    'BuyNow': 'Køb nu',
    'BookNow': 'Reservér nu',
    'BookHotel': 'Bestil hotel',
    'BookACar': 'Reservér en bil',
    'BidNow': 'Byd nu',
    'BetNow': 'Spil nu',
    'ApplyNow': 'Ansøg nu',
    'ActNow': 'Handl nu',
    'Directions': 'Rutevejledning',
    'FindStore': 'Find butik',
    'SwitchNow': 'Skift nu',
    'VisitStore': 'Besøg butik',
    'RenewNow': 'Forny ny',
    'Reorder': 'Bestil igen',
  },
  'German': {
    'CustomText': 'Benutzerdefinierter Text',
    'WatchNow': 'Jetzt ansehen',
    'WatchMore': 'Weitere ansehen',
    'Watch': 'Ansehen',
    'VoteNow': 'Jetzt abstimmen',
    'ViewPlans': 'Pläne anzeigen',
    'ViewCars': 'Autos anzeigen',
    'TryNow': 'Jetzt testen',
    'TestDrive': 'Testfahrt',
    'Subscribe': 'Abonnieren',
    'StartNow': 'Jetzt starten',
    'SignUp': 'Registrieren',
    'SignIn': 'Anmelden',
    'Showtimes': 'Vorstellungen',
    'ShopNow': 'Jetzt einkaufen',
    'SellNow': 'Jetzt verkaufen',
    'SeeOffer': 'Angebot anzeigen',
    'SeeMenu': 'Menü anzeigen',
    'Schedule': 'Zeitplan',
    'SaveNow': 'Jetzt speichern',
    'Sale': 'Sale anzeigen',
    'Reserve': 'Reservieren',
    'RentNow': 'Jetzt mieten',
    'RentACar': 'Auto mieten',
    'Register': 'Registrieren',
    'PostJob': 'Job posten',
    'PlayNow': 'Jetzt spielen',
    'PlayGame': 'Spiel spielen',
    'OrderNow': 'Jetzt bestellen',
    'LogIn': 'Anmelden',
    'ListenNow': 'Jetzt anhören',
    'LearnMore': 'Mehr Info',
    'JoinNow': 'Jetzt beitreten',
    'GetQuote': 'Angebot',
    'GetOffer': 'Angebot',
    'GetDeals': 'Angebote',
    'FindJob': 'Job suchen',
    'FileNow': 'Einreichen',
    'EnrollNow': 'Registrieren',
    'EmailNow': 'E-Mail senden',
    'Download': 'Download',
    'Donate': 'Spenden',
    'Coupon': 'Gutschein holen',
    'ContactUs': 'Kontaktieren',
    'Compare': 'Vergleichen',
    'ChatNow': 'Jetzt chatten',
    'BuyNow': 'Jetzt kaufen',
    'BookNow': 'Jetzt buchen',
    'BookHotel': 'Hotel buchen',
    'BookACar': 'Auto buchen',
    'BidNow': 'Jetzt bieten',
    'BetNow': 'Jetzt wetten',
    'ApplyNow': 'Jetzt bewerben',
    'ActNow': 'Jetzt handeln',
    'Directions': 'Wegbeschreibung',
    'FindStore': 'Shop suchen',
    'SwitchNow': 'Jetzt wechseln',
    'VisitStore': 'Shop besuchen',
    'RenewNow': 'Jetzt verlängern',
    'Reorder': 'Neu bestellen',
  },
  'Spanish': {
    'CustomText': 'Texto personalizado',
    'WatchNow': 'Ver ahora',
    'WatchMore': 'Ver más',
    'Watch': 'Ver',
    'VoteNow': 'Votar ahora',
    'ViewPlans': 'Ver planes',
    'ViewCars': 'Ver coches',
    'TryNow': 'Probar ahora',
    'TestDrive': 'Probar coche',
    'Subscribe': 'Suscribirse',
    'StartNow': 'Iniciar ahora',
    'SignUp': 'Registrarse',
    'SignIn': 'Iniciar sesión',
    'Showtimes': 'Horarios',
    'ShopNow': 'Comprar ahora',
    'SellNow': 'Vender ahora',
    'SeeOffer': 'Ver oferta',
    'SeeMenu': 'Ver menú',
    'Schedule': 'Programación',
    'SaveNow': 'Guardar ahora',
    'Sale': 'Ver oferta',
    'Reserve': 'Reservar',
    'RentNow': 'Alquilar ahora',
    'RentACar': 'Alquilar coche',
    'Register': 'Registro',
    'PostJob': 'Publicar anuncio',
    'PlayNow': 'Jugar ahora',
    'PlayGame': 'Jugar juego',
    'OrderNow': 'Pedir ahora',
    'LogIn': 'Iniciar sesión',
    'ListenNow': 'Escuchar ahora',
    'LearnMore': 'Más información',
    'JoinNow': 'Unirse ahora',
    'GetQuote': 'Obtener oferta',
    'GetOffer': 'Obtener oferta',
    'GetDeals': 'Obtener ofertas',
    'FreeTrial': 'Jugar ahora',
    'FreeQuote': 'Presupuesto',
    'FreePlay': 'Jugar gratis',
    'FindJob': 'Buscar trabajo',
    'FileNow': 'Archivar ahora',
    'EnrollNow': 'Inscribirse',
    'EmailNow': 'Enviar correo',
    'Download': 'Descargar',
    'Donate': 'Donar',
    'Coupon': 'Obtener cupón',
    'ContactUs': 'Contáctanos',
    'Compare': 'Comparar',
    'ChatNow': 'Chat ahora',
    'BuyNow': 'Comprar ahora',
    'BookNow': 'Reservar ahora',
    'BookHotel': 'Reservar hotel',
    'BookACar': 'Reservar coche',
    'BidNow': 'Pujar ahora',
    'BetNow': 'Apostar ahora',
    'ApplyNow': 'Aplicar ahora',
    'ActNow': 'Actuar ahora',
    'Directions': 'Indicaciones',
    'FindStore': 'Buscar tienda',
    'SwitchNow': 'Cambiar ahora',
    'VisitStore': 'Visitar tienda',
    'RenewNow': 'Renovar ahora',
    'Reorder': 'Repetir pedido',
  },
  'Finnish': {
    'CustomText': 'Mukautettu teksti',
    'WatchNow': 'Katso nyt',
    'WatchMore': 'Katso lisää',
    'Watch': 'Katso',
    'VoteNow': 'Äänestä nyt',
    'ViewPlans': 'Suunnitelmat',
    'ViewCars': 'Näytä autot',
    'TryNow': 'Kokeile nyt',
    'TestDrive': 'Koeajo',
    'Subscribe': 'Tilaa',
    'StartNow': 'Aloita nyt',
    'SignUp': 'Rekisteröidy',
    'SignIn': 'Kirjaudu sisään',
    'Showtimes': 'Esitysajat',
    'ShopNow': 'Osta nyt',
    'SellNow': 'Myy nyt',
    'SeeOffer': 'Näytä tarjous',
    'SeeMenu': 'Näytä valikko',
    'Schedule': 'Aikataulu',
    'SaveNow': 'Tallenna nyt',
    'Sale': 'Katso tarjous',
    'Reserve': 'Varaa',
    'RentNow': 'Vuokraa nyt',
    'RentACar': 'Vuokraa auto',
    'Register': 'Rekisteröi',
    'PostJob': 'Lähetä työ',
    'PlayNow': 'Toista nyt',
    'PlayGame': 'Pelaa peli',
    'OrderNow': 'Tilaa nyt',
    'LogIn': 'Kirjaudu sisään',
    'ListenNow': 'Kuuntele nyt',
    'LearnMore': 'Lue lisää',
    'JoinNow': 'Liity nyt',
    'GetQuote': 'Hae tarjous',
    'GetOffer': 'Hae tarjous',
    'GetDeals': 'Hae sopimuksia',
    'FreeTrial': 'Ilmaiskokeilu',
    'FreeQuote': 'Ilmaistarjous',
    'FreePlay': 'Ilmainen peli',
    'FindJob': 'Etsi työpaikka',
    'FileNow': 'Hae nyt',
    'EnrollNow': 'Ilmoittaudu nyt',
    'EmailNow': 'Sähköpostita',
    'Download': 'Lataa',
    'Donate': 'Lahjoita',
    'Coupon': 'Hanki kuponki',
    'ContactUs': 'Ota yhteyttä',
    'Compare': 'Vertaa',
    'ChatNow': 'Keskustele nyt',
    'BuyNow': 'Osta nyt',
    'BookNow': 'Varaa nyt',
    'BookHotel': 'Varaa hotelli',
    'BookACar': 'Varaa auto',
    'BidNow': 'Tarjoa nyt',
    'BetNow': 'Veikkaa nyt',
    'ApplyNow': 'Käytä nyt',
    'ActNow': 'Toimi nyt',
    'Directions': 'Reittiohjeet',
    'FindStore': 'Etsi kauppa',
    'SwitchNow': 'Vaihda nyt',
    'VisitStore': 'Siirry kauppaan',
    'RenewNow': 'Uusi nyt',
    'Reorder': 'Tilaa uudelleen',
  },
  'French': {
    'CustomText': 'Texte personnalisé',
    'WatchNow': 'Regarder',
    'WatchMore': 'Regarder plus',
    'Watch': 'Regarder',
    'VoteNow': 'Voter',
    'ViewPlans': 'Afficher plans',
    'TryNow': 'Essayer',
    'Subscribe': 'S’abonner',
    'StartNow': 'Démarrer',
    'SignUp': 'S’inscrire',
    'SignIn': 'Connexion',
    'Showtimes': 'Horaires',
    'ShopNow': 'Acheter',
    'SellNow': 'Vendre',
    'SeeOffer': 'Voir l’offre',
    'SeeMenu': 'Voir le menu',
    'Schedule': 'Planifier',
    'SaveNow': 'Enregistrer',
    'Sale': 'Voir l’offre',
    'Reserve': 'Réserver',
    'RentNow': 'Louer',
    'RentACar': 'Louer voiture',
    'Register': 'S’inscrire',
    'PostJob': 'Publier emploi',
    'PlayNow': 'Lire',
    'PlayGame': 'Jouer',
    'OrderNow': 'Commander',
    'LogIn': 'Connexion',
    'ListenNow': 'Écouter',
    'LearnMore': 'En savoir plus',
    'JoinNow': 'Rejoindre',
    'GetQuote': 'Obtenir devis',
    'GetOffer': 'Obtenir offre',
    'GetDeals': 'Obtenir offres',
    'FreeTrial': 'Essai gratuit',
    'FreeQuote': 'Devis gratuit',
    'FreePlay': 'Jeu gratuit',
    'FindJob': 'Trouver emploi',
    'FileNow': 'Ranger',
    'EnrollNow': 'S’inscrire',
    'EmailNow': 'Envoyer e-mail',
    'Download': 'Télécharger',
    'Donate': 'Faire un don',
    'Coupon': 'Obtenir un bon',
    'ContactUs': 'Nous contacter',
    'Compare': 'Comparer',
    'ChatNow': 'Discuter',
    'BuyNow': 'Acheter',
    'BookNow': 'Réserver',
    'BookHotel': 'Réserver hôtel',
    'BookACar': 'Réserver voiture',
    'BidNow': 'Faire une offre',
    'BetNow': 'Parier',
    'ApplyNow': 'Appliquer',
    'ActNow': 'Allez-y',
    'Directions': 'Itinéraires',
    'SwitchNow': 'Changer',
    'RenewNow': 'Renouveler',
    'Reorder': 'Recommander',
  },
  'Italian': {
    'CustomText': 'Testo personalizzato',
    'WatchNow': 'Guarda ora',
    'WatchMore': 'Guarda altro',
    'Watch': 'Guarda',
    'VoteNow': 'Vota ora',
    'ViewPlans': 'Vedi piani',
    'ViewCars': 'Visualizza auto',
    'TryNow': 'Prova ora',
    'TestDrive': 'Prova su strada',
    'Subscribe': 'Sottoscrivi',
    'StartNow': 'Inizia ora',
    'SignUp': 'Iscriviti',
    'SignIn': 'Accedi',
    'Showtimes': 'Orari',
    'ShopNow': 'Acquista ora',
    'SellNow': 'Vendi ora',
    'SeeOffer': 'Vedi offerta',
    'SeeMenu': 'Visualizza menu',
    'Schedule': 'Pianifica',
    'SaveNow': 'Salva ora',
    'Sale': 'Guarda sconto',
    'Reserve': 'Prenota',
    'RentNow': 'Noleggia ora',
    'RentACar': 'Noleggia auto',
    'Register': 'Registrati',
    'PostJob': 'Offerta lavoro',
    'PlayNow': 'Riproduci ora',
    'PlayGame': 'Gioca',
    'OrderNow': 'Ordina ora',
    'LogIn': 'Accedi',
    'ListenNow': 'Ascolta ora',
    'LearnMore': 'Ulteriori info',
    'JoinNow': 'Partecipa ora',
    'GetQuote': 'Preventivo',
    'GetOffer': 'Ottieni offerta',
    'GetDeals': 'Ottieni offerte',
    'FreeTrial': 'Prova gratuita',
    'FreePlay': 'Gioco gratuito',
    'FindJob': 'Trova lavoro',
    'FileNow': 'Inoltra ora',
    'EnrollNow': 'Iscriviti ora',
    'EmailNow': 'Invia e-mail',
    'Download': 'Scarica',
    'Donate': 'Dona',
    'Coupon': 'Ottieni coupon',
    'ContactUs': 'Contattaci',
    'Compare': 'Confronta',
    'ChatNow': 'Chatta ora',
    'BuyNow': 'Acquista ora',
    'BookNow': 'Prenota ora',
    'BookHotel': 'Prenota hotel',
    'BookACar': 'Prenota un\'auto',
    'BidNow': 'Offri ora',
    'BetNow': 'Scommetti ora',
    'ApplyNow': 'Applica ora',
    'ActNow': 'Agisci ora',
    'Directions': 'Indicazioni',
    'FindStore': 'Trova il negozio',
    'SwitchNow': 'Cambia subito',
    'VisitStore': 'Visita negozio',
    'RenewNow': 'Rinnova ora',
    'Reorder': 'Riordina',
  },
  'Norwegian': {
    'CustomText': 'Egendefinert tekst',
    'WatchNow': 'Se nå',
    'WatchMore': 'Se mer',
    'Watch': 'Se',
    'VoteNow': 'Stem nå',
    'ViewPlans': 'Se planer',
    'ViewCars': 'Vis biler',
    'TryNow': 'Prøv nå',
    'TestDrive': 'Testkjør',
    'Subscribe': 'Abonner',
    'StartNow': 'Start nå',
    'FreeTrial': 'Start gratis',
    'SignUp': 'Meld deg på',
    'SignIn': 'Logg på',
    'Showtimes': 'Visningstider',
    'ShopNow': 'Handle nå',
    'SellNow': 'Selg nå',
    'SeeOffer': 'Se tilbud',
    'SeeMenu': 'Se meny',
    'Schedule': 'Terminliste',
    'SaveNow': 'Spar nå',
    'Sale': 'Se salg',
    'Reserve': 'Reserver',
    'RentNow': 'Lei nå',
    'RentACar': 'Lei en bil',
    'Register': 'Registrer deg',
    'PostJob': 'Legg ut jobb',
    'PlayNow': 'Spill nå',
    'PlayGame': 'Spill',
    'OrderNow': 'Bestill nå',
    'LogIn': 'Logg på',
    'ListenNow': 'Hør nå',
    'LearnMore': 'Les mer',
    'JoinNow': 'Bli med nå',
    'GetQuote': 'Få anbud',
    'GetOffer': 'Få tilbud',
    'GetDeals': 'Få tilbud',
    'FreeQuote': 'Gratis anbud',
    'FreePlay': 'Gratis spill',
    'FindJob': 'Finn jobb',
    'FileNow': 'Søk nå',
    'EnrollNow': 'Registrer deg',
    'EmailNow': 'Send e-post nå',
    'Download': 'Last ned',
    'Donate': 'Doner',
    'Coupon': 'Hent kupong',
    'ContactUs': 'Kontakt oss',
    'Compare': 'Sammenlign',
    'ChatNow': 'Chat nå',
    'BuyNow': 'Kjøp nå',
    'BookNow': 'Reserver nå',
    'BookHotel': 'Reserver hotell',
    'BookACar': 'Reserver en bil',
    'BidNow': 'By nå',
    'BetNow': 'Sats nå',
    'ApplyNow': 'Søk nå',
    'ActNow': 'Handle nå',
    'Directions': 'Veibeskrivelse',
    'FindStore': 'Finn butikk',
    'SwitchNow': 'Bytt nå',
    'VisitStore': 'Gå til butikk',
    'RenewNow': 'Forny nå',
    'Reorder': 'Bestill på nytt',
  },
  'Dutch': {
    'CustomText': 'Aangepaste tekst',
    'WatchNow': 'Nu kijken',
    'WatchMore': 'Meer kijken',
    'Watch': 'Kijken',
    'VoteNow': 'Nu stemmen',
    'ViewPlans': 'Plannen tonen',
    'ViewCars': 'Auto\'s tonen',
    'TryNow': 'Nu proberen',
    'TestDrive': 'Proefrit',
    'Subscribe': 'Abonneren',
    'StartNow': 'Nu beginnen',
    'SignUp': 'Registreren',
    'SignIn': 'Aanmelden',
    'Showtimes': 'Aanvangstijd',
    'ShopNow': 'Nu shoppen',
    'SellNow': 'Nu verkopen',
    'SeeOffer': 'Aanbieding zien',
    'SeeMenu': 'Menu zien',
    'Schedule': 'Schema',
    'SaveNow': 'Nu besparen',
    'Sale': 'Sale bekijken',
    'Reserve': 'Reserveren',
    'RentNow': 'Nu huren',
    'RentACar': 'Auto huren',
    'Register': 'Registreren',
    'PlayNow': 'Nu spelen',
    'PlayGame': 'Game spelen',
    'OrderNow': 'Nu bestellen',
    'LogIn': 'Aanmelden',
    'ListenNow': 'Nu luisteren',
    'LearnMore': 'Meer informatie',
    'JoinNow': 'Nu meedoen',
    'GetQuote': 'Offerte krijgen',
    'GetOffer': 'Aanbieding zien',
    'GetDeals': 'Deals zien',
    'FreeTrial': 'Gratis demo',
    'FreeQuote': 'Gratis offerte',
    'FreePlay': 'Gratis spelen',
    'FindJob': 'Vacature zoeken',
    'FileNow': 'Nu inzenden',
    'EnrollNow': 'Nu inschrijven',
    'EmailNow': 'Nu e-mailen',
    'Download': 'Downloaden',
    'Donate': 'Doneren',
    'Coupon': 'Coupon aanvragen',
    'ContactUs': 'Contact opnemen',
    'Compare': 'Vergelijken',
    'ChatNow': 'Nu chatten',
    'BuyNow': 'Nu kopen',
    'BookNow': 'Nu boeken',
    'BookHotel': 'Hotel boeken',
    'BookACar': 'Auto huren',
    'BidNow': 'Nu bieden',
    'BetNow': 'Nu inzetten',
    'ApplyNow': 'Nu solliciteren',
    'ActNow': 'Nu beslissen',
    'Directions': 'Route',
    'FindStore': 'Winkel zoeken',
    'SwitchNow': 'Nu wisselen',
    'VisitStore': 'Winkel bezoeken',
    'RenewNow': 'Nu vernieuwen',
    'Reorder': 'Nabestellen',
  },
  'Portuguese': {
    'CustomText': 'Texto personalizado',
    'WatchNow': 'Assistir Agora',
    'WatchMore': 'Assistir Mais',
    'Watch': 'Assistir',
    'VoteNow': 'Votar Agora',
    'ViewPlans': 'Exibir Planos',
    'ViewCars': 'Exibir Carros',
    'TryNow': 'Experimentar Já',
    'TestDrive': 'Test Drive',
    'Subscribe': 'Assinar',
    'StartNow': 'Iniciar Agora',
    'SignUp': 'Inscrever-se',
    'SignIn': 'Entrar',
    'Showtimes': 'Horários',
    'ShopNow': 'Comprar Agora',
    'SellNow': 'Vender Agora',
    'SeeOffer': 'Ver Oferta',
    'SeeMenu': 'Ver Menu',
    'Schedule': 'Agenda',
    'SaveNow': 'Salvar Agora',
    'Sale': 'Ver Promoção',
    'Reserve': 'Reservar',
    'RentNow': 'Alugar Agora',
    'RentACar': 'Alugar um Carro',
    'Register': 'Registrar',
    'PostJob': 'Postar Trabalho',
    'PlayNow': 'Jogar Agora',
    'PlayGame': 'Jogar Jogo',
    'OrderNow': 'Encomendar',
    'LogIn': 'Fazer Logon',
    'ListenNow': 'Ouvir Agora',
    'LearnMore': 'Saiba Mais',
    'JoinNow': 'Ingressar Agora',
    'GetQuote': 'Obter Cotação',
    'GetOffer': 'Obter Oferta',
    'GetDeals': 'Obter Ofertas',
    'FreeTrial': 'Avalie Grátis',
    'FreeQuote': 'Cotação Grátis',
    'FreePlay': 'Jogo Grátis',
    'FindJob': 'Buscar Trabalho',
    'FileNow': 'Arquivar Agora',
    'EnrollNow': 'Registrar Agora',
    'EmailNow': 'Enviar Email',
    'Download': 'Download',
    'Donate': 'Doar',
    'Coupon': 'Obter Cupom',
    'ContactUs': 'Fale Conosco',
    'Compare': 'Comparar',
    'ChatNow': 'Conversar Agora',
    'BuyNow': 'Comprar Agora',
    'BookNow': 'Reservar Agora',
    'BookHotel': 'Reservar Hotel',
    'BookACar': 'Alugar um Carro',
    'BidNow': 'Fazer Lance',
    'BetNow': 'Apostar Agora',
    'ApplyNow': 'Solicitar Agora',
    'ActNow': 'Aja Agora',
    'Directions': 'Trajeto',
    'FindStore': 'Encontrar Loja',
    'SwitchNow': 'Mudar Agora',
    'VisitStore': 'Visitar Loja',
    'RenewNow': 'Renovar Agora',
    'Reorder': 'Comprar de novo',
  },
  'Swedish': {
    'CustomText': 'Anpassad text',
    'WatchNow': 'Titta nu',
    'WatchMore': 'Visa mer',
    'Watch': 'Visa',
    'VoteNow': 'Rösta nu',
    'ViewPlans': 'Visa planer',
    'ViewCars': 'Visa bilar',
    'TryNow': 'Prova nu',
    'TestDrive': 'Provkör',
    'Subscribe': 'Prenumerera',
    'StartNow': 'Börja nu',
    'SignUp': 'Registrering',
    'SignIn': 'Logga in',
    'Showtimes': 'Föreställningar',
    'ShopNow': 'Shoppa nu',
    'SellNow': 'Sälj nu',
    'SeeOffer': 'Visa erbjudande',
    'SeeMenu': 'Visa meny',
    'Schedule': 'Schemalägg',
    'SaveNow': 'Spara nu',
    'Sale': 'Visa försäljning',
    'Reserve': 'Reservera',
    'RentNow': 'Hyr nu',
    'RentACar': 'Hyr bil',
    'Register': 'Registrera dig',
    'PostJob': 'Lägg upp jobb',
    'PlayNow': 'Spela nu',
    'PlayGame': 'Spela',
    'OrderNow': 'Beställ nu',
    'LogIn': 'Logga in',
    'ListenNow': 'Lyssna nu',
    'LearnMore': 'Mer information',
    'JoinNow': 'Gå med nu',
    'GetQuote': 'Begär offert',
    'GetOffer': 'Se erbjudanden',
    'GetDeals': 'Se erbjudanden',
    'FreeTrial': 'Prova gratis',
    'FreeQuote': 'Gratis offert',
    'FreePlay': 'Spela gratis',
    'FindJob': 'Hitta jobb',
    'FileNow': 'Spara nu',
    'EnrollNow': 'Registrera nu',
    'EmailNow': 'Skicka mejl nu',
    'Download': 'Ladda ned',
    'Donate': 'Donera',
    'Coupon': 'Hämta kupong',
    'ContactUs': 'Kontakta oss',
    'Compare': 'Jämför',
    'ChatNow': 'Chatta nu',
    'BuyNow': 'Köp nu',
    'BookNow': 'Boka nu',
    'BookHotel': 'Boka hotel',
    'BookACar': 'Boka en bil',
    'BidNow': 'Bjud nu',
    'BetNow': 'Spela nu',
    'ApplyNow': 'Ansök nu',
    'ActNow': 'Gör det nu',
    'Directions': 'Vägbeskrivning',
    'FindStore': 'Hitta butik',
    'SwitchNow': 'Växla nu',
    'VisitStore': 'Besök butik',
    'RenewNow': 'Förnya nu',
    'Reorder': 'Beställ igen',
  },
  'TraditionalChinese': {
    'CustomText': '自訂文字',
    'WatchNow': '立即觀看',
    'WatchMore': '觀看更多',
    'Watch': '觀看',
    'VoteNow': '立即投票',
    'ViewPlans': '檢視方案',
    'ViewCars': '檢視車輛',
    'TryNow': '立即試試',
    'TestDrive': '試駕',
    'Subscribe': '訂閱',
    'StartNow': '立即開始',
    'SignUp': '註冊',
    'SignIn': '登入',
    'Showtimes': '放映時間',
    'ShopNow': '立即選購',
    'SellNow': '立即銷售',
    'SeeOffer': '查看優惠',
    'SeeMenu': '查看菜單',
    'Schedule': '排程',
    'SaveNow': '立即省錢',
    'Sale': '查看銷售',
    'Reserve': '預約',
    'RentNow': '立即租下',
    'RentACar': '租車',
    'Register': '註冊',
    'PostJob': '張貼職缺',
    'PlayNow': '立即玩',
    'PlayGame': '玩遊戲',
    'OrderNow': '立即訂購',
    'LogIn': '登入',
    'ListenNow': '立即聆聽',
    'LearnMore': '深入了解',
    'JoinNow': '立即加入',
    'GetQuote': '取得報價',
    'GetOffer': '取得優惠',
    'GetDeals': '取得優惠',
    'FreeTrial': '免費試用',
    'FreeQuote': '免費報價',
    'FreePlay': '免費玩',
    'FindJob': '找工作',
    'FileNow': '立即提交',
    'EnrollNow': '立即報名',
    'EmailNow': '立即寄電子郵件',
    'Download': '下載',
    'Donate': '捐贈',
    'Coupon': '取得優惠券',
    'ContactUs': '與我們連絡',
    'Compare': '比較',
    'ChatNow': '立即交談',
    'BuyNow': '立即購買',
    'BookNow': '立即預訂',
    'BookHotel': '訂旅館',
    'BookACar': '買車',
    'BidNow': '立即出價',
    'BetNow': '立即下注',
    'ApplyNow': '立即申請',
    'ActNow': '立即行動',
    'Directions': '路線',
    'FindStore': '尋找商店',
    'SwitchNow': '立即切換',
    'VisitStore': '造訪商店',
    'RenewNow': '立即更新',
    'Reorder': '重新訂購',
  },
  'Polish': {
    'CustomText': 'Tekst niestandardowy',
    'ActNow': 'Działaj teraz',
    'ApplyNow': 'Zgłoś się teraz',
    'BetNow': 'Postaw teraz',
    'BidNow': 'Licytuj teraz',
    'BookACar': 'Zarezerwuj samochód',
    'BookHotel': 'Zarezerwuj pokój',
    'BookNow': 'Zarezerwuj teraz',
    'BuyNow': 'Kup teraz',
    'ChatNow': 'Porozmawiaj na czacie',
    'Compare': 'Porównaj',
    'ContactUs': 'Skontaktuj się z nami',
    'Coupon': 'Uzyskaj kupon',
    'Directions': 'Wskazówki dojazdu',
    'Donate': 'Przekaż darowiznę',
    'Download': 'Pobierz',
    'EmailNow': 'Wyślij e-mail teraz',
    'EnrollNow': 'Zapisz się teraz',
    'FileNow': 'Złóż teraz',
    'FindJob': 'Znajdź pracę',
    'FindStore': 'Znajdź sklep',
    'FreePlay': 'Bezpłatna rozgrywka',
    'FreeQuote': 'Bezpłatna wycena',
    'FreeTrial': 'Bezpłatny okres próbny',
    'GetDeals': 'Uzyskaj oferty',
    'GetOffer': 'Uzyskaj ofertę',
    'GetQuote': 'Uzyskaj wycenę',
    'JoinNow': 'Dołącz teraz',
    'LearnMore': 'Dowiedz się więcej',
    'ListenNow': 'Posłuchaj teraz',
    'LogIn': 'Zaloguj się',
    'OrderNow': 'Zamów teraz',
    'PlayGame': 'Zagraj w coś',
    'PlayNow': 'Zagraj teraz',
    'PostJob': 'Zamieść ofertę pracy',
    'Register': 'Zarejestruj się',
    'RenewNow': 'Odnów teraz',
    'RentACar': 'Wynajmij samochód',
    'RentNow': 'Wynajmij teraz',
    'Reorder': 'Zamów ponownie',
    'Reserve': 'Zarezerwuj',
    'Sale': 'Zobacz wyprzedaż',
    'SaveNow': 'Zapisz teraz',
    'Schedule': 'Zaplanuj',
    'SeeMenu': 'Zobacz menu',
    'SeeOffer': 'Zobacz ofertę',
    'SellNow': 'Sprzedaj teraz',
    'ShopNow': 'Kup teraz',
    'Showtimes': 'Pory seansów',
    'SignIn': 'Zaloguj się',
    'SignUp': 'Zarejestruj się',
    'StartNow': 'Rozpocznij teraz',
    'Subscribe': 'Zasubskrybuj',
    'SwitchNow': 'Przejdź teraz',
    'TestDrive': 'Jazda próbna',
    'TryNow': 'Wypróbuj teraz',
    'ViewCars': 'Zobacz samochody',
    'ViewPlans': 'Zobacz taryfy',
    'VisitStore': 'Odwiedź sklep',
    'VoteNow': 'Zagłosuj teraz',
    'Watch': 'Obejrzyj',
    'WatchMore': 'Obejrzyj więcej',
    'WatchNow': 'Obejrzyj teraz',
  },
  'Turkish': {
    'CustomText': 'Özel Metin',
    'ActNow': 'Hemen Harekete Geç',
    'ApplyNow': 'Hemen Başvur',
    'BetNow': 'Hemen İddiaya Gir',
    'BidNow': 'Hemen Teklif Ver',
    'BookACar': 'Araba Ayırt',
    'BookHotel': 'Otel Ayırt',
    'BookNow': 'Hemen Ayırt',
    'BuyNow': 'Hemen Satın Al',
    'ChatNow': 'Hemen Sohbet Et',
    'Compare': 'Karşılaştır',
    'ContactUs': 'Bize Ulaşın',
    'Coupon': 'Kupon Al',
    'Directions': 'Yol Tarifi',
    'Donate': 'Bağış Yap',
    'Download': 'İndir',
    'EmailNow': 'Hemen E-posta Gönder',
    'EnrollNow': 'Hemen Kaydol',
    'FileNow': 'Hemen Gönder',
    'FindJob': 'İş Bul',
    'FindStore': 'Mağaza Bul',
    'FreePlay': 'Ücretsiz Oyna',
    'FreeQuote': 'Ücretsiz Fiyat Teklifi',
    'FreeTrial': 'Ücretsiz Deneme',
    'GetDeals': 'Fırsat Al',
    'GetOffer': 'Teklif Al',
    'GetQuote': 'Fiyat Teklifi Al',
    'JoinNow': 'Hemen Katıl',
    'LearnMore': 'Daha Fazla Bilgi',
    'ListenNow': 'Hemen Dinle',
    'LogIn': 'Oturum Aç',
    'OrderNow': 'Hemen Sipariş Ver',
    'PlayGame': 'Oyun Oyna',
    'PlayNow': 'Hemen Oyna',
    'PostJob': 'İş İlanı Yayımla',
    'Register': 'Kaydol',
    'RenewNow': 'Hemen Yenile',
    'RentACar': 'Araba Kirala',
    'RentNow': 'Hemen Kirala',
    'Reorder': 'Yeniden Sırala',
    'Reserve': 'Rezerve Et',
    'Sale': 'İndirimi Göster',
    'SaveNow': 'Hemen Kaydet',
    'Schedule': 'Zamanla',
    'SeeMenu': 'Menüyü Göster',
    'SeeOffer': 'Teklifi Göster',
    'SellNow': 'Hemen Sat',
    'ShopNow': 'Hemen Alışveriş Yap',
    'Showtimes': 'Gösteri Zamanları',
    'SignIn': 'Oturum Aç',
    'SignUp': 'Kaydol',
    'StartNow': 'Hemen Başla',
    'Subscribe': 'Abone Ol',
    'SwitchNow': 'Hemen Geçiş Yap',
    'TestDrive': 'Test Sürüşü',
    'TryNow': 'Hemen Dene',
    'ViewCars': 'Arabaları Görüntüle',
    'ViewPlans': 'Planları Görüntüle',
    'VisitStore': 'Mağazayı Görüntüle',
    'VoteNow': 'Hemen Oy Ver',
    'Watch': 'İzle',
    'WatchMore': 'Daha Fazlasını İzle',
    'WatchNow': 'Hemen İzle',
  },
  'Greek': {
    'CustomText': 'Προσαρμοσμένο κείμενο',
    'ActNow': 'Δράστε τώρα',
    'ApplyNow': 'Αίτηση τώρα',
    'BetNow': 'Στοίχημα τώρα',
    'BidNow': 'Προσφορά τώρα',
    'BookACar': 'Κράτηση αυτοκινήτου',
    'BookHotel': 'Κράτηση ξενοδοχείου',
    'BookNow': 'Κράτηση τώρα',
    'BuyNow': 'Αγορά τώρα',
    'ChatNow': 'Συνομιλία τώρα',
    'Compare': 'Σύγκριση',
    'ContactUs': 'Επικοινωνία',
    'Coupon': 'Απόκτηση κουπονιού',
    'Directions': 'Οδηγίες',
    'Donate': 'Δωρεά',
    'Download': 'Λήψη',
    'EmailNow': 'Αποστολή email τώρα',
    'EnrollNow': 'Εγγραφή τώρα',
    'FileNow': 'Αρχειοθέτηση τώρα',
    'FindJob': 'Εύρεση εργασίας',
    'FindStore': 'Εύρεση καταστήματος',
    'FreePlay': 'Δωρεάν παιχνίδι',
    'FreeQuote': 'Δωρεάν προσφορά',
    'FreeTrial': 'Δωρεάν δοκιμή',
    'GetDeals': 'Λάβετε προσφορές',
    'GetOffer': 'Λάβετε προσφορά',
    'GetQuote': 'Λάβετε τιμή',
    'JoinNow': 'Εγγραφή τώρα',
    'LearnMore': 'Μάθετε περισσότερα',
    'ListenNow': 'Ακρόαση τώρα',
    'LogIn': 'Σύνδεση',
    'OrderNow': 'Παραγγελία τώρα',
    'PlayGame': 'Αναπαραγωγή παιχνιδιού',
    'PlayNow': 'Αναπαραγωγή τώρα',
    'PostJob': 'Δημοσίευση θέσης εργασίας',
    'Register': 'Καταχώριση',
    'RenewNow': 'Ανανέωση τώρα',
    'RentACar': 'Ενοικίαση αυτοκινήτου',
    'RentNow': 'Ενοικίαση τώρα',
    'Reorder': 'Αναπαραγγελία',
    'Reserve': 'Κράτηση',
    'Sale': 'Προβολή πώλησης',
    'SaveNow': 'Αποθήκευση τώρα',
    'Schedule': 'Πρόγραμμα',
    'SeeMenu': 'Προβολή μενού',
    'SeeOffer': 'Προβολή προσφοράς',
    'SellNow': 'Πώληση τώρα',
    'ShopNow': 'Αγορά τώρα',
    'Showtimes': 'Ώρες προβολής',
    'SignIn': 'Είσοδος',
    'SignUp': 'Εγγραφή',
    'StartNow': 'Έναρξη τώρα',
    'Subscribe': 'Συνδρομή',
    'SwitchNow': 'Μετάβαση τώρα',
    'TestDrive': 'Δοκιμή',
    'TryNow': 'Δοκιμή τώρα',
    'ViewCars': 'Προβολή αυτοκινήτων',
    'ViewPlans': 'Προβολή σχεδίων',
    'VisitStore': 'Επίσκεψη στο κατάστημα',
    'VoteNow': 'Ψηφοφορία τώρα',
    'Watch': 'Παρακολούθηση',
    'WatchMore': 'Παρακολούθηση περισσότερων',
    'WatchNow': 'Παρακολούθηση τώρα',
  },
  'Bulgarian': {
    'CustomText': 'Текст по избор',
    'ActNow': 'Действайте сега',
    'ApplyNow': 'Кандидатствайте сега',
    'BetNow': 'Заложете сега',
    'BidNow': 'Наддайте сега',
    'BookACar': 'Резервирайте кола',
    'BookHotel': 'Резервирайте хотел',
    'BookNow': 'Резервирайте сега',
    'BuyNow': 'Купете сега',
    'ChatNow': 'Чат сега',
    'Compare': 'Сравняване',
    'ContactUs': 'Връзка с нас',
    'Coupon': 'Вземете купон',
    'Directions': 'Направления',
    'Donate': 'Дарете',
    'Download': 'Изтегляне',
    'EmailNow': 'Изпратете имейл сега',
    'EnrollNow': 'Запишете се сега',
    'FileNow': 'Подайте сега',
    'FindJob': 'Намерете работа',
    'FindStore': 'Намерете магазин',
    'FreePlay': 'Безплатна игра',
    'FreeQuote': 'Безплатна оферта',
    'FreeTrial': 'Безплатен пробен период',
    'GetDeals': 'Вземете оферти',
    'GetOffer': 'Получете оферта',
    'GetQuote': 'Вземете оферта',
    'JoinNow': 'Присъединете се сега',
    'LearnMore': 'Научете повече',
    'ListenNow': 'Слушайте сега',
    'LogIn': 'Влизане',
    'OrderNow': 'Поръчайте сега',
    'PlayGame': 'Играйте',
    'PlayNow': 'Играйте сега',
    'PostJob': 'Публикувайте работна оферта',
    'Register': 'Регистриране',
    'RenewNow': 'Подновете сега',
    'RentACar': 'Кола под наем',
    'RentNow': 'Наемете сега',
    'Reorder': 'Поръчайте отново',
    'Reserve': 'Резервирайте',
    'Sale': 'Преглед на разпродажбата',
    'SaveNow': 'Спестете сега',
    'Schedule': 'Програма',
    'SeeMenu': 'Преглед на менюто',
    'SeeOffer': 'Преглед на офертата',
    'SellNow': 'Продайте сега',
    'ShopNow': 'Пазарувайте сега',
    'Showtimes': 'Прожекции',
    'SignIn': 'Вход',
    'SignUp': 'Регистрирация',
    'StartNow': 'Стартирайте сега',
    'Subscribe': 'Абониране',
    'SwitchNow': 'Превключете сега',
    'TestDrive': 'Тестово шофиране',
    'TryNow': 'Опитайте сега',
    'ViewCars': 'Преглед на автомобилите',
    'ViewPlans': 'Преглед на плановете',
    'VisitStore': 'Посетете магазина',
    'VoteNow': 'Гласувайте сега',
    'Watch': 'Гледайте',
    'WatchMore': 'Гледайте още',
    'WatchNow': 'Гледайте сега',
  },
  'Croatian': {
    'CustomText': 'Prilagođeni tekst',
    'ActNow': 'Djelujte sada',
    'ApplyNow': 'Primijeni sada',
    'BetNow': 'Kladite se sada',
    'BidNow': 'Pošaljite ponudu sada',
    'BookACar': 'Rezervirajte automobil',
    'BookHotel': 'Rezervirajte hotel',
    'BookNow': 'Rezervirajte odmah',
    'BuyNow': 'Kupite sada',
    'ChatNow': 'Razgovarajte sada',
    'Compare': 'Usporedi',
    'ContactUs': 'Obratite nam se',
    'Coupon': 'Ostvarite kupon',
    'Directions': 'Upute',
    'Donate': 'Doniraj',
    'Download': 'Preuzmi',
    'EmailNow': 'Pošalji poruku e-pošte sada',
    'EnrollNow': 'Upišite se sada',
    'FileNow': 'Predajte odmah',
    'FindJob': 'Traženje posla',
    'FindStore': 'Traženje trgovine',
    'FreePlay': 'Besplatna reprodukcija',
    'FreeQuote': 'Besplatna ponuda',
    'FreeTrial': 'Besplatna probna verzija',
    'GetDeals': 'Ostvarite ponude',
    'GetOffer': 'Ostvarite ponudu',
    'GetQuote': 'Zatražite ponudu',
    'JoinNow': 'Pridruži se sada',
    'LearnMore': 'Saznajte više',
    'ListenNow': 'Slušajte sada',
    'LogIn': 'Prijava',
    'OrderNow': 'Naručite sada',
    'PlayGame': 'Igraj igru',
    'PlayNow': 'Igraj sada',
    'PostJob': 'Objavi posao',
    'Register': 'Registracija',
    'RenewNow': 'Obnovi sada',
    'RentACar': 'Unajmite automobil',
    'RentNow': 'Unajmi sada',
    'Reorder': 'Promijeni redoslijed',
    'Reserve': 'Rezerviraj',
    'Sale': 'Pogledajte rasprodaju',
    'SaveNow': 'Spremi sada',
    'Schedule': 'Zakaži',
    'SeeMenu': 'Pogledaj jelovnik',
    'SeeOffer': 'Prikaži ponudu',
    'SellNow': 'Prodaj sada',
    'ShopNow': 'Krenite u kupovinu',
    'Showtimes': 'Raspored prikazivanja',
    'SignIn': 'Prijavite se',
    'SignUp': 'Registrirajte se',
    'StartNow': 'Započnite odmah',
    'Subscribe': 'Pretplatite se',
    'SwitchNow': 'Promijeni odmah',
    'TestDrive': 'Probna vožnja',
    'TryNow': 'Isprobajte sada',
    'ViewCars': 'Prikaži automobile',
    'ViewPlans': 'Prikaži planove',
    'VisitStore': 'Posjeti trgovinu',
    'VoteNow': 'Glasajte sada',
    'Watch': 'Gledaj',
    'WatchMore': 'Pogledajte više',
    'WatchNow': 'Pogledajte sada',
  },
  'Czech': {
    'CustomText': 'Vlastní text',
    'ActNow': 'Jednat',
    'ApplyNow': 'Požádat',
    'BetNow': 'Vsadit si',
    'BidNow': 'Učinit nabídku',
    'BookACar': 'Rezervace auta',
    'BookHotel': 'Rezervovat hotel',
    'BookNow': 'Zarezervovat',
    'BuyNow': 'Kup teď',
    'ChatNow': 'Chatovat',
    'Compare': 'Porovnat',
    'ContactUs': 'Kontaktujte nás',
    'Coupon': 'Získat kupon',
    'Directions': 'Navigační pokyny',
    'Donate': 'Darovat',
    'Download': 'Stáhnout',
    'EmailNow': 'Napsat e-mail',
    'EnrollNow': 'Zapsat se',
    'FileNow': 'Podat',
    'FindJob': 'Najít práci',
    'FindStore': 'Najít obchod',
    'FreePlay': 'Hrát zdarma',
    'FreeQuote': 'Bezplatná nabídka',
    'FreeTrial': 'Bezplatná zkušební verze',
    'GetDeals': 'Získat slevy',
    'GetOffer': 'Získat nabídku',
    'GetQuote': 'Požádat o nabídku',
    'JoinNow': 'Zapojit se',
    'LearnMore': 'Další informace',
    'ListenNow': 'Poslouchat',
    'LogIn': 'Přihlásit se',
    'OrderNow': 'Objednat',
    'PlayGame': 'Hrát',
    'PlayNow': 'Přehrát',
    'PostJob': 'Zveřejnit',
    'Register': 'Registrovat',
    'RenewNow': 'Prodloužit',
    'RentACar': 'Pronájem auta',
    'RentNow': 'Pronajmout',
    'Reorder': 'Přeobjednat',
    'Reserve': 'Rezervovat',
    'Sale': 'Zobrazit slevu',
    'SaveNow': 'Uložit',
    'Schedule': 'Časový plán',
    'SeeMenu': 'Zobrazit menu',
    'SeeOffer': 'Zobrazit nabídku',
    'SellNow': 'Prodat',
    'ShopNow': 'Nakupovat',
    'Showtimes': 'Programy',
    'SignIn': 'Přihlášení',
    'SignUp': 'Zaregistrovat se',
    'StartNow': 'Spustit',
    'Subscribe': 'Přihlásit se k odběru',
    'SwitchNow': 'Přejít',
    'TestDrive': 'Zkušební jízda',
    'TryNow': 'Vyzkoušet',
    'ViewCars': 'Zobrazit auta',
    'ViewPlans': 'Zobrazit plány',
    'VisitStore': 'Navštívit obchod',
    'VoteNow': 'Hlasovat',
    'Watch': 'Sledovat',
    'WatchMore': 'Sledovat další',
    'WatchNow': 'Sledovat nyní',
  },
  'Estonian': {
    'CustomText': 'Kohandatud tekst',
    'ActNow': 'Tegutse kohe',
    'ApplyNow': 'Rakenda kohe',
    'BetNow': 'Panusta kohe',
    'BidNow': 'Paku kohe',
    'BookACar': 'Broneeri auto',
    'BookHotel': 'Broneeri hotell',
    'BookNow': 'Broneeri kohe',
    'BuyNow': 'Osta kohe',
    'ChatNow': 'Vestle kohe',
    'Compare': 'Võrdle',
    'ContactUs': 'Kontaktteave',
    'Coupon': 'Hangi kupong',
    'Directions': 'Juhised',
    'Donate': 'Anneta',
    'Download': 'Laadi alla',
    'EmailNow': 'Meili kohe',
    'EnrollNow': 'Registreeru kohe',
    'FileNow': 'Esita taotlus kohe',
    'FindJob': 'Otsi tööd',
    'FindStore': 'Otsi poodi',
    'FreePlay': 'Tasuta mäng',
    'FreeQuote': 'Tasuta hinnapakkumine',
    'FreeTrial': 'Tasuta prooviversioon',
    'GetDeals': 'Hangi pakkumisi',
    'GetOffer': 'Hangi pakkumine',
    'GetQuote': 'Hangi hinnapakkumine',
    'JoinNow': 'Liitu kohe',
    'LearnMore': 'Lisateave',
    'ListenNow': 'Kuula kohe',
    'LogIn': 'Logi sisse',
    'OrderNow': 'Telli kohe',
    'PlayGame': 'Mängi',
    'PlayNow': 'Esita kohe',
    'PostJob': 'Postita töö',
    'Register': 'Registreeri',
    'RenewNow': 'Uuenda kohe',
    'RentACar': 'Autorent',
    'RentNow': 'Rendi kohe',
    'Reorder': 'Telli uuesti',
    'Reserve': 'Reserveeri',
    'Sale': 'Kuva allahindlus',
    'SaveNow': 'Säästa kohe',
    'Schedule': 'Ajasta',
    'SeeMenu': 'Kuva menüü',
    'SeeOffer': 'Kuva pakkumine',
    'SellNow': 'Müü kohe',
    'ShopNow': 'Mine poodi',
    'Showtimes': 'Esitusajad',
    'SignIn': 'Sisse logima',
    'SignUp': 'Registreeru',
    'StartNow': 'Alusta kohe',
    'Subscribe': 'Telli',
    'SwitchNow': 'Vaheta kohe',
    'TestDrive': 'Proovisõit',
    'TryNow': 'Proovi kohe',
    'ViewCars': 'Vaata autosid',
    'ViewPlans': 'Kuva plaanid',
    'VisitStore': 'Külasta poodi',
    'VoteNow': 'Hääleta kohe',
    'Watch': 'Vaata',
    'WatchMore': 'Vaata veel',
    'WatchNow': 'Vaata kohe',
  },
  'Hungarian': {
    'CustomText': 'Egyéni szöveg',
    'ActNow': 'Cselekvés',
    'ApplyNow': 'Alkalmaz',
    'BetNow': 'Fogadás',
    'BidNow': 'Licitálás',
    'BookACar': 'Autófoglalás',
    'BookHotel': 'Szállodai foglalás',
    'BookNow': 'Foglalás most',
    'BuyNow': 'Megvásárlás most',
    'ChatNow': 'Csevegés most',
    'Compare': 'Összehasonlítás',
    'ContactUs': 'Kapcsolatfelvétel',
    'Coupon': 'Kupon beszerzése',
    'Directions': 'Útvonalak',
    'Donate': 'Adományozás',
    'Download': 'Letöltés',
    'EmailNow': 'E-mail küldése',
    'EnrollNow': 'Regisztráció most',
    'FileNow': 'Iktatás',
    'FindJob': 'Állás keresése',
    'FindStore': 'Üzlet keresése',
    'FreePlay': 'Ingyenesen játszható',
    'FreeQuote': 'Ingyenes árajánlat',
    'FreeTrial': 'Ingyenes próbaverzió',
    'GetDeals': 'Ajánlatok megtekintése',
    'GetOffer': 'Ajánlat igénybevétele',
    'GetQuote': 'Ajánlat kérése',
    'JoinNow': 'Csatlakozás most',
    'LearnMore': 'További információ',
    'ListenNow': 'Hallgatás',
    'LogIn': 'Belépés',
    'OrderNow': 'Rendelés',
    'PlayGame': 'Játék',
    'PlayNow': 'Lejátszás',
    'PostJob': 'Álláshirdetés feladása',
    'Register': 'Regisztráció',
    'RenewNow': 'Megújítás',
    'RentACar': 'Autóbérlés',
    'RentNow': 'Bérlés',
    'Reorder': 'Újrarendelés',
    'Reserve': 'Foglalás',
    'Sale': 'Akció megtekintése',
    'SaveNow': 'Megtakarítás',
    'Schedule': 'Ütemezés',
    'SeeMenu': 'Menü megtekintése',
    'SeeOffer': 'Ajánlat megtekintése',
    'SellNow': 'Eladás',
    'ShopNow': 'Vásárlás most',
    'Showtimes': 'Műsorok',
    'SignIn': 'Bejelentkezés',
    'SignUp': 'Csatlakozás',
    'StartNow': 'Kezdés most',
    'Subscribe': 'Feliratkozás',
    'SwitchNow': 'Váltás most',
    'TestDrive': 'Tesztvezetés',
    'TryNow': 'Kipróbálás',
    'ViewCars': 'Autók megtekintése',
    'ViewPlans': 'Csomgaok megtekintése',
    'VisitStore': 'Áruház felkeresése',
    'VoteNow': 'Szavazás',
    'Watch': 'Megtekintés',
    'WatchMore': 'Továbbiak megtekintése',
    'WatchNow': 'Megtekintés most',
  },
  'Latvian': {
    'CustomText': 'Pielāgots teksts',
    'ActNow': 'Rīkojieties tūlīt',
    'ApplyNow': 'Lietot tagad',
    'BetNow': 'Solīt tūlīt',
    'BidNow': 'Soliet tūlīt',
    'BookACar': 'Rezervēt automašīnu',
    'BookHotel': 'Rezervēt viesnīcu',
    'BookNow': 'Rezervēt tagad',
    'BuyNow': 'Pirkt tūlīt',
    'ChatNow': 'Tērzēt tagad',
    'Compare': 'Salīdzināt',
    'ContactUs': 'Sazināties ar mums',
    'Coupon': 'Saņemt kuponu',
    'Directions': 'Norādes',
    'Donate': 'Ziedot',
    'Download': 'Lejupielādēt',
    'EmailNow': 'Nosūtīt e-pasta ziņojumu tūlīt',
    'EnrollNow': 'Reģistrēties tūlīt',
    'FileNow': 'Iesniegt tūlīt',
    'FindJob': 'Atrast darbu',
    'FindStore': 'Atrast veikalu',
    'FreePlay': 'Bezmaksas spēle',
    'FreeQuote': 'Bezmaksas piedāvājums',
    'FreeTrial': 'Bezmaksas izmēģinājumversija',
    'GetDeals': 'Saņemt piedāvājumus',
    'GetOffer': 'Saņemt piedāvājumu',
    'GetQuote': 'Iegūt piedāvājumu',
    'JoinNow': 'Pievienoties tūlīt',
    'LearnMore': 'Uzzināt vairāk',
    'ListenNow': 'Klausīties tūlīt',
    'LogIn': 'Pieteikties',
    'OrderNow': 'Pasūtīt tūlīt',
    'PlayGame': 'Spēlēt spēli',
    'PlayNow': 'Atskaņot tagad',
    'PostJob': 'Publicēt darbu',
    'Register': 'Piereģistrēties',
    'RenewNow': 'Atjaunot tūlīt',
    'RentACar': 'Nomāt automašīnu',
    'RentNow': 'Nomāt tūlīt',
    'Reorder': 'Pārkārtot',
    'Reserve': 'Rezervēt',
    'Sale': 'Skatīt izpārdošanas piedāvājumu',
    'SaveNow': 'Ietaupīt tūlīt',
    'Schedule': 'Grafiks',
    'SeeMenu': 'Skatīt izvēlni',
    'SeeOffer': 'Skatīt piedāvājumu',
    'SellNow': 'Pārdot tūlīt',
    'ShopNow': 'Iepirkties tūlīt',
    'Showtimes': 'Seansi',
    'SignIn': 'Pierakstīties',
    'SignUp': 'Reģistrēties',
    'StartNow': 'Sākt tūlīt',
    'Subscribe': 'Abonēt',
    'SwitchNow': 'Pārslēgt tūlīt',
    'TestDrive': 'Izmēģinājuma brauciens',
    'TryNow': 'Izmēģināt tūlīt',
    'ViewCars': 'Skatīt automašīnas',
    'ViewPlans': 'Skatīt plānus',
    'VisitStore': 'Apmeklēt veikalu',
    'VoteNow': 'Balsot tūlīt',
    'Watch': 'Skatīties',
    'WatchMore': 'Skatīties vēl',
    'WatchNow': 'Skatīties tūlīt',
  },
  'Lithuanian': {
    'CustomText': 'Pasirinktinis tekstas',
    'ActNow': 'Veikti dabar',
    'ApplyNow': 'Teikti paraišką dabar',
    'BetNow': 'Lažintis dabar',
    'BidNow': 'Siūlyti kainą dabar',
    'BookACar': 'Užsisakyti automobilį',
    'BookHotel': 'Užsisakyti viešbutį',
    'BookNow': 'Užsakyti dabar',
    'BuyNow': 'Įsigyti dabar',
    'ChatNow': 'Kalbėtis dabar',
    'Compare': 'Palyginti',
    'ContactUs': 'Kontaktinė informacija',
    'Coupon': 'Gauti kuponą',
    'Directions': 'Kryptys',
    'Donate': 'Aukoti',
    'Download': 'Atsisiųsti',
    'EmailNow': 'Siųsti el. paštu dabar',
    'EnrollNow': 'Registruotis dabar',
    'FileNow': 'Užpildyti dabar',
    'FindJob': 'Rasti darbą',
    'FindStore': 'Rasti parduotuvę',
    'FreePlay': 'Nemokamas žaidimas',
    'FreeQuote': 'Nemokamas pasiūlymas',
    'FreeTrial': 'Nemokama bandomoji versija',
    'GetDeals': 'Puikūs pasiūlymai',
    'GetOffer': 'Gauti pasiūlymą',
    'GetQuote': 'Gauti kainą',
    'JoinNow': 'Prisijungti dabar',
    'LearnMore': 'Sužinokite daugiau',
    'ListenNow': 'Klausytis dabar',
    'LogIn': 'Prisijungimas',
    'OrderNow': 'Užsisakyti dabar',
    'PlayGame': 'Žaisti žaidimą',
    'PlayNow': 'Leisti dabar',
    'PostJob': 'Pašto darbas',
    'Register': 'Registruotis',
    'RenewNow': 'Atnaujinti dabar',
    'RentACar': 'Išsinuomoti automibilį',
    'RentNow': 'Išsinuomoti dabar',
    'Reorder': 'Pertvarkyti',
    'Reserve': 'Rezervuoti',
    'Sale': 'Peržiūrėti išpardavimą',
    'SaveNow': 'Įrašyti dabar',
    'Schedule': 'Tvarkaraštis',
    'SeeMenu': 'Rodyti meniu',
    'SeeOffer': 'Rodyti pasiūlymą',
    'SellNow': 'Parduoti dabar',
    'ShopNow': 'Apsipirkti dabar',
    'Showtimes': 'Rodymo laikas',
    'SignIn': 'Prisijungti',
    'SignUp': 'Prisiregistruoti',
    'StartNow': 'Pradėti dabar',
    'Subscribe': 'Prenumeruoti',
    'SwitchNow': 'Perjungti dabar',
    'TestDrive': 'Bandomoji versija',
    'TryNow': 'Išbandyti dabar',
    'ViewCars': 'Peržiūrėti automobilius',
    'ViewPlans': 'Peržiūrėti planus',
    'VisitStore': 'Apsilankyti parduotuvėje',
    'VoteNow': 'Balsuoti dabar',
    'Watch': 'Žiūrėti',
    'WatchMore': 'Žiūrėti daugiau',
    'WatchNow': 'Žiūrėti dabar',
  },
  'Maltese': {
    'CustomText': 'Test Personalizzat',
    'ActNow': 'Ħu Azzjoni Issa',
    'ApplyNow': 'Applika Issa',
    'BetNow': 'Agħmel Imħatra Issa',
    'BidNow': 'Agħmel Offerta Issa',
    'BookACar': 'Ibbukkja Karozza',
    'BookHotel': 'Ibbukkja Lukanda',
    'BookNow': 'Ibbukkja Issa',
    'BuyNow': 'Ixtri Issa',
    'ChatNow': 'Iċċettja Issa',
    'Compare': 'Qabbel',
    'ContactUs': 'Ikkuntattjana',
    'Coupon': 'Ikseb Kupun',
    'Directions': 'Direzzjonijiet',
    'Donate': 'Agħti donazzjoni',
    'Download': 'Niżżel',
    'EmailNow': 'Ibgħat Email Issa',
    'EnrollNow': 'Inkiteb Issa',
    'FileNow': 'Iffajlja Issa',
    'FindJob': 'Sib Impjieg',
    'FindStore': 'Sib Ħanut',
    'FreePlay': 'Logħob b\'Xejn',
    'FreeQuote': 'Kwotazzjoni b\'Xejn',
    'FreeTrial': 'Prova b\'Xejn',
    'GetDeals': 'Ikseb Prezzijiet Vantaġġjużi',
    'GetOffer': 'Ikseb Offerta',
    'GetQuote': 'Ikseb Kwota',
    'JoinNow': 'Issieħeb issa',
    'LearnMore': 'Sir af aktar',
    'ListenNow': 'Isma\' Issa',
    'LogIn': 'Illoggja',
    'OrderNow': 'Ordna Issa',
    'PlayGame': 'Ilgħab il-Logħba',
    'PlayNow': 'Doqq issa',
    'PostJob': 'Ippowstja l-Impjieg',
    'Register': 'Irreġistra',
    'RenewNow': 'Ġedded Issa',
    'RentACar': 'Ikri Karozza',
    'RentNow': 'Ikri Issa',
    'Reorder': 'Erġa\' poġġi fl-ordni',
    'Reserve': 'Irriżerva',
    'Sale': 'Ara l-Iskont',
    'SaveNow': 'Issejvja Issa',
    'Schedule': 'Skeda',
    'SeeMenu': 'Ara l-Menu',
    'SeeOffer': 'Ara l-Offerta',
    'SellNow': 'Biegħ Issa',
    'ShopNow': 'Agħmel ix-Xirja Issa',
    'Showtimes': 'Ħinijiet ta\' wiri',
    'SignIn': 'Idħol',
    'SignUp': 'Oħloq akkawnt',
    'StartNow': 'Ibda Issa',
    'Subscribe': 'Abbona',
    'SwitchNow': 'Aqleb Issa',
    'TestDrive': 'Test tas-Sewqan',
    'TryNow': 'Ipprova Issa',
    'ViewCars': 'Ara l-Karozzi',
    'ViewPlans': 'Ara l-Pjanijiet',
    'VisitStore': 'Żur il-Ħanut',
    'VoteNow': 'Ivvota Issa',
    'Watch': 'Ara',
    'WatchMore': 'Ara Aktar',
    'WatchNow': 'Ara Issa',
  },
  'Romanian': {
    'CustomText': 'Text personalizat',
    'ActNow': 'Acționați acum',
    'ApplyNow': 'Aplicați acum',
    'BetNow': 'Pariați acum',
    'BidNow': 'Licitați acum',
    'BookACar': 'Rezervați o mașină',
    'BookHotel': 'Rezervați o cameră de hotel',
    'BookNow': 'Rezervați acum',
    'BuyNow': 'Achiziționați acum',
    'ChatNow': 'Discutați acum',
    'Compare': 'Comparați',
    'ContactUs': 'Contactați-ne',
    'Coupon': 'Obțineți un cupon',
    'Directions': 'Indicații',
    'Donate': 'Donați',
    'Download': 'Descărcați',
    'EmailNow': 'Trimiteți un e-mail acum',
    'EnrollNow': 'Înscrieți-vă acum',
    'FileNow': 'Arhivați acum',
    'FindJob': 'Găsiți un loc de muncă',
    'FindStore': 'Găsiți magazinul',
    'FreePlay': 'Redați gratis',
    'FreeQuote': 'Cotație gratis',
    'FreeTrial': 'Încercare gratuită',
    'GetDeals': 'Obțineți oferte',
    'GetOffer': 'Obțineți o ofertă',
    'GetQuote': 'Obțineți cotația',
    'JoinNow': 'Alăturați-vă acum',
    'LearnMore': 'Aflați mai multe',
    'ListenNow': 'Ascultați acum',
    'LogIn': 'Logați-vă',
    'OrderNow': 'Comandați acum',
    'PlayGame': 'Jucați jocuri',
    'PlayNow': 'Redați acum',
    'PostJob': 'Postați un loc de muncă',
    'Register': 'Înregistrați',
    'RenewNow': 'Prelungiți acum',
    'RentACar': 'Închiriați o mașină',
    'RentNow': 'Închiriați acum',
    'Reorder': 'Reordonați',
    'Reserve': 'Rezervați',
    'Sale': 'Vedeți reducerile',
    'SaveNow': 'Salvați acum',
    'Schedule': 'Program',
    'SeeMenu': 'Vedeți meniul',
    'SeeOffer': 'Vedeți oferta',
    'SellNow': 'Vindeți acum',
    'ShopNow': 'Cumpărați acum',
    'Showtimes': 'Programul emisiunilor',
    'SignIn': 'Conectați-vă',
    'SignUp': 'Înregistrați-vă',
    'StartNow': 'Începeți acum',
    'Subscribe': 'Abonați-vă',
    'SwitchNow': 'Comutați acum',
    'TestDrive': 'Test Drive',
    'TryNow': 'Încercați acum',
    'ViewCars': 'Vizualizați mașini',
    'ViewPlans': 'Vizualizați planuri',
    'VisitStore': 'Vizitați magazinul',
    'VoteNow': 'Votați acum',
    'Watch': 'Vizionați',
    'WatchMore': 'Urmăriți mai multe',
    'WatchNow': 'Urmăriți acum',
  },
  'Slovak': {
    'CustomText': 'Vlastný text',
    'ActNow': 'Konať',
    'ApplyNow': 'Požiadať',
    'BetNow': 'Staviť',
    'BidNow': 'Ponúknuť',
    'BookACar': 'Rezervovať auto',
    'BookHotel': 'Rezervovať hotel',
    'BookNow': 'Rezervovať',
    'BuyNow': 'Kúpiť',
    'ChatNow': 'Chatovať',
    'Compare': 'Porovnať',
    'ContactUs': 'Kontaktujte nás',
    'Coupon': 'Získať kupón',
    'Directions': 'Navigačné pokyny',
    'Donate': 'Darovať',
    'Download': 'Stiahnuť',
    'EmailNow': 'Napísať e-mail',
    'EnrollNow': 'Zapísať sa',
    'FileNow': 'Podať',
    'FindJob': 'Nájsť prácu',
    'FindStore': 'Nájsť obchod',
    'FreePlay': 'Hrať zdarma',
    'FreeQuote': 'Bezplatná cenová ponuka',
    'FreeTrial': 'Skúšobná verzia zdarma',
    'GetDeals': 'Získať ponuky',
    'GetOffer': 'Získať ponuku',
    'GetQuote': 'Získať cenovú ponuku',
    'JoinNow': 'Zapojiť sa',
    'LearnMore': 'Ďalšie informácie',
    'ListenNow': 'Počúvať',
    'LogIn': 'Prihlásiť sa',
    'OrderNow': 'Objednať',
    'PlayGame': 'Hrať',
    'PlayNow': 'Prehrať',
    'PostJob': 'Zverejniť pracovné miesto',
    'Register': 'Registrovať',
    'RenewNow': 'Obnoviť',
    'RentACar': 'Požičať si auto',
    'RentNow': 'Požičať si',
    'Reorder': 'Znova objednať',
    'Reserve': 'Predobjednať',
    'Sale': 'Zobraziť zľavu',
    'SaveNow': 'Uložiť',
    'Schedule': 'Naplánovať',
    'SeeMenu': 'Zobraziť ponuku',
    'SeeOffer': 'Zobraziť akciu',
    'SellNow': 'Predať',
    'ShopNow': 'Nakupovať',
    'Showtimes': 'Programy',
    'SignIn': 'Prihlásenie',
    'SignUp': 'Zaregistrovať sa',
    'StartNow': 'Spustiť',
    'Subscribe': 'Prihlásiť sa na odber',
    'SwitchNow': 'Prepnúť',
    'TestDrive': 'Testovacia jazda',
    'TryNow': 'Vyskúšať',
    'ViewCars': 'Zobraziť autá',
    'ViewPlans': 'Zobraziť plány',
    'VisitStore': 'Navštíviť obchod',
    'VoteNow': 'Hlasovať',
    'Watch': 'Pozerať',
    'WatchMore': 'Pozerať ďalšie',
    'WatchNow': 'Pozerať teraz',
  },
  'Slovenian': {
    'CustomText': 'Besedilo po meri',
    'ActNow': 'Ukrepajte zdaj',
    'ApplyNow': 'Prijavite se zdaj',
    'BetNow': 'Stavite zdaj',
    'BidNow': 'Dajte ponudbo zdaj',
    'BookACar': 'Rezervacija avtomobila',
    'BookHotel': 'Rezervacija hotela',
    'BookNow': 'Rezervirajte zdaj',
    'BuyNow': 'Kupite zdaj',
    'ChatNow': 'Klepet',
    'Compare': 'Primerjaj',
    'ContactUs': 'Stik z nami',
    'Coupon': 'Pridobi kupon',
    'Directions': 'Navodila',
    'Donate': 'Doniraj',
    'Download': 'Prenos',
    'EmailNow': 'Pošljite po e-pošti',
    'EnrollNow': 'Vpišite se zdaj',
    'FileNow': 'Pošljite vlogo zdaj',
    'FindJob': 'Iskanje zaposlitve',
    'FindStore': 'Iskanje trgovine',
    'FreePlay': 'Brezplačno predvajanje',
    'FreeQuote': 'Brezplačna ponudba',
    'FreeTrial': 'Brezplačen preskus',
    'GetDeals': 'Pridobi ugodnosti',
    'GetOffer': 'Pridobi ponudbo',
    'GetQuote': 'Prejem ponudbe',
    'JoinNow': 'Vključite se zdaj',
    'LearnMore': 'Več o tem',
    'ListenNow': 'Poslušaj zdaj',
    'LogIn': 'Prijava',
    'OrderNow': 'Naročite zdaj',
    'PlayGame': 'Igranje igre',
    'PlayNow': 'Predvajaj zdaj',
    'PostJob': 'Objava delovnega mesta',
    'Register': 'Registracija',
    'RenewNow': 'Obnovite zdaj',
    'RentACar': 'Najem avtomobila',
    'RentNow': 'Najemite zdaj',
    'Reorder': 'Ponovno naročilo',
    'Reserve': 'Rezerviraj',
    'Sale': 'Prikaz popustov',
    'SaveNow': 'Prihranite zdaj',
    'Schedule': 'Razpored',
    'SeeMenu': 'Prikaži meni',
    'SeeOffer': 'Ogled ponudbe',
    'SellNow': 'Prodajte takoj',
    'ShopNow': 'Nakupovanje',
    'Showtimes': 'Časi predvajanja',
    'SignIn': 'Vpis',
    'SignUp': 'Ustvarjanje računa',
    'StartNow': 'Začni zdaj',
    'Subscribe': 'Naroči',
    'SwitchNow': 'Preklopi zdaj',
    'TestDrive': 'Testna vožnja',
    'TryNow': 'Preizkusite zdaj',
    'ViewCars': 'Prikaz avtomobilov',
    'ViewPlans': 'Prikaz paketov',
    'VisitStore': 'Obisk trgovine',
    'VoteNow': 'Glasujte zdaj',
    'Watch': 'Ogled',
    'WatchMore': 'Oglejte si še več',
    'WatchNow': 'Oglejte si zdaj',
  },
  'Albanian': {
    'CustomText': 'Tekst i personalizuar',
    'ActNow': 'Vepro tani',
    'ApplyNow': 'Apliko tani',
    'BetNow': 'Vendos bastin tani',
    'BidNow': 'Oferto tani',
    'BookACar': 'Rezervo një makinë',
    'BookHotel': 'Rezervo hotelin',
    'BookNow': 'Rezervo tani',
    'BuyNow': 'Bli tani',
    'ChatNow': 'Bisedo tani',
    'Compare': 'Krahaso',
    'ContactUs': 'Na kontakto',
    'Coupon': 'Merr kuponin',
    'Directions': 'Udhëzimet',
    'Donate': 'Dhuro',
    'Download': 'Shkarko',
    'EmailNow': 'Dërgo email tani',
    'EnrollNow': 'Regjistrohu tani',
    'FileNow': 'Raporto tani',
    'FindJob': 'Gjej punë',
    'FindStore': 'Gjej dyqanin',
    'FreePlay': 'Lojë falas',
    'FreeQuote': 'Kuotë falas',
    'FreeTrial': 'Provë falas',
    'GetDeals': 'Merr oferta',
    'GetOffer': 'Përfito ofertën',
    'GetQuote': 'Merr kuotë',
    'JoinNow': 'Bashkohu tani',
    'LearnMore': 'Mëso më shumë',
    'ListenNow': 'Dëgjo tani',
    'LogIn': 'Hyr',
    'OrderNow': 'Porosit tani',
    'PlayGame': 'Luaj lojën',
    'PlayNow': 'Luaj tani',
    'PostJob': 'Posto punën',
    'Register': 'Regjistro',
    'RenewNow': 'Rinovo tani',
    'RentACar': 'Merr një makinë me qira',
    'RentNow': 'Merr me qira tani',
    'Reorder': 'Rirendit',
    'Reserve': 'Rezervo',
    'Sale': 'Shiko uljen',
    'SaveNow': 'Kurse tani',
    'Schedule': 'Planifiko',
    'SeeMenu': 'Shiko menynë',
    'SeeOffer': 'Shiko ofertën',
    'SellNow': 'Shit tani',
    'ShopNow': 'Bëj blerje tani',
    'Showtimes': 'Oraret e shfaqjes',
    'SignIn': 'Hyr te',
    'SignUp': 'Regjistrohu',
    'StartNow': 'Fillo tani',
    'Subscribe': 'Abonohu',
    'SwitchNow': 'Ndrysho tani',
    'TestDrive': 'Drejtim provë',
    'TryNow': 'Provo tani',
    'ViewCars': 'Shiko makinat',
    'ViewPlans': 'Shiko planet',
    'VisitStore': 'Vizito dyqanin',
    'VoteNow': 'Voto tani',
    'Watch': 'Shiko',
    'WatchMore': 'Shiko më shumë',
    'WatchNow': 'Shiko tani',
  },
  'Bosnian': {
    'CustomText': 'Prilagođeni tekst',
    'ActNow': 'Reagiraj sada',
    'ApplyNow': 'Prijavi se sada',
    'BetNow': 'Pošalji ponudu sada',
    'BidNow': 'Licitiraj sada',
    'BookACar': 'Rezerviraj automobil',
    'BookHotel': 'Rezerviraj hotel',
    'BookNow': 'Rezerviraj sada',
    'BuyNow': 'Kupi odmah',
    'ChatNow': 'Razgovaraj sada',
    'Compare': 'Uporedi',
    'ContactUs': 'Kontaktirajte nas',
    'Coupon': 'Preuzmi kupon',
    'Directions': 'Upute za kretanje',
    'Donate': 'Doniraj',
    'Download': 'Preuzmi',
    'EmailNow': 'Pošalji e-poruku sada',
    'EnrollNow': 'Upiši se sada',
    'FileNow': 'Podnesi sada',
    'FindJob': 'Pronađi posao',
    'FindStore': 'Pronađi prodavnicu',
    'FreePlay': 'Besplatna reprodukcija',
    'FreeQuote': 'Besplatno kotiranje na berzi',
    'FreeTrial': 'Besplatna probna verzija',
    'GetDeals': 'Preuzmi pogodbe',
    'GetOffer': 'Preuzmi ponudu',
    'GetQuote': 'Preuzmi kotiranje na berzi',
    'JoinNow': 'Pridruži se sada',
    'LearnMore': 'Saznajte više',
    'ListenNow': 'Slušaj sada',
    'LogIn': 'Prijavljivanje',
    'OrderNow': 'Naruči sada',
    'PlayGame': 'Igrajte igru',
    'PlayNow': 'Reproduciraj sada',
    'PostJob': 'Objavi posao',
    'Register': 'Registriraj',
    'RenewNow': 'Obnovi sada',
    'RentACar': 'Iznajmljivanje automobila',
    'RentNow': 'Iznajmi sada',
    'Reorder': 'Promijeni redoslijed',
    'Reserve': 'Rezerviraj',
    'Sale': 'Prikaži rasprodaju',
    'SaveNow': 'Sačuvaj sada',
    'Schedule': 'Raspored',
    'SeeMenu': 'Prikaži meni',
    'SeeOffer': 'Prikaži ponudu',
    'SellNow': 'Prodaj sada',
    'ShopNow': 'Kupi sada',
    'Showtimes': 'Vremena prikazivanja',
    'SignIn': 'Prijava',
    'SignUp': 'Izradite račun',
    'StartNow': 'Počinje sada',
    'Subscribe': 'Pretplati se',
    'SwitchNow': 'Pređi sada',
    'TestDrive': 'Probna vožnja',
    'TryNow': 'Probaj sada',
    'ViewCars': 'Prikaz vozila',
    'ViewPlans': 'Prikaz planova',
    'VisitStore': 'Posjeti prodavnicu',
    'VoteNow': 'Glasaj sada',
    'Watch': 'Gledaj',
    'WatchMore': 'Gledaj više',
    'WatchNow': 'Gledaj sada',
  },
  'Icelandic': {
    'CustomText': 'Sérsniðinn texti',
    'ActNow': 'Framkvæma núna',
    'ApplyNow': 'Sækja um núna',
    'BetNow': 'Veðja núna',
    'BidNow': 'Gera tilboð núna',
    'BookACar': 'Bóka bíl',
    'BookHotel': 'Bóka hótel',
    'BookNow': 'Bóka núna',
    'BuyNow': 'Kaupa núna',
    'ChatNow': 'Spjalla núna',
    'Compare': 'Bera saman',
    'ContactUs': 'Hafa samband',
    'Coupon': 'Fá afsláttarmiða',
    'Directions': 'Leiðsögn',
    'Donate': 'Gefa',
    'Download': 'Sækja',
    'EmailNow': 'Senda tölvupóst núna',
    'EnrollNow': 'Skrá sig núna',
    'FileNow': 'Skjalvista núna',
    'FindJob': 'Finna starf',
    'FindStore': 'Finna verslun',
    'FreePlay': 'Ókeypis spilun',
    'FreeQuote': 'Tilboð að kostnaðarlausu',
    'FreeTrial': 'Ókeypis reynslutími',
    'GetDeals': 'Fá sértilboð',
    'GetOffer': 'Fá tilboð',
    'GetQuote': 'Fá verðtilboð',
    'JoinNow': 'Skáðu þig núna',
    'LearnMore': 'Frekari upplýsingar',
    'ListenNow': 'Hlusta núna',
    'LogIn': 'Skrá inn',
    'OrderNow': 'Panta núna',
    'PlayGame': 'Spila leik',
    'PlayNow': 'Spila núna',
    'PostJob': 'Bóka starf',
    'Register': 'Skrá',
    'RenewNow': 'Endurnýja núna',
    'RentACar': 'Leigja bíl',
    'RentNow': 'Leigja núna',
    'Reorder': 'Endurraða',
    'Reserve': 'Panta',
    'Sale': 'Skoða útsölu',
    'SaveNow': 'Vista núna',
    'Schedule': 'Dagskrá',
    'SeeMenu': 'Sjá matseðil',
    'SeeOffer': 'Sjá tilboð',
    'SellNow': 'Selja núna',
    'ShopNow': 'Versla núna',
    'Showtimes': 'Sýningartímar',
    'SignIn': 'Innskráning',
    'SignUp': 'Skráning',
    'StartNow': 'Ræsa núna',
    'Subscribe': 'Gerast áskrifandi',
    'SwitchNow': 'Skipta núna',
    'TestDrive': 'Reynsluakstur',
    'TryNow': 'Prófa núna',
    'ViewCars': 'Skoða bíla',
    'ViewPlans': 'Skoða áætlanir',
    'VisitStore': 'Fara í verslun',
    'VoteNow': 'Kjósa núna',
    'Watch': 'Horfa',
    'WatchMore': 'Horfa á fleira',
    'WatchNow': 'Horfa núna',
  },
  'Macedonian': {
    'CustomText': 'Прилагодена текстуална порака',
    'ActNow': 'Дејствувај сега',
    'ApplyNow': 'Аплицирај сега',
    'BetNow': 'Обложи се сега',
    'BidNow': 'Лицитирај сега',
    'BookACar': 'Резервирај автомобил',
    'BookHotel': 'Резервирај хотел',
    'BookNow': 'Резервирај сега',
    'BuyNow': 'Купи сега',
    'ChatNow': 'Разговарај сега',
    'Compare': 'Спореди',
    'ContactUs': 'Контактирај со нас',
    'Coupon': 'Добиј купон',
    'Directions': 'Насоки',
    'Donate': 'Донирај',
    'Download': 'Преземи',
    'EmailNow': 'Испрати е-пошта сега',
    'EnrollNow': 'Пријави сега',
    'FileNow': 'Поднеси сега',
    'FindJob': 'Најди работа',
    'FindStore': 'Најди продавница',
    'FreePlay': 'Бесплатно играње',
    'FreeQuote': 'Бесплатно давање цена',
    'FreeTrial': 'Бесплатна проба',
    'GetDeals': 'Добиј зделки',
    'GetOffer': 'Добиј понуда',
    'GetQuote': 'Добиј цена',
    'JoinNow': 'Придружи се сега',
    'LearnMore': 'Дознајте повеќе',
    'ListenNow': 'Слушај сега',
    'LogIn': 'Евидентирај',
    'OrderNow': 'Нарачај сега',
    'PlayGame': 'Играј игра',
    'PlayNow': 'Пушти сега',
    'PostJob': 'Објави работно место',
    'Register': 'Регистрирај се',
    'RenewNow': 'Обнови сега',
    'RentACar': 'Изнајми автомобил',
    'RentNow': 'Изнајми сега',
    'Reorder': 'Преуреди',
    'Reserve': 'Резерва',
    'Sale': 'Види распродажба',
    'SaveNow': 'Зачувај сега',
    'Schedule': 'Распоред',
    'SeeMenu': 'Види мени',
    'SeeOffer': 'Види понуда',
    'SellNow': 'Продај сега',
    'ShopNow': 'Пазарувај сега',
    'Showtimes': 'Времиња на прикажување',
    'SignIn': 'Пријави се',
    'SignUp': 'Започни сега',
    'StartNow': 'Започни сега',
    'Subscribe': 'Претплати се',
    'SwitchNow': 'Префрли сега',
    'TestDrive': 'Тест возење',
    'TryNow': 'Обиди се сега',
    'ViewCars': 'Види автомобили',
    'ViewPlans': 'Види пакети',
    'VisitStore': 'Посети продавница',
    'VoteNow': 'Гласај сега',
    'Watch': 'Гледај',
    'WatchMore': 'Гледај повеќе',
    'WatchNow': 'Гледај сега',
  },
  'Serbian': {
    'CustomText': 'Прилагођени текст',
    'ActNow': 'Reaguj odmah',
    'ApplyNow': 'Prijavi se odmah',
    'BetNow': 'Kladi se odmah',
    'BidNow': 'Ponudi odmah',
    'BookACar': 'Rezerviši automobil',
    'BookHotel': 'Rezerviši hotel',
    'BookNow': 'Rezerviši odmah',
    'BuyNow': 'Kupi odmah',
    'ChatNow': 'Ćaskaj odmah',
    'Compare': 'Uporedi',
    'ContactUs': 'Kontaktirajte nas',
    'Coupon': 'Preuzmi kupon',
    'Directions': 'Putokazi',
    'Donate': 'Doniraj',
    'Download': 'Preuzmi',
    'EmailNow': 'Pošalji e-poruku odmah',
    'EnrollNow': 'Upiši se odmah',
    'FileNow': 'Podnesi odmah',
    'FindJob': 'Pronađi posao',
    'FindStore': 'Pronađi prodavnicu',
    'FreePlay': 'Besplatna igra',
    'FreeQuote': 'Besplatna ponuda',
    'FreeTrial': 'Besplatna probna verzija',
    'GetDeals': 'Nabavi ponude',
    'GetOffer': 'Preuzmi ponudu',
    'GetQuote': 'Preuzmi kotiranje na berzi',
    'JoinNow': 'Pridruži se odmah',
    'LearnMore': 'Saznajte više',
    'ListenNow': 'Slušaj odmah',
    'LogIn': 'Prijavi se',
    'OrderNow': 'Poruči odmah',
    'PlayGame': 'Igraj igru',
    'PlayNow': 'Reprodukuj odmah',
    'PostJob': 'Objavi posao',
    'Register': 'Registruj',
    'RenewNow': 'Obnovi odmah',
    'RentACar': 'Iznajmi automobil',
    'RentNow': 'Iznajmi odmah',
    'Reorder': 'Promeni redosled',
    'Reserve': 'Rezerviši',
    'Sale': 'Prikaži prodaju',
    'SaveNow': 'Sačuvaj odmah',
    'Schedule': 'Raspored',
    'SeeMenu': 'Prikaži meni',
    'SeeOffer': 'Prikaži ponudu',
    'SellNow': 'Prodaj odmah',
    'ShopNow': 'Kupujte odmah',
    'Showtimes': 'Termini prikazivanja',
    'SignIn': 'Prijavljivanje',
    'SignUp': 'Upiši se',
    'StartNow': 'Počni odmah',
    'Subscribe': 'Pretplati se',
    'SwitchNow': 'Zameni odmah',
    'TestDrive': 'Testiraj disk jedinicu',
    'TryNow': 'Isprobaj odmah',
    'ViewCars': 'Prikaži automobile',
    'ViewPlans': 'Prikaži planove',
    'VisitStore': 'Poseti prodavnicu',
    'VoteNow': 'Glasaj odmah',
    'Watch': 'Gledaj',
    'WatchMore': 'Gledaj više',
    'WatchNow': 'Gledaj odmah',
  },
  'Japanese': {
    'CustomText': 'カスタム テキスト',
    'ActNow': '今すぐ実行',
    'ApplyNow': '今すぐ適用する',
    'BetNow': '今すぐ賭ける',
    'BidNow': '今すぐ入札する',
    'BookACar': '自動車の予約',
    'BookHotel': 'ホテルを予約',
    'BookNow': '今すぐ予約',
    'BuyNow': '今すぐ購入',
    'ChatNow': '今すぐチャット',
    'Compare': '比較',
    'ContactUs': 'お問い合わせ',
    'Coupon': 'クーポンを取得',
    'Directions': '指揮',
    'Donate': '寄付する',
    'Download': 'ダウンロード',
    'EmailNow': '今すぐメールを送信',
    'EnrollNow': '今すぐ登録',
    'FileNow': '今すぐ綴じ込む',
    'FindJob': '仕事の検索',
    'FindStore': 'ストアの検索',
    'FreePlay': '無料プレイ',
    'FreeQuote': '無料見積もり',
    'FreeTrial': '無料試用版',
    'GetDeals': '契約の獲得',
    'GetOffer': 'オファーの獲得',
    'GetQuote': '見積の取得',
    'JoinNow': '今すぐ参加',
    'LearnMore': '詳細情報',
    'ListenNow': '今すぐ聴く',
    'LogIn': 'ログイン',
    'OrderNow': '今すぐ注文',
    'PlayGame': 'ゲームをプレイする',
    'PlayNow': '今すぐプレイ',
    'PostJob': '仕事の投稿',
    'Register': '登録',
    'RenewNow': '今すぐ更新',
    'RentACar': 'レンタカーを借りる',
    'RentNow': '今すぐレンタル',
    'Reorder': '再投入',
    'Reserve': '予約',
    'Sale': 'セールを見る',
    'SaveNow': '今すぐ保存',
    'Schedule': 'スケジュール',
    'SeeMenu': 'メニューを表示',
    'SeeOffer': 'オファーを参照',
    'SellNow': '今すぐ販売',
    'ShopNow': '今すぐ買い物をする',
    'Showtimes': '上映開始時刻',
    'SignIn': 'サインイン',
    'SignUp': 'サインアップ',
    'StartNow': '今すぐはじめる',
    'Subscribe': '購読する',
    'SwitchNow': '今すぐ切り替える',
    'TestDrive': '体験版',
    'TryNow': '今すぐ試す',
    'ViewCars': '車を表示',
    'ViewPlans': 'プランを表示',
    'VisitStore': 'ストアにアクセス',
    'VoteNow': '今すぐ投票',
    'Watch': '視聴',
    'WatchMore': '詳細を見る',
    'WatchNow': 'すぐに観る',
  },
  'Russian': {
    'CustomText': 'Пользовательский текст',
    'ActNow': 'Вперед',
    'ApplyNow': 'Применить сейчас',
    'BetNow': 'Ставить сейчас',
    'BidNow': 'Заявка сейчас',
    'BookACar': 'Забронировать автомобиль',
    'BookHotel': 'Забронировать отель',
    'BookNow': 'Забронировать',
    'BuyNow': 'Купить сейчас',
    'ChatNow': 'Начать чат',
    'Compare': 'Сравнить',
    'ContactUs': 'Связаться с нами',
    'Coupon': 'Получить купон',
    'Directions': 'Маршруты',
    'Donate': 'Пожертвовать',
    'Download': 'Скачать',
    'EmailNow': 'Написать сейчас',
    'EnrollNow': 'Зарегистрироваться сейчас',
    'FileNow': 'Подать сейчас',
    'FindJob': 'Найти задание',
    'FindStore': 'Найти Магазин',
    'FreePlay': 'Играть бесплатно',
    'FreeQuote': 'Бесплатная цитата',
    'FreeTrial': 'Бесплатная пробная версия',
    'GetDeals': 'Получить предложения',
    'GetOffer': 'Получить предложение',
    'GetQuote': 'Узнать цену',
    'JoinNow': 'Присоединиться сейчас',
    'LearnMore': 'Подробнее',
    'ListenNow': 'Слушать сейчас',
    'LogIn': 'Авторизоваться',
    'OrderNow': 'Заказать сейчас',
    'PlayGame': 'Начать игру',
    'PlayNow': 'Играть сейчас',
    'PostJob': 'Опубликовать задание',
    'Register': 'Зарегистрироваться',
    'RenewNow': 'Возобновить сейчас',
    'RentACar': 'Арендовать автомобиль',
    'RentNow': 'Арендовать сейчас',
    'Reorder': 'Изменить порядок',
    'Reserve': 'Резервировать',
    'Sale': 'Просмотреть распродажу',
    'SaveNow': 'Сохранить сейчас',
    'Schedule': 'График',
    'SeeMenu': 'Просмотреть меню',
    'SeeOffer': 'Показать предложение',
    'SellNow': 'Продать сейчас',
    'ShopNow': 'Получи это сейчас',
    'Showtimes': 'Расписание сеансов',
    'SignIn': 'Войти',
    'SignUp': 'Подписаться',
    'StartNow': 'Приступить сейчас',
    'Subscribe': 'Подписаться',
    'SwitchNow': 'Переключить сейчас',
    'TestDrive': 'Тестовый выпуск',
    'TryNow': 'Попробовать сейчас',
    'ViewCars': 'Просмотреть автомобили',
    'ViewPlans': 'Просмотреть планы',
    'VisitStore': 'Посетить магазин',
    'VoteNow': 'Проголосовать сейчас',
    'Watch': 'Посмотреть',
    'WatchMore': 'Просмотреть еще',
    'WatchNow': 'Смотреть сейчас',
  },
  'Arabic': {
    'CustomText': 'نص مخصص',
    'ActNow': 'التصرف الآن',
    'ApplyNow': 'الطّلب الآن',
    'BetNow': 'المراهنة الآن',
    'BidNow': 'المزايدة الآن',
    'BookACar': 'حجز سيارة',
    'BookHotel': 'حجز فندق',
    'BookNow': 'الحجز الآن',
    'BuyNow': 'شراء الآن',
    'ChatNow': 'الدردشة الآن',
    'Compare': 'مقارنة',
    'ContactUs': 'اتصل بنا',
    'Coupon': 'الحصول على القسيمة',
    'Directions': 'الاتجاهات',
    'Donate': 'تبرع',
    'Download': 'تنزيل',
    'EmailNow': 'إرسال بريد إلكتروني الآن',
    'EnrollNow': 'التسجيل الآن',
    'FileNow': 'الإيداع الآن',
    'FindJob': 'البحث عن عمل',
    'FindStore': 'البحث عن المتجر',
    'FreePlay': 'اللّعب المجاني',
    'FreeQuote': 'اقتباس مجاني',
    'FreeTrial': 'إصدار تجريبي مجاني',
    'GetDeals': 'الحصول على الصفقات',
    'GetOffer': 'الحصول على العرض',
    'GetQuote': 'الحصول على عرض أسعار',
    'JoinNow': 'الانضمام الآن',
    'LearnMore': 'معرفة المزيد',
    'ListenNow': 'الاستماع الآن',
    'LogIn': 'تسجيل دخول',
    'OrderNow': 'الطلب الآن',
    'PlayGame': 'ألعب اللعبة',
    'PlayNow': 'اللعب الآن',
    'PostJob': 'نشر عمل',
    'Register': 'تسجيل',
    'RenewNow': 'التجديد الآن',
    'RentACar': 'تأجير سيارة',
    'RentNow': 'الإيجار الآن',
    'Reorder': 'إعادة طلب',
    'Reserve': 'حجز',
    'Sale': 'الاطلاع على عملية البيع',
    'SaveNow': 'حفظ الآن',
    'Schedule': 'الجدول',
    'SeeMenu': 'راجع القائمة',
    'SeeOffer': 'الاطلاع على العرض',
    'SellNow': 'البيع الآن',
    'ShopNow': 'تسوق الآن',
    'Showtimes': 'العروض',
    'SignIn': 'تسجيل الدخول',
    'SignUp': 'اشتراك',
    'StartNow': 'بدء الآن',
    'Subscribe': 'اشتراك',
    'SwitchNow': 'التبديل الآن',
    'TestDrive': 'اختبار القيادة',
    'TryNow': 'جربه الآن',
    'ViewCars': 'عرض السيارات',
    'ViewPlans': 'عرض الخطط',
    'VisitStore': 'زيارة المتجر',
    'VoteNow': 'التصويت الآن',
    'Watch': 'مشاهدة',
    'WatchMore': 'مشاهدة المزيد',
    'WatchNow': 'مشاهدة الآن',
  },
  'Hebrew': {
    'CustomText': 'טקסט מותאם אישית',
    'ActNow': 'פעל עכשיו',
    'ApplyNow': 'הגש בקשה עכשיו',
    'BetNow': 'המר עכשיו',
    'BidNow': 'שלח הצעת מחיר עכשיו',
    'BookACar': 'הזמן מכונית',
    'BookHotel': 'הזמן מלון',
    'BookNow': 'להזמין עכשיו',
    'BuyNow': 'קנה עכשיו',
    'ChatNow': 'שוחח בצ\'אט עכשיו',
    'Compare': 'השווה',
    'ContactUs': 'צור קשר',
    'Coupon': 'קבל שובר',
    'Directions': 'הוראות הגעה',
    'Donate': 'תרום',
    'Download': 'הורד',
    'EmailNow': 'שלח דואר אלקטרוני עכשיו',
    'EnrollNow': 'הירשם עכשיו',
    'FileNow': 'הגש עכשיו',
    'FindJob': 'חפש עבודה',
    'FindStore': 'חפש חנות',
    'FreePlay': 'משחק בחינם',
    'FreeQuote': 'הצעת מחיר בחינם',
    'FreeTrial': 'גירסת ניסיון בחינם',
    'GetDeals': 'קבל עסקאות',
    'GetOffer': 'קבל הצעה',
    'GetQuote': 'קבל הצעת מחיר',
    'JoinNow': 'הצטרף עכשיו',
    'LearnMore': 'למד עוד',
    'ListenNow': 'האזן עכשיו',
    'LogIn': 'התחברות',
    'OrderNow': 'הזמן עכשיו',
    'PlayGame': 'שחק משחק',
    'PlayNow': 'שחק עכשיו',
    'PostJob': 'פרסם עבודה',
    'Register': 'הרשמה',
    'RenewNow': 'חדש עכשיו',
    'RentACar': 'שכור רכב',
    'RentNow': 'שכור עכשיו',
    'Reorder': 'שינוי סדר',
    'Reserve': 'ממלא מקום',
    'Sale': 'הצג מכירה',
    'SaveNow': 'שמור עכשיו',
    'Schedule': 'לוח זמנים',
    'SeeMenu': 'הצג תפריט',
    'SeeOffer': 'הצג הצעה',
    'SellNow': 'מכור עכשיו',
    'ShopNow': 'קנה עכשיו',
    'Showtimes': 'מועדי הצגה',
    'SignIn': 'היכנס',
    'SignUp': 'הירשם',
    'StartNow': 'התחל עכשיו',
    'Subscribe': 'הירשם כמנוי',
    'SwitchNow': 'עבור עכשיו',
    'TestDrive': 'גירסת ניסיון',
    'TryNow': 'נסה עכשיו',
    'ViewCars': 'הצג מכוניות',
    'ViewPlans': 'הצג תוכניות',
    'VisitStore': 'בקר בחנות',
    'VoteNow': 'הצבע עכשיו',
    'Watch': 'צפה',
    'WatchMore': 'צפה בעוד',
    'WatchNow': 'צפה עכשיו',
  },
  'SimplifiedChinese': {
    'CustomText': '自订文字',
    'ActNow': '立即操作',
    'ApplyNow': '立即应用',
    'BetNow': '立即下注',
    'BidNow': '立即进行标价',
    'BookACar': '预订汽车',
    'BookHotel': '预订酒店',
    'BookNow': '立即预订',
    'BuyNow': '立即购买',
    'ChatNow': '立即开始聊天',
    'Compare': '比较',
    'ContactUs': '联系我们',
    'Coupon': '获取优惠券',
    'Directions': '路线',
    'Donate': '捐赠',
    'Download': '下载',
    'EmailNow': '立即发送电子邮件',
    'EnrollNow': '立即注册',
    'FileNow': '立即文件',
    'FindJob': '查找职位',
    'FindStore': '查找应用商店',
    'FreePlay': '免费播放',
    'FreeQuote': '免费报价',
    'FreeTrial': '免费试用',
    'GetDeals': '获取交易',
    'GetOffer': '获取产品/服务',
    'GetQuote': '获取报价单',
    'JoinNow': '立即加入',
    'LearnMore': '了解详细信息',
    'ListenNow': '立即收听',
    'LogIn': '登录',
    'OrderNow': '立即订购',
    'PlayGame': '玩游戏',
    'PlayNow': '立即播放',
    'PostJob': '发布职位',
    'Register': '注册',
    'RenewNow': '立即续订',
    'RentACar': '租用汽车',
    'RentNow': '立即租赁',
    'Reorder': '再订购',
    'Reserve': '保留',
    'Sale': '请参阅销售',
    'SaveNow': '立即保存',
    'Schedule': '日程安排',
    'SeeMenu': '查看菜单',
    'SeeOffer': '查看产品/服务',
    'SellNow': '立即销售',
    'ShopNow': '现在购买',
    'Showtimes': '显示时间',
    'SignIn': '登入',
    'SignUp': '报名',
    'StartNow': '立即开始',
    'Subscribe': '订阅',
    'SwitchNow': '立即切换',
    'TestDrive': '试驾',
    'TryNow': '立即试用',
    'ViewCars': '查看汽车',
    'ViewPlans': '查看计划',
    'VisitStore': '访问应用商店',
    'VoteNow': '立即投票',
    'Watch': '观看',
    'WatchMore': '观看更多',
    'WatchNow': '立即观看',
  },
  'Catalan': {
    'CustomText': 'Text personalitzat',
    'WatchNow': 'Mira-ho ara',
    'WatchMore': 'Mostra\'n més',
    'Watch': 'Mira',
    'VoteNow': 'Vota ara',
    'VisitSite': 'Visita el lloc',
    'ViewPlans': 'Mostra els plans',
    'ViewNow': 'Mostra-ho ara',
    'ViewCars': 'Mostra els cotxes',
    'UsedCars': 'Cotxes de segona mà',
    'TryNow': 'Prova-ho ara',
    'TestDrive': 'Prova de conducció',
    'Subscribe': 'Subscriu-te',
    'StartNow': 'Comença ara',
    'StartFree': 'Comença de franc',
    'SignUp': 'Registra\'t',
    'SignIn': 'Inicia la sessió',
    'Showtimes': 'Horaris',
    'ShopNow': 'Compra ara',
    'SellNow': 'Ven ara',
    'SeeOffer': 'Mostra l\'oferta',
    'SeeMore': 'Mira\'n més',
    'SeeMenu': 'Mostra el menú',
    'Schedule': 'Planifica',
    'SaveNow': 'Desa-ho ara',
    'SeeSale': 'Mostra la venda',
    'Reserve': 'Reserva',
    'RentNow': 'Lloga ara',
    'RentACar': 'Lloga un cotxe',
    'Register': 'Registra’t',
    'PostJob': 'Publica la feina',
    'PlayNow': 'Reprodueix-ho ara',
    'PlayGame': 'Juga a un joc',
    'OrderNow': 'Demana-ho ara',
    'NewCars': 'Cotxes nous',
    'Message': 'Missatge',
    'LogIn': 'Inicia la sessió',
    'ListenNow': 'Escolta ara',
    'LearnMore': 'Més informació',
    'JoinNow': 'Uneix-te ara',
    'GetQuote': 'Demana un pressupost',
    'GetOffer': 'Aconsegueix l\'oferta',
    'GetDeals': 'Aconsegueix ofertes',
    'FreeTrial': 'Prova de franc',
    'FreeQuote': 'Pressupost de franc',
    'FreePlay': 'Reproducció de franc',
    'FindJob': 'Cerca feina',
    'FileNow': 'Arxiva ara',
    'Explore': 'Explora',
    'EnrollNow': 'Inscriu-t\'hi ara',
    'EmailNow': 'Envia un correu ara',
    'Download': 'Baixa',
    'Donate': 'Dona',
    'GetCoupon': 'Obtén un cupó',
    'ContactUs': 'Posa\'t en contacte amb nosaltres',
    'Compare': 'Compara',
    'ChatNow': 'Xateja ara',
    'BuyNow': 'Compra ara',
    'Browse': 'Navega',
    'BookNow': 'Reserva ara',
    'BookHotel': 'Reserva un hotel',
    'BookACar': 'Reserva un cotxe',
    'BidNow': 'Ofereix ara',
    'BetNow': 'Aposta ara',
    'ApplyNow': 'Sol·licita-ho ara',
    'ActNow': 'Actua ara',
    'Directions': 'Direccions',
    'FindStore': 'Cerca la Store',
    'SwitchNow': 'Canvia ara',
    'VisitStore': 'Visita la Store',
    'RenewNow': 'Renova-la ara',
    'Reorder': 'Reordena',
    'Buildnow': 'Crea ara',
    'Dealers': 'Distribuïdors',
    'Getdemo': 'Obtén la demostració',
    'Getnow': 'Obtén ara',
    'Gotodemo': 'Ves a la demostració',
    'Seedemo': 'Mostra la demostració',
    'Seemodels': 'Mostra els models',
    'Seeoffers': 'Mostra les ofertes',
    'Viewdemo': 'Visualitza la demostració',
  },
  'Gaelic': {
    'CustomText': 'Teacsa gnàthaichte',
    'WatchNow': 'Coimhead air an-dràsta',
    'WatchMore': 'Coimhead air barrachd',
    'Watch': 'Coimhead',
    'VoteNow': 'Bhòt an-dràsta',
    'VisitSite': 'Tadhail air an làrach',
    'ViewPlans': 'Seall na planaichean',
    'ViewNow': 'Faic an-dràsta',
    'ViewCars': 'Faic càraichean',
    'UsedCars': 'Seann-chàraichean',
    'TryNow': 'Feuch e an-dràsta',
    'TestDrive': 'Dèan draibh deuchainne',
    'Subscribe': 'Fo-sgrìobh',
    'StartNow': 'Tòisich an-dràsta',
    'StartFree': 'Tòisich an-asgaidh',
    'SignUp': 'Clàraich leinn',
    'SignIn': 'Clàraich a-steach',
    'Showtimes': 'Amannan seallaidh',
    'ShopNow': 'Dèan seopadaireachd an-dràsta',
    'SellNow': 'Reic an-dràsta',
    'SeeOffer': 'Seall an tairgse',
    'SeeMore': 'Seall barrachd',
    'SeeMenu': 'Faic an clàr-taice',
    'Schedule': 'An sgeideal',
    'SaveNow': 'Sàbhail an-dràsta',
    'SeeSale': 'Faic an reic',
    'Reserve': 'Glèidh',
    'RentNow': 'Faigh air mhàl an-dràsta',
    'RentACar': 'Faigh càr air mhàl',
    'Register': 'Clàraich',
    'PostJob': 'Postaich obair',
    'PlayNow': 'Cluich an-dràsta',
    'PlayGame': 'Cluich an geama',
    'OrderNow': 'Cuir òrdan an-dràsta',
    'NewCars': 'Càraichean ùra',
    'Message': 'Teachdaireachd',
    'LogIn': 'Clàraich a-steach',
    'ListenNow': 'Èist ris an-dràsta',
    'LearnMore': 'Barrachd fiosrachaidh',
    'JoinNow': 'Faigh ballrachd an-dràsta',
    'GetQuote': 'Faigh ro-aithris chosgaisean',
    'GetOffer': 'Faigh an tairgse',
    'GetDeals': 'Faigh barganan',
    'FreeTrial': 'Triail an-asgaidh',
    'FreeQuote': 'Ro-aithris chosgaisean an-asgaidh',
    'FreePlay': 'Cluich an-asgaidh',
    'FindJob': 'Lorg obair',
    'FileNow': 'Faidhlich an-dràsta',
    'Explore': 'Rùraich',
    'EnrollNow': 'Rolaich an-dràsta',
    'EmailNow': 'Cuir post-d an-dràsta',
    'Download': 'Luchdaich a-nuas',
    'Donate': 'Thoir tabhartas',
    'GetCoupon': 'Faigh an cùpon',
    'ContactUs': 'Cuir fios thugainn',
    'Compare': 'Dèan coimeas',
    'ChatNow': 'Dèan cabadaich an-dràsta',
    'BuyNow': 'Ceannaich an-dràsta',
    'Browse': 'Rùraich',
    'BookNow': 'Glèidh an-dràsta',
    'BookHotel': 'Glèidh taigh-òsta',
    'BookACar': 'Glèidh càr',
    'BidNow': 'Cuir tairgse an-dràsta',
    'BetNow': 'Cuir geall an-dràsta',
    'ApplyNow': 'Dèan tagradh an-dràsta',
    'ActNow': 'Tionndaidh ri gnìomh an-dràsta',
    'Directions': 'Stiùireadh slighe',
    'FindStore': 'Lorg bùth',
    'SwitchNow': 'Imrich an-dràsta fhèin',
    'VisitStore': 'Tadhail air a’ Bhùth',
    'RenewNow': 'Ath-nuadhaich an-dràsta',
    'Reorder': 'Òrdugh ùr',
    'Buildnow': 'Tog an-dràsta',
    'Dealers': 'Reiceadairean',
    'Getdemo': 'Faigh demo',
    'Getnow': 'Faigh an-dràsta',
    'Gotodemo': 'Tadhail air an demo',
    'Seedemo': 'Faic an demo',
    'Seemodels': 'Seall na modailean',
    'Seeoffers': 'Seall na tairgsean',
    'Viewdemo': 'Seall an demo',
  },
  'Hindi': {
    'CustomText': 'कस्टम टेक्स्ट',
    'WatchNow': 'अभी देखें',
    'WatchMore': 'अधिक देखें',
    'Watch': 'घड़ी',
    'VoteNow': 'अभी वोट करें',
    'VisitSite': 'साइट पर जाएँ',
    'ViewPlans': 'योजनाएँ देखें',
    'ViewNow': 'अभी देखें',
    'ViewCars': 'कारें देखें',
    'UsedCars': 'उपयोग की गई कारें',
    'TryNow': 'अभी आज़माएँ',
    'TestDrive': 'टेस्ट-ड्राइव',
    'Subscribe': 'सदस्यता लें',
    'StartNow': 'अभी शुरू करें',
    'StartFree': 'मुफ़्त शुरू करें',
    'SignUp': 'साइन अप करें',
    'SignIn': 'साइन इन करें',
    'Showtimes': 'शोटाइम',
    'ShopNow': 'अभी खरीदें',
    'SellNow': 'अभी बेचें',
    'SeeOffer': 'ऑफ़र देखें',
    'SeeMore': 'अधिक देखें',
    'SeeMenu': 'मेनू देखें',
    'Schedule': 'शेड्यूल करें',
    'SaveNow': 'अभी सहेजें',
    'SeeSale': 'सेल देखें',
    'Reserve': 'आरक्षित करें',
    'RentNow': 'अभी किराए पर लें',
    'RentACar': 'कार किराए पर लें',
    'Register': 'पंजीकृत करें',
    'PostJob': 'जॉब पोस्ट करें',
    'PlayNow': 'अभी खेलें',
    'PlayGame': 'गेम खेलें',
    'OrderNow': 'अभी ऑर्डर करें',
    'NewCars': 'नई कारें',
    'Message': 'संदेश',
    'LogIn': 'लॉग इन करें',
    'ListenNow': 'अभी सुनें',
    'LearnMore': 'अधिक जानें',
    'JoinNow': 'अभी शामिल हों',
    'GetQuote': 'कीमत प्राप्त करें',
    'GetOffer': 'ऑफ़र प्राप्त करें',
    'GetDeals': 'डील प्राप्त करें',
    'FreeTrial': 'मुफ़्त ट्रायल',
    'FreeQuote': 'मुफ़्त कोटेशन',
    'FreePlay': 'मुफ़्त खेलें',
    'FindJob': 'जॉब ढूँढें',
    'FileNow': 'अभी फ़ाइल करें',
    'Explore': 'एक्सप्लोर करें',
    'EnrollNow': 'अभी नामांकित करें',
    'EmailNow': 'अभी ईमेल करें',
    'Download': 'डाउनलोड करें',
    'Donate': 'दान करें',
    'GetCoupon': 'कूपन प्राप्त करें',
    'ContactUs': 'हमसे संपर्क करें',
    'Compare': 'तुलना करें',
    'ChatNow': 'अभी चैट करें',
    'BuyNow': 'अभी खरीदें',
    'Browse': 'ब्राउज़ करें',
    'BookNow': 'अभी बुक करें',
    'BookHotel': 'होटल बुक करें',
    'BookACar': 'कार बुक करें',
    'BidNow': 'अभी बोली लगाएँ',
    'BetNow': 'अभी बाज़ी लगाएँ',
    'ApplyNow': 'अभी लागू करें',
    'ActNow': 'अभी कार्रवाई करें',
    'Directions': 'निर्देश',
    'FindStore': 'Store ढूँढें',
    'SwitchNow': 'अभी स्विच करें',
    'VisitStore': 'Store पर जाएँ',
    'RenewNow': 'अभी नवीनीकृत करें',
    'Reorder': 'रीऑर्डर करें',
    'Buildnow': 'अभी बनाएँ',
    'Dealers': 'डीलर्स',
    'Getdemo': 'डेमो प्राप्त करें',
    'Getnow': 'अभी प्राप्त करें',
    'Gotodemo': 'डेमो पर जाएँ',
    'Seedemo': 'डेमो देखें',
    'Seemodels': 'मॉडल देखें',
    'Seeoffers': 'ऑफ़र देखें',
    'Viewdemo': 'डेमो देखें',
  },
  'Indonesian': {
    'CustomText': 'Teks Kustom',
    'WatchNow': 'Tonton Sekarang',
    'WatchMore': 'Tonton Lainnya',
    'Watch': 'Tonton',
    'VoteNow': 'Pilih Sekarang',
    'VisitSite': 'Kunjungi Situs',
    'ViewPlans': 'Tampilkan Rencana',
    'ViewNow': 'Tampilkan Sekarang',
    'ViewCars': 'Tampilkan Mobil',
    'UsedCars': 'Mobil Bekas',
    'TryNow': 'Coba Sekarang',
    'TestDrive': 'Uji Coba',
    'Subscribe': 'Berlangganan',
    'StartNow': 'Mulai Sekarang',
    'StartFree': 'Mulai Gratis',
    'SignUp': 'Daftar',
    'SignIn': 'Masuk',
    'Showtimes': 'Waktu peragaan',
    'ShopNow': 'Belanja Sekarang',
    'SellNow': 'Jual Sekarang',
    'SeeOffer': 'Lihat Penawaran',
    'SeeMore': 'Lihat Lainnya',
    'SeeMenu': 'Lihat Menu',
    'Schedule': 'Jadwalkan',
    'SaveNow': 'Simpan Sekarang',
    'SeeSale': 'Lihat Penjualan',
    'Reserve': 'Memesan',
    'RentNow': 'Sewa Sekarang',
    'RentACar': 'Sewa Mobil',
    'Register': 'Daftar',
    'PostJob': 'Posting Pekerjaan',
    'PlayNow': 'Putar Sekarang',
    'PlayGame': 'Mainkan Game',
    'OrderNow': 'Pesan Sekarang',
    'NewCars': 'Mobil Baru',
    'Message': 'Pesan',
    'LogIn': 'Masuk',
    'ListenNow': 'Dengarkan Sekarang',
    'LearnMore': 'Pelajari Selengkapnya',
    'JoinNow': 'Bergabung sekarang',
    'GetQuote': 'Dapatkan Kutipan',
    'GetOffer': 'Dapatkan Penawaran',
    'GetDeals': 'Dapatkan Penawaran',
    'FreeTrial': 'Percobaan Gratis',
    'FreeQuote': 'Kutipan Gratis',
    'FreePlay': 'Putar Gratis',
    'FindJob': 'Temukan Pekerjaan',
    'FileNow': 'File Sekarang',
    'Explore': 'Jelajahi',
    'EnrollNow': 'Daftar Sekarang',
    'EmailNow': 'Email Sekarang',
    'Download': 'Unduh',
    'Donate': 'Donasi',
    'GetCoupon': 'Dapatkan Kupon',
    'ContactUs': 'Hubungi Kami',
    'Compare': 'Bandingkan',
    'ChatNow': 'Mengobrol Sekarang',
    'BuyNow': 'Beli Sekarang',
    'Browse': 'Telusuri',
    'BookNow': 'Pesan Sekarang',
    'BookHotel': 'Pesan Hotel',
    'BookACar': 'Pesan mobil',
    'BidNow': 'Tawaran Sekarang',
    'BetNow': 'Bertaruh Sekarang',
    'ApplyNow': 'Terapkan Sekarang',
    'ActNow': 'Bertindak Sekarang',
    'Directions': 'Petunjuk arah',
    'FindStore': 'Temukan Store',
    'SwitchNow': 'Beralih Sekarang',
    'VisitStore': 'Kunjungi Store',
    'RenewNow': 'Perpanjang Sekarang',
    'Reorder': 'Urutkan ulang',
    'Buildnow': 'Buat sekarang',
    'Dealers': 'Dealer',
    'Getdemo': 'Dapatkan demo',
    'Getnow': 'Dapatkan sekarang',
    'Gotodemo': 'Buka demo',
    'Seedemo': 'Lihat demo',
    'Seemodels': 'Lihat model',
    'Seeoffers': 'Lihat penawaran',
    'Viewdemo': 'Tampilkan demo',
  },
  'Korean': {
    'CustomText': '사용자 지정 텍스트',
    'WatchNow': '지금 시청하기',
    'WatchMore': '더 시청하기',
    'Watch': '시청하기',
    'VoteNow': '지금 투표하기',
    'VisitSite': '사이트 방문',
    'ViewPlans': '플랜 보기',
    'ViewNow': '지금 보기',
    'ViewCars': '자동차 보기',
    'UsedCars': '중고차',
    'TryNow': '지금 시도',
    'TestDrive': '테스트 드라이브',
    'Subscribe': '구독',
    'StartNow': '지금 시작',
    'StartFree': '무료로 시작',
    'SignUp': '가입하기',
    'SignIn': '로그인',
    'Showtimes': '상영 시간',
    'ShopNow': '지금 쇼핑하기',
    'SellNow': '지금 판매',
    'SeeOffer': '제안 보기',
    'SeeMore': '더보기',
    'SeeMenu': '메뉴 보기',
    'Schedule': '일정',
    'SaveNow': '지금 저장하기',
    'SeeSale': '판매 보기',
    'Reserve': '예약',
    'RentNow': '지금 임대',
    'RentACar': '차 임대하기',
    'Register': '등록하기',
    'PostJob': '사후 작업',
    'PlayNow': '지금 플레이',
    'PlayGame': '게임 플레이',
    'OrderNow': '지금 주문하기',
    'NewCars': '새 자동차',
    'Message': '메시지',
    'LogIn': '로그인',
    'ListenNow': '지금 듣기',
    'LearnMore': '더 알아보기',
    'JoinNow': '지금 가입하기',
    'GetQuote': '견적 받기',
    'GetOffer': '제안 받기',
    'GetDeals': '특가 가져오기',
    'FreeTrial': '무료 시험판',
    'FreeQuote': '무료 견적',
    'FreePlay': '무료 플레이',
    'FindJob': '일자리 찾기',
    'FileNow': '지금 신청하기',
    'Explore': '탐색하기',
    'EnrollNow': '지금 등록',
    'EmailNow': '지금 이메일 보내기',
    'Download': '다운로드',
    'Donate': '기부하기',
    'GetCoupon': '쿠폰 받기',
    'ContactUs': '문의하기',
    'Compare': '비교하기',
    'ChatNow': '지금 채팅',
    'BuyNow': '지금 구매',
    'Browse': '찾아보기',
    'BookNow': '지금 예약하기',
    'BookHotel': '호텔 예약하기',
    'BookACar': '자동차 예약하기',
    'BidNow': '지금 입찰하기',
    'BetNow': '지금 내기하기',
    'ApplyNow': '지금 신청하기',
    'ActNow': '지금 행동하기',
    'Directions': '길 찾기',
    'FindStore': '매장 찾기',
    'SwitchNow': '지금 전환',
    'VisitStore': '매장 방문',
    'RenewNow': '지금 갱신',
    'Reorder': '다시 주문하기',
    'Buildnow': '지금 빌드하기',
    'Dealers': '대리점',
    'Getdemo': '데모 받기',
    'Getnow': '지금 받기',
    'Gotodemo': '데모로 이동',
    'Seedemo': '데모 보기',
    'Seemodels': '모델 보기',
    'Seeoffers': '혜택 보기',
    'Viewdemo': '데모 보기',
  },
  'Thai': {
    'CustomText': 'ข้อความแบบกำหนดเอง',
    'WatchNow': 'ดูตอนนี้',
    'WatchMore': 'ดูเพิ่มเติม',
    'Watch': 'ดู',
    'VoteNow': 'โหวตตอนนี้',
    'VisitSite': 'เยี่ยมชมไซต์',
    'ViewPlans': 'ดูแผน',
    'ViewNow': 'ดูตอนนี้',
    'ViewCars': 'ดูรถยนต์',
    'UsedCars': 'รถยนต์มือสอง',
    'TryNow': 'ลองใช้ทันที',
    'TestDrive': 'ทดลองใช้',
    'Subscribe': 'สมัครใช้งาน',
    'StartNow': 'เริ่มเลย',
    'StartFree': 'เริ่มใช้งานฟรี',
    'SignUp': 'ลงทะเบียน',
    'SignIn': 'ลงชื่อเข้าใช้',
    'Showtimes': 'เวลาแสดง',
    'ShopNow': 'เลือกซื้อตอนนี้',
    'SellNow': 'ขายทันที',
    'SeeOffer': 'ดูข้อเสนอ',
    'SeeMore': 'ดูเพิ่ม',
    'SeeMenu': 'ดูเมนู',
    'Schedule': 'จัดกำหนดการ',
    'SaveNow': 'บันทึกเดี๋ยวนี้',
    'SeeSale': 'ดูการขาย',
    'Reserve': 'สำรอง',
    'RentNow': 'เช่าทันที',
    'RentACar': 'เช่ารถ',
    'Register': 'ลงทะเบียน',
    'PostJob': 'โพสต์งาน',
    'PlayNow': 'เล่นเดี๋ยวนี้',
    'PlayGame': 'เล่นเกม',
    'OrderNow': 'สั่งซื้อทันที',
    'NewCars': 'รถยนต์ใหม่',
    'Message': 'ข้อความ',
    'LogIn': 'เข้าสู่ระบบ',
    'ListenNow': 'ฟังเดี๋ยวนี้',
    'LearnMore': 'เรียนรู้เพิ่มเติม',
    'JoinNow': 'เข้าร่วมเดี๋ยวนี้',
    'GetQuote': 'รับใบเสนอราคา',
    'GetOffer': 'รับข้อเสนอ',
    'GetDeals': 'รับข้อเสนอ',
    'FreeTrial': 'ทดลองใช้ฟรี',
    'FreeQuote': 'ใบเสนอราคาฟรี',
    'FreePlay': 'เล่นฟรี',
    'FindJob': 'ค้นหางาน',
    'FileNow': 'ทำไฟล์เดี๋ยวนี้',
    'Explore': 'สำรวจ',
    'EnrollNow': 'ลงทะเบียนทันที',
    'EmailNow': 'ส่งอีเมลทันที',
    'Download': 'ดาวน์โหลด',
    'Donate': 'บริจาค',
    'GetCoupon': 'รับคูปอง',
    'ContactUs': 'ติดต่อเรา',
    'Compare': 'เปรียบเทียบ',
    'ChatNow': 'แชทตอนนี้',
    'BuyNow': 'ซื้อตอนนี้',
    'Browse': 'เรียกดู',
    'BookNow': 'จองทันที',
    'BookHotel': 'จองโรงแรม',
    'BookACar': 'จองรถ',
    'BidNow': 'เสนอราคาทันที',
    'BetNow': 'เดิมพันตอนนี้',
    'ApplyNow': 'นำไปใช้ทันที',
    'ActNow': 'ดำเนินการทันที',
    'Directions': 'เส้นทาง',
    'FindStore': 'ค้นหา Store',
    'SwitchNow': 'เปลี่ยนทันที',
    'VisitStore': 'เยี่ยมชม Store',
    'RenewNow': 'ต่ออายุตอนนี้',
    'Reorder': 'เรียงลำดับใหม่',
    'Buildnow': 'สร้างทันที',
    'Dealers': 'ตัวแทนจำหน่าย',
    'Getdemo': 'รับการสาธิต',
    'Getnow': 'รับทันที',
    'Gotodemo': 'ไปที่การสาธิต',
    'Seedemo': 'ดูการสาธิต',
    'Seemodels': 'ดูโมเดล',
    'Seeoffers': 'ดูข้อเสนอ',
    'Viewdemo': 'ดูการสาธิต',
  },
  'Ukrainian': {
    'CustomText': 'Налаштуйте текст',
    'WatchNow': 'Перегляньте',
    'WatchMore': 'Перегляньте більше',
    'Watch': 'Перегляд',
    'VoteNow': 'Проголосуйте',
    'VisitSite': 'Відвідайте сайт',
    'ViewPlans': 'Перегляньте плани',
    'ViewNow': 'Перегляньте',
    'ViewCars': 'Перегляньте автомобілі',
    'UsedCars': 'Вживані автомобілі',
    'TryNow': 'Спробуйте зараз',
    'TestDrive': 'Тест-драйв',
    'Subscribe': 'Підпишіться',
    'StartNow': 'Почніть',
    'StartFree': 'Почніть безкоштовно',
    'SignUp': 'Зареєструйтеся',
    'SignIn': 'Увійдіть',
    'Showtimes': 'Сеанси',
    'ShopNow': 'Придбайте зараз',
    'SellNow': 'Продайте зараз',
    'SeeOffer': 'Перегляньте пропозицію',
    'SeeMore': 'Більше',
    'SeeMenu': 'Перегляньте меню',
    'Schedule': 'Заплануйте',
    'SaveNow': 'Заощадьте зараз',
    'SeeSale': 'Перегляньте розпродаж',
    'Reserve': 'Зарезервуйте',
    'RentNow': 'Візьміть у прокат зараз',
    'RentACar': 'Візьміть авто у прокат',
    'Register': 'Зареєструйтеся',
    'PostJob': 'Опублікуйте вакансію',
    'PlayNow': 'Грайте зараз',
    'PlayGame': 'Грайте в гру',
    'OrderNow': 'Замовте зараз',
    'NewCars': 'Нові автомобілі',
    'Message': 'Повідомлення',
    'LogIn': 'Увійдіть',
    'ListenNow': 'Прослухайте зараз',
    'LearnMore': 'Дізнайтеся більше',
    'JoinNow': 'Приєднайтеся',
    'GetQuote': 'Отримайте котирування',
    'GetOffer': 'Отримайте пропозицію',
    'GetDeals': 'Отримайте угоди',
    'FreeTrial': 'Ознайомтеся безкоштовно',
    'FreeQuote': 'Безкоштовне котирування',
    'FreePlay': 'Безкоштовна гра',
    'FindJob': 'Знайдіть роботу',
    'FileNow': 'Надішліть зараз',
    'Explore': 'Ознайомтеся',
    'EnrollNow': 'Зареєструйтеся зараз',
    'EmailNow': 'Надішліть електронний лист зараз',
    'Download': 'Завантажте',
    'Donate': 'Внесіть пожертву',
    'GetCoupon': 'Отримайте купон',
    'ContactUs': 'Зверніться до нас',
    'Compare': 'Порівняйте',
    'ChatNow': 'Перейдіть у чат',
    'BuyNow': 'Придбайте зараз',
    'Browse': 'Огляньте',
    'BookNow': 'Зарезервуйте зараз',
    'BookHotel': 'Зарезервуйте готель',
    'BookACar': 'Зарезервуйте автомобіль',
    'BidNow': 'Зробіть цінову пропозицію зараз',
    'BetNow': 'Зробіть ставку зараз',
    'ApplyNow': 'Застосуйте зараз',
    'ActNow': 'Дійте зараз',
    'Directions': 'Маршрут',
    'FindStore': 'Знайдіть магазин',
    'SwitchNow': 'Перейдіть зараз',
    'VisitStore': 'Відвідайте магазин',
    'RenewNow': 'Поновіть зараз',
    'Reorder': 'Змініть порядок',
    'Buildnow': 'Побудуйте зараз',
    'Dealers': 'Дилери',
    'Getdemo': 'Отримайте демо-версію',
    'Getnow': 'Отримайте зараз',
    'Gotodemo': 'Перейдіть до демонстрації',
    'Seedemo': 'Перегляньте демонстрацію',
    'Seemodels': 'Перегляньте моделі',
    'Seeoffers': 'Перегляньте пропозиції',
    'Viewdemo': 'Подивіться демонстрацію',
  },
  'Vietnamese': {
    'CustomText': 'Văn bản tùy chỉnh',
    'WatchNow': 'Xem ngay',
    'WatchMore': 'Xem thêm',
    'Watch': 'Xem',
    'VoteNow': 'Bình chọn ngay',
    'VisitSite': 'Truy nhập trang web',
    'ViewPlans': 'Xem các gói',
    'ViewNow': 'Xem ngay',
    'ViewCars': 'Xem ô tô',
    'UsedCars': 'Ô tô đã qua sử dụng',
    'TryNow': 'Thử ngay',
    'TestDrive': 'Chạy thử',
    'Subscribe': 'Đăng ký',
    'StartNow': 'Bắt đầu ngay',
    'StartFree': 'Bắt đầu miễn phí',
    'SignUp': 'Đăng ký',
    'SignIn': 'Đăng nhập',
    'Showtimes': 'Lịch chiếu',
    'ShopNow': 'Mua ngay',
    'SellNow': 'Bán ngay',
    'SeeOffer': 'Xem chào hàng',
    'SeeMore': 'Xem thêm',
    'SeeMenu': 'Xem menu',
    'Schedule': 'Lên lịch',
    'SaveNow': 'Lưu ngay',
    'SeeSale': 'Xem giảm giá',
    'Reserve': 'Đặt trước',
    'RentNow': 'Thuê ngay',
    'RentACar': 'Thuê ô tô',
    'Register': 'Đăng ký',
    'PostJob': 'Đăng công việc',
    'PlayNow': 'Chơi ngay',
    'PlayGame': 'Chơi trò chơi',
    'OrderNow': 'Đặt ngay',
    'NewCars': 'Ô tô mới',
    'Message': 'Tin nhắn',
    'LogIn': 'Đăng nhập',
    'ListenNow': 'Nghe ngay',
    'LearnMore': 'Tìm hiểu thêm',
    'JoinNow': 'Tham gia ngay',
    'GetQuote': 'Lấy báo giá',
    'GetOffer': 'Lấy chào hàng',
    'GetDeals': 'Lấy ưu đãi',
    'FreeTrial': 'Bản dùng thử',
    'FreeQuote': 'Báo giá miễn phí',
    'FreePlay': 'Chơi miễn phí',
    'FindJob': 'Tìm công việc',
    'FileNow': 'Sẵn dùng ngay',
    'Explore': 'Khám phá',
    'EnrollNow': 'Đăng ký ngay',
    'EmailNow': 'Gửi email ngay',
    'Download': 'Tải xuống',
    'Donate': 'Tặng',
    'GetCoupon': 'Lấy phiếu giảm giá',
    'ContactUs': 'Liên hệ với chúng tôi',
    'Compare': 'So sánh',
    'ChatNow': 'Trò chuyện ngay',
    'BuyNow': 'Mua ngay',
    'Browse': 'Duyệt xem',
    'BookNow': 'Đặt trước ngay',
    'BookHotel': 'Đặt phòng khách sạn',
    'BookACar': 'Đặt ô tô',
    'BidNow': 'Trả giá ngay',
    'BetNow': 'Lựa chọn ngay',
    'ApplyNow': 'Áp dụng ngay',
    'ActNow': 'Hành động ngay',
    'Directions': 'Chỉ đường',
    'FindStore': 'Tìm cửa hàng',
    'SwitchNow': 'Chuyển ngay',
    'VisitStore': 'Đến cửa hàng',
    'RenewNow': 'Gia hạn ngay',
    'Reorder': 'Sắp xếp lại',
    'Buildnow': 'Dựng ngay',
    'Dealers': 'Đại lý',
    'Getdemo': 'Lấy bản demo',
    'Getnow': 'Lấy ngay',
    'Gotodemo': 'Đến bản demo',
    'Seedemo': 'Xem bản demo',
    'Seemodels': 'Xem mẫu',
    'Seeoffers': 'Xem chào hàng',
    'Viewdemo': 'Xem bản demo',
  },
  'Afrikaans': {
    'ActNow': 'Tree nou op',
    'ApplyNow': 'Doen nou aansoek',
    'BetNow': 'Wed nou',
    'BidNow': 'Bie nou',
    'BookACar': 'Bespreek ’n motor',
    'BookHotel': 'Bespreek hotel',
    'BookNow': 'Bespreek nou',
    'Browse': 'Blaai',
    'BuyNow': 'Koop nou',
    'ChatNow': 'Klets nou',
    'Compare': 'Vergelyk',
    'ContactUs': 'Kontak ons',
    'GetCoupon': 'Kry koepon',
    'Donate': 'Skenk',
    'Download': 'Laai af',
    'EmailNow': 'E-pos nou',
    'EnrollNow': 'Skryf nou in',
    'Explore': 'Verken',
    'FileNow': 'Lêer nou',
    'FindJob': 'Vind werk',
    'FreePlay': 'Gratis speel',
    'FreeQuote': 'Gratis kwotasie',
    'FreeTrial': 'Gratis proeflopie',
    'GetDeals': 'Kry aanbiedings',
    'GetOffer': 'Kry aanbieding',
    'GetQuote': 'Kry kwotasie',
    'JoinNow': 'Sluit nou aan',
    'LearnMore': 'Kom meer te wete',
    'ListenNow': 'Luister nou',
    'LogIn': 'Teken aan',
    'Message': 'Boodskap',
    'NewCars': 'Nuwe motors',
    'OrderNow': 'Bestel nou',
    'PlayGame': 'Speel speletjie',
    'PlayNow': 'Speel nou',
    'PostJob': 'Plaas werk',
    'Register': 'Registreer',
    'RentACar': 'Huur ’n motor',
    'RentNow': 'Huur nou',
    'Reserve': 'Reserveer',
    'SeeSale': 'Sien uitverkoping',
    'SaveNow': 'Stoor nou',
    'Schedule': 'Skedule',
    'SeeMenu': 'Sien kieslys',
    'SeeMore': 'Sien meer',
    'SeeOffer': 'Sien aanbieding',
    'SellNow': 'Verkoop nou',
    'ShopNow': 'Koop nou',
    'Showtimes': 'Vertoontyd',
    'SignIn': 'Meld aan',
    'SignUp': 'Registreer',
    'StartFree': 'Begin gratis',
    'StartNow': 'Begin nou',
    'Subscribe': 'Inteken',
    'TestDrive': 'Toetsbestuur',
    'TryNow': 'Probeer nou',
    'UsedCars': 'Tweedehandse motors',
    'ViewCars': 'Bekyk motors',
    'ViewNow': 'Bekyk nou',
    'ViewPlans': 'Bekyk planne',
    'VisitSite': 'Besoek werf',
    'VoteNow': 'Stem nou',
    'Watch': 'Kyk',
    'WatchMore': 'Kyk meer',
    'WatchNow': 'Kyk nou',
    'Directions': 'Aanwysings',
    'FindStore': 'Vind winkel',
    'SwitchNow': 'Skakel nou oor',
    'VisitStore': 'Besoek winkel',
    'RenewNow': 'Hernu nou',
    'Reorder': 'Bestel weer',
    'Buildnow': 'Bou nou',
    'Dealers': 'Handelaars',
    'Getdemo': 'Kry demo',
    'Getnow': 'Kry nou',
    'Gotodemo': 'Gaan na demo',
    'Seedemo': 'Sien demo',
    'Seemodels': 'Sien modelle',
    'Seeoffers': 'Sien aanbiedings',
    'Viewdemo': 'Bekyk demo',
    'CustomText': 'Pasmaak teks',
    'Discover': 'Ontdek',
    'Dismiss': 'Weier',
  },
  'Amharic': {
    'ActNow': 'አሁን ይተግብሩ',
    'ApplyNow': 'አሁን ይተግብሩ',
    'BetNow': 'አሁን ይወራረዱ',
    'BidNow': 'አሁን ይጫረቱ',
    'BookACar': 'መኪና ያስይዙ',
    'BookHotel': 'የሆቴል ቦታ ያስይዙ',
    'BookNow': 'አሁን ቦታ ያስይዙ',
    'Browse': 'ያስሱ',
    'BuyNow': 'አሁን ይግዙ',
    'ChatNow': 'አሁን ይወያዩ',
    'Compare': 'ያወዳድሩ',
    'ContactUs': 'እኛን ያግኙን',
    'GetCoupon': 'ኩፖን ያግኙ',
    'Donate': 'ይለገሱ',
    'Download': 'ያውርዱ',
    'EmailNow': 'አሁን ኢሜይል ያድርጉ',
    'EnrollNow': 'አሁን ይመዝገቡ',
    'Explore': 'ያስሱ',
    'FileNow': 'አሁን ፋይል ያድርጉ',
    'FindJob': 'ስራ ይፈልጉ',
    'FreePlay': 'ነጻ ይጫወቱ',
    'FreeQuote': 'ነፃ ጥቅስ',
    'FreeTrial': 'የነፃ ሙከራ',
    'GetDeals': 'ስምምነት ያግኙ',
    'GetOffer': 'ቅናሽ ያግኙ',
    'GetQuote': 'ጥቅስ ያግኙ',
    'JoinNow': 'አሁን ይቀላቀሉ',
    'LearnMore': 'ተጨማሪ ይወቁ',
    'ListenNow': 'አሁኑኑ ያዳምጡ',
    'LogIn': 'በመለያ ይግቡ',
    'Message': 'መልዕክት',
    'NewCars': 'አዳዲስ መኪናዎች',
    'OrderNow': 'አሁን ይዘዙ',
    'PlayGame': 'ጨዋታ ይጫወቱ',
    'PlayNow': 'አሁን ይጫወቱ',
    'PostJob': 'ጽሁፍ ልጥፍ',
    'Register': 'ተመዝገብ',
    'RentACar': 'መኪና ይከራዩ',
    'RentNow': 'አሁን ይከራዩ',
    'Reserve': 'መጠባበቂያ',
    'SeeSale': 'ሽያጩን ይመልከቱ',
    'SaveNow': 'አሁን ያስቀምጡ',
    'Schedule': 'የጊዜ ሰሌዳ',
    'SeeMenu': 'ምናሌ ይመልከቱ',
    'SeeMore': 'ተጨማሪ ይመልከቱ',
    'SeeOffer': 'ቅናሽ ይመልከቱ',
    'SellNow': 'አሁን ይሽጡ',
    'ShopNow': 'አሁን ይግዙ',
    'Showtimes': 'የማሳያ ጊዜያት',
    'SignIn': 'በመለያ ይግቡ',
    'SignUp': 'ይመዝገቡ',
    'StartFree': 'ነጻ ሙከራ ይጀምሩ',
    'StartNow': 'አሁን ይጀምሩ',
    'Subscribe': 'ለደምበኝነት ይመዝገቡ',
    'TestDrive': 'መንዳት ይሞክሩ',
    'TryNow': 'አሁን ይሞክሩ',
    'UsedCars': 'በጥቅም ላይ የዋሉ መኪናዎች',
    'ViewCars': 'መኪናዎች ይመልከቱ',
    'ViewNow': 'አሁን ይመልከቱ',
    'ViewPlans': 'እቅዶችን ይመልከቱ',
    'VisitSite': 'ድረ-ገጽ ይጎብኙ',
    'VoteNow': 'አሁን ድምጽ ይስጡ',
    'Watch': 'ይመልከቱ',
    'WatchMore': 'ተጨማሪ ይመልከቱ',
    'WatchNow': 'አሁን ይመልከቱ',
    'Directions': 'አቅጣጫዎች',
    'FindStore': 'መደብር ይፈልጉ',
    'SwitchNow': 'አሁን ይቀይሩ',
    'VisitStore': 'መደብር ይመልከቱ',
    'RenewNow': 'አሁን ያድሱ',
    'Reorder': 'እንደገና ደርድር',
    'Buildnow': 'አሁን ይገንቡ',
    'Dealers': 'ነጋዴዎች',
    'Getdemo': 'ማሳያ ያግኙ',
    'Getnow': 'አሁን ያግኙ',
    'Gotodemo': 'ወደ ማሳያ ይሂዱ',
    'Seedemo': 'ማሳያ ይመልከቱ',
    'Seemodels': 'ሞዴሎች ይመልከቱ',
    'Seeoffers': 'አቅርቦቶችን ይመልከቱ',
    'Viewdemo': 'ማሳያ ይመልከቱ',
    'CustomText': 'ብጁ ጽሑፍ',
    'Discover': 'አግኝ ',
    'Dismiss': 'አሰናብት ',
  },
  'Armenian': {
    'ActNow': 'Գործել հիմա',
    'ApplyNow': 'Դիմել հիմա',
    'BetNow': 'Խաղադրույք կատարել հիմա',
    'BidNow': 'Գնային առաջարկ կատարել հիմա',
    'BookACar': 'Ամրագրել ավտոմեքենա',
    'BookHotel': 'Ամրագրել հյուրանոց',
    'BookNow': 'Ամրագրել հիմա',
    'Browse': 'Զննել',
    'BuyNow': 'Գնել հիմա',
    'ChatNow': 'Զրուցել հիմա',
    'Compare': 'Համեմատել',
    'ContactUs': 'Դիմել մեզ',
    'GetCoupon': 'Ստանալ կտրոն',
    'Donate': 'Նվիրատվություն կատարել',
    'Download': 'Ներբեռնել',
    'EmailNow': 'Էլ. ուղերձ ուղարկել հիմա',
    'EnrollNow': 'Գրանցվել հիմա',
    'Explore': 'Հետազոտել',
    'FileNow': 'Ներկայացնել հիմա',
    'FindJob': 'Գտնել աշխատանք',
    'FreePlay': 'Անվճար խաղ',
    'FreeQuote': 'Ազատ գնային առաջարկ',
    'FreeTrial': 'Անվճար փորձաշրջան',
    'GetDeals': 'Ստանալ հատուկ առաջարկները',
    'GetOffer': 'Ստանալ առաջարկ',
    'GetQuote': 'Ստանալ գնային առաջարկ',
    'JoinNow': 'Միանալ հիմա',
    'LearnMore': 'Իմանալ ավելին',
    'ListenNow': 'Լսի՛ր հիմա',
    'LogIn': 'Մուտք գործել',
    'Message': 'Հաղորդագրություն',
    'NewCars': 'Նոր ավտոմեքենաներ',
    'OrderNow': 'Պատվիրել հիմա',
    'PlayGame': 'Խաղալ խաղ',
    'PlayNow': 'Խաղալ հիմա',
    'PostJob': 'Աշխատանքի հայտարարություն տեղադրել',
    'Register': 'Գրանցվել',
    'RentACar': 'Վարձակալել ավտոմեքենա',
    'RentNow': 'Վարձակալել հիմա',
    'Reserve': 'Պատվիրել',
    'SeeSale': 'Տեսնել զեղչը',
    'SaveNow': 'Խնայել հիմա',
    'Schedule': 'Ժամանակացույց',
    'SeeMenu': 'Տեսնել ցանկը',
    'SeeMore': 'Տեսնել ավելին',
    'SeeOffer': 'Տեսնել առաջարկը',
    'SellNow': 'Վաճառել հիմա',
    'ShopNow': 'Գնել հիմա',
    'Showtimes': 'Ցուցադրման ժամեր',
    'SignIn': 'Մուտք գործել',
    'SignUp': 'Գրանցվել',
    'StartFree': 'Սկսել անվճար',
    'StartNow': 'Սկսել հիմա',
    'Subscribe': 'Բաժանորդագրվել',
    'TestDrive': 'Փորձնական վարել',
    'TryNow': 'Փորձել հիմա',
    'UsedCars': 'Օգտագործված ավտոմեքենաներ',
    'ViewCars': 'Դիտել ավտոմեքենաներ',
    'ViewNow': 'Դիտել հիմա',
    'ViewPlans': 'Դիտել պլանները',
    'VisitSite': 'Այցելեք կայքը',
    'VoteNow': 'Քվեարկել հիմա',
    'Watch': 'Դիտել',
    'WatchMore': 'Դիտել ավելին',
    'WatchNow': 'Դիտել հիմա',
    'Directions': 'Ուղղություններ',
    'FindStore': 'Գտնել խանութ',
    'SwitchNow': 'Փոխարկել հիմա',
    'VisitStore': 'Այցելել խանութը',
    'RenewNow': 'Նորացնել հիմա',
    'Reorder': 'Կրկին պատվիրել',
    'Buildnow': 'Կառուցել հիմա',
    'Dealers': 'Գործակալ',
    'Getdemo': 'Ստանալ ցուցադրում',
    'Getnow': 'Ստանալ հիմա',
    'Gotodemo': 'Անցնել ցուցադրմանը',
    'Seedemo': 'Տեսնել ցուցադրումը',
    'Seemodels': 'Տեսնել մոդելները',
    'Seeoffers': 'Տեսնել առաջարկները',
    'Viewdemo': 'Դիտել ցուցադրումը',
    'CustomText': 'Հարմարեցված գրվածք',
    'Discover': 'Բացահայտել',
    'Dismiss': 'Անտեսել',
  },
  'Assamese': {
    'ActNow': 'এতিয়াই কাৰ্য কৰক',
    'ApplyNow': 'এতিয়াই আৱেদন কৰক',
    'BetNow': 'এতিয়াই বাজি মাৰক',
    'BidNow': 'এতিয়াই বিড কৰক',
    'BookACar': 'এখন গাড়ী বুক কৰক',
    'BookHotel': 'হোটেল বুক কৰক',
    'BookNow': 'এতিয়াই বুক কৰক',
    'Browse': 'ব্ৰাউজ কৰক',
    'BuyNow': 'এতিয়াই কিনক',
    'ChatNow': 'এতিয়াই চাট কৰক',
    'Compare': 'তুলনা কৰক',
    'ContactUs': 'আমাৰ সৈতে যোগাযোগ কৰক',
    'GetCoupon': 'কুপন লাভ কৰক',
    'Donate': 'দান কৰক',
    'Download': 'ডাউনল\'ড কৰক',
    'EmailNow': 'এতিয়াই ইমেইল কৰক',
    'EnrollNow': 'এতিয়াই পঞ্জীয়ন কৰক',
    'Explore': 'অন্বেষণ কৰক',
    'FileNow': 'এতিয়াই ফাইল কৰক',
    'FindJob': 'চাকৰি বিচাৰক',
    'FreePlay': 'বিনামূলীয়াকৈ প্লে’ কৰক',
    'FreeQuote': 'বিনামূলীয়া উদ্ধৃতি',
    'FreeTrial': 'বিনামূলীয়া ট্ৰায়েল',
    'GetDeals': 'ডীল লাভ কৰক',
    'GetOffer': 'অফাৰ লাভ কৰক',
    'GetQuote': 'উদ্ধৃতি লাভ কৰক',
    'JoinNow': 'এতিয়াই যোগদান কৰক',
    'LearnMore': 'অধিক জানক',
    'ListenNow': 'এতিয়াই শুনক',
    'LogIn': 'লগ ইন কৰক',
    'Message': 'বাৰ্তা',
    'NewCars': 'নতুন গাড়ী',
    'OrderNow': 'এতিয়াই অৰ্ডাৰ কৰক',
    'PlayGame': 'গে’ম খেলক',
    'PlayNow': 'এতিয়াই প্লে’ কৰক',
    'PostJob': 'চাকৰি প’ষ্ট কৰক',
    'Register': 'পঞ্জীয়ন কৰক',
    'RentACar': 'এখন গাড়ী ভাড়ালৈ লওক',
    'RentNow': 'এতিয়াই ভাড়ালৈ দিয়ক',
    'Reserve': 'আৰক্ষণ',
    'SeeSale': 'বিক্ৰী চাওক',
    'SaveNow': 'এতিয়াই সংৰক্ষণ কৰক',
    'Schedule': 'সময়সূচী',
    'SeeMenu': 'মেনু চাওক',
    'SeeMore': 'অধিক চাওক',
    'SeeOffer': 'অফাৰ চাওক',
    'SellNow': 'এতিয়াই বিক্ৰী কৰক',
    'ShopNow': 'এতিয়াই বজাৰ কৰক',
    'Showtimes': 'প্ৰদৰ্শনৰ সময়',
    'SignIn': 'ছাইন ইন কৰক',
    'SignUp': 'ছাইন আপ কৰক',
    'StartFree': 'বিনামূলীয়াকৈ আৰম্ভ কৰক',
    'StartNow': 'এতিয়াই আৰম্ভ কৰক',
    'Subscribe': 'ছাবস্ক্ৰাইব কৰক',
    'TestDrive': 'পৰীক্ষণমূলক গাড়ী চালনা',
    'TryNow': 'এতিয়াই কৰি চাওক',
    'UsedCars': 'ব্যৱহৃত গাড়ী',
    'ViewCars': 'গাড়ীসমূহ চাওক',
    'ViewNow': 'এতিয়াই চাওক',
    'ViewPlans': 'পৰিকল্পনাসমূহ চাওক',
    'VisitSite': 'ছাইটলৈ যাওক',
    'VoteNow': 'এতিয়াই ভোট দিয়ক',
    'Watch': 'ঘড়ী',
    'WatchMore': 'অধিক চাওক',
    'WatchNow': 'এতিয়াই চাওক',
    'Directions': 'নিৰ্দেশনাসমূহ',
    'FindStore': 'Store বিচাৰক',
    'SwitchNow': 'এতিয়াই সলনি কৰক',
    'VisitStore': 'Store-লৈ যাওক',
    'RenewNow': 'এতিয়াই নৱীকৰণ কৰক',
    'Reorder': 'পুনৰ অৰ্ডাৰ কৰক',
    'Buildnow': 'এতিয়াই নিৰ্মাণ কৰক',
    'Dealers': 'ডীলাৰ',
    'Getdemo': 'ডেম’ লাভ কৰক',
    'Getnow': 'এতিয়াই লাভ কৰক',
    'Gotodemo': 'ডেম’লৈ যাওক',
    'Seedemo': 'ডেম’ চাওক',
    'Seemodels': 'মডেলসমূহ চাওক',
    'Seeoffers': 'অফাৰ চাওক',
    'Viewdemo': 'ডেম’ চাওক',
    'CustomText': 'অনুকূলিত পাঠ',
    'Discover': 'আৱিষ্কাৰ কৰক',
    'Dismiss': 'অগ্ৰাহ্য কৰক',
  },
  'Azerbaijani': {
    'ActNow': 'İndi Hərəkət Et',
    'ApplyNow': 'İndi Tətbiq et',
    'BetNow': 'İndi Mərc et',
    'BidNow': 'İndi Təklif et',
    'BookACar': 'Maşın Rezervasiya et',
    'BookHotel': 'Otel Rezervasiya et',
    'BookNow': 'İndi Rezervasiya et',
    'Browse': 'Bax',
    'BuyNow': 'İndi Al',
    'ChatNow': 'İndi Söhbət et',
    'Compare': 'Müqayisə et',
    'ContactUs': 'Bizimlə Əlaqə Saxla',
    'GetCoupon': 'Kupon Əldə et',
    'Donate': 'İanə Et',
    'Download': 'Endir',
    'EmailNow': 'İndi E-poçt göndər',
    'EnrollNow': 'İndi Qeydiyyatdan keç',
    'Explore': 'Araşdır',
    'FileNow': 'Fayl İndi',
    'FindJob': 'İş Tap',
    'FreePlay': 'Pulsuz İfa et',
    'FreeQuote': 'Pulsuz Sitat',
    'FreeTrial': 'Pulsuz Sınaq',
    'GetDeals': 'Sövdələşmə Əldə et',
    'GetOffer': 'Təklif Əldə et',
    'GetQuote': 'Sitat Ədə et',
    'JoinNow': 'İndi Qoşul',
    'LearnMore': 'Ətraflı Məlumat',
    'ListenNow': 'İndi Dinlə',
    'LogIn': 'Daxil Ol',
    'Message': 'Mesaj',
    'NewCars': 'Yeni Maşınlar',
    'OrderNow': 'İndi Sifariş et',
    'PlayGame': 'Oyun Oyna',
    'PlayNow': 'İndi İfa et',
    'PostJob': 'Tapşırıq Göndər',
    'Register': 'Qeydiyyatdan keç',
    'RentACar': 'Maşın İcarəyə Ver',
    'RentNow': 'İndi İcarəyə Ver',
    'Reserve': 'Rezerv Et',
    'SeeSale': 'Satışa Bax',
    'SaveNow': 'İndi Saxla',
    'Schedule': 'Cədvəl',
    'SeeMenu': 'Menyuya Bax',
    'SeeMore': 'Daha Çoxuna Bax',
    'SeeOffer': 'Təklifə Bax',
    'SellNow': 'İndi Sat',
    'ShopNow': 'İndi Alış-veriş et',
    'Showtimes': 'Şou vaxtları',
    'SignIn': 'Daxil Ol',
    'SignUp': 'Qeydiyyatdan Keç',
    'StartFree': 'Pulsuz Başla',
    'StartNow': 'İndi Başla',
    'Subscribe': 'Abunə Ol',
    'TestDrive': 'Sınaq Sürüşü',
    'TryNow': 'İndi Sına',
    'UsedCars': 'İstifadə edilmiş Maşınlar',
    'ViewCars': 'Maşınlara Bax',
    'ViewNow': 'İndi Bax',
    'ViewPlans': 'Planlara Bax',
    'VisitSite': 'Sayta Daxil Ol',
    'VoteNow': 'İndi Səs Ver',
    'Watch': 'Bax',
    'WatchMore': 'Daha Çoxuna Bax',
    'WatchNow': 'İndi Bax',
    'Directions': 'İstiqamətlər',
    'FindStore': 'Mağaza Tap',
    'SwitchNow': 'İndi Keç',
    'VisitStore': 'Mağazanı Ziyarət Et',
    'RenewNow': 'İndi Yenilə',
    'Reorder': 'Yenidən Sifariş Et',
    'Buildnow': 'İndi Qur',
    'Dealers': 'Satıcılar',
    'Getdemo': 'Demo Əldə et',
    'Getnow': 'İndi Əldə et',
    'Gotodemo': 'Demoya keç',
    'Seedemo': 'Demoya bax',
    'Seemodels': 'Modellərə bax',
    'Seeoffers': 'Təkliflərə bax',
    'Viewdemo': 'Demoya bax',
    'CustomText': 'Fərdi Mətn',
    'Discover': 'Kəşf Et',
    'Dismiss': 'Bağla',
  },
  'Basque': {
    'ActNow': 'Egin orain',
    'ApplyNow': 'Aurkeztu zeure burua',
    'BetNow': 'Egin apustua',
    'BidNow': 'Egin eskaintza',
    'BookACar': 'Erreserbatu autoa',
    'BookHotel': 'Erreserbatu hotela',
    'BookNow': 'Erreserbatu orain',
    'Browse': 'Arakatu',
    'BuyNow': 'Erosi orain',
    'ChatNow': 'Txateatu orain',
    'Compare': 'Konparatu',
    'ContactUs': 'Jarri gurekin harremanetan',
    'GetCoupon': 'Eskuratu kupoia',
    'Donate': 'Eman',
    'Download': 'Deskargatu',
    'EmailNow': 'Bidali mezu elektronikoa',
    'EnrollNow': 'Eman izena orain',
    'Explore': 'Arakatu',
    'FileNow': 'Artxibatu orain',
    'FindJob': 'Bilatu lanpostua',
    'FreePlay': 'Doako jokoa',
    'FreeQuote': 'Doako aurrekontua',
    'FreeTrial': 'Doako proba',
    'GetDeals': 'Eskuratu aukerak',
    'GetOffer': 'Eskuratu eskaintza',
    'GetQuote': 'Eskuratu aurrekontua',
    'JoinNow': 'Sartu orain',
    'LearnMore': 'Informazio gehiago',
    'ListenNow': 'Entzun orain',
    'LogIn': 'Hasi saioa',
    'Message': 'Mezua',
    'NewCars': 'Auto berriak',
    'OrderNow': 'Eskatu orain',
    'PlayGame': 'Jokatu bideo-jokoa',
    'PlayNow': 'Jokatu orain',
    'PostJob': 'Argitaratu lanpostua',
    'Register': 'Erregistratu',
    'RentACar': 'Alokatu autoa',
    'RentNow': 'Alokatu orain',
    'Reserve': 'Erreserbatu',
    'SeeSale': 'Ikusi beherapena',
    'SaveNow': 'Gorde orain',
    'Schedule': 'Agenda',
    'SeeMenu': 'Ikusi menua',
    'SeeMore': 'Ikusi gehiago',
    'SeeOffer': 'Ikusi eskaintza',
    'SellNow': 'Saldu orain',
    'ShopNow': 'Erosi orain',
    'Showtimes': 'Emanaldi-ordutegia',
    'SignIn': 'Hasi saioa',
    'SignUp': 'Eman izena',
    'StartFree': 'Hasi doan',
    'StartNow': 'Hasi orain',
    'Subscribe': 'Harpidetu',
    'TestDrive': 'Probako bertsioa',
    'TryNow': 'Probatu Orain',
    'UsedCars': 'Erabilitako autoak',
    'ViewCars': 'Ikusi autoak',
    'ViewNow': 'Ikusi orain',
    'ViewPlans': 'Ikusi planak',
    'VisitSite': 'Ikusi gunea',
    'VoteNow': 'Bozkatu',
    'Watch': 'Ikusi',
    'WatchMore': 'Ikusi gehiago',
    'WatchNow': 'Ikusi orain',
    'Directions': 'Jarraibideak',
    'FindStore': 'Bilatu dena',
    'SwitchNow': 'Aldatu orain',
    'VisitStore': 'Bisitatu dena',
    'RenewNow': 'Berritu orain',
    'Reorder': 'Berriro eskatu',
    'Buildnow': 'Eraiki orain',
    'Dealers': 'Saltzaileak',
    'Getdemo': 'Eskuratu demoa',
    'Getnow': 'Eskuratu orain',
    'Gotodemo': 'Joan demora',
    'Seedemo': 'Ikusi demoa',
    'Seemodels': 'Ikusi modeloak',
    'Seeoffers': 'Ikusi eskaintzak',
    'Viewdemo': 'Ikusi demoa',
    'CustomText': 'Testu pertsonalizatua',
    'Discover': 'Aurkitu',
    'Dismiss': 'Baztertu',
  },
  'Bengali': {
    'ActNow': 'এখনই কাজ করুন',
    'ApplyNow': 'এখনই প্রয়োগ করুন',
    'BetNow': 'এখনই বাজি ধরুন',
    'BidNow': 'এখনই নিলাম ডাকুন',
    'BookACar': 'একটি গাড়ি বুক করুন',
    'BookHotel': 'হোটেল বুক করুন',
    'BookNow': 'এখনই বুক করুন',
    'Browse': 'ব্রাউজ করুন',
    'BuyNow': 'এখনই কিনুন',
    'ChatNow': 'এখনই চ্যাট করুন',
    'Compare': 'তুলনা করুন',
    'ContactUs': 'আমাদের সাথে যোগাযোগ করুন',
    'GetCoupon': 'কুপন পান',
    'Donate': 'দান করুন',
    'Download': 'ডাউনলোড করুন',
    'EmailNow': 'এখনই ইমেল করুন',
    'EnrollNow': 'এখনই নাম লেখান',
    'Explore': 'এক্সপ্লোর করুন',
    'FileNow': 'এখনই ফাইল করুন',
    'FindJob': 'কাজ খুঁজুন',
    'FreePlay': 'বিনামূল্যে খেলুন',
    'FreeQuote': 'বিনামূল্যে উদ্ধৃতি',
    'FreeTrial': 'বিনামূল্যের ট্রায়াল',
    'GetDeals': 'ডিলগুলি পান',
    'GetOffer': 'অফার পান',
    'GetQuote': 'উদ্ধৃতি পান',
    'JoinNow': 'এখনই যোগ দিন',
    'LearnMore': 'আরও জানুন',
    'ListenNow': 'এখনই শুনুন',
    'LogIn': 'লগ ইন করুন',
    'Message': 'বার্তা',
    'NewCars': 'নতুন গাড়িগুলি',
    'OrderNow': 'এখনই অর্ডার করুন',
    'PlayGame': 'গেম খেলুন',
    'PlayNow': 'এখনই বাজান',
    'PostJob': 'চাকরি পোস্ট করুন',
    'Register': 'নিবন্ধন করুন',
    'RentACar': 'একটি গাড়ি ভাড়া করুন',
    'RentNow': 'এখনই ভাড়া নিন',
    'Reserve': 'রিজার্ভ করুন',
    'SeeSale': 'বিক্রয় দেখুন',
    'SaveNow': 'এখনই সংরক্ষণ করুন',
    'Schedule': 'সময়সূচি',
    'SeeMenu': 'মেনু দেখুন',
    'SeeMore': 'আরও দেখুন',
    'SeeOffer': 'অফার দেখুন',
    'SellNow': 'এখনই বিক্রি করুন',
    'ShopNow': 'এখনই কেনাকাটা করুন',
    'Showtimes': 'শোটাইমগুলি',
    'SignIn': 'সাইন ইন করুন',
    'SignUp': 'সাইন আপ করুন',
    'StartFree': 'বিনামূল্যে শুরু করুন',
    'StartNow': 'এখনই শুরু করুন',
    'Subscribe': 'সদস্যতা নিন',
    'TestDrive': 'টেস্ট ড্রাইভ করুন',
    'TryNow': 'এখনই চেষ্টা করুন',
    'UsedCars': 'ব্যবহৃত গাড়িগুলি',
    'ViewCars': 'গাড়িগুলি দেখুন',
    'ViewNow': 'এখনই দর্শন করুন',
    'ViewPlans': 'প্ল্যানগুলি দর্শন করুন',
    'VisitSite': 'সাইটে যান',
    'VoteNow': 'এখনই ভোট দিন',
    'Watch': 'পর্যবেক্ষণ করুন',
    'WatchMore': 'আরো পর্যবেক্ষণ করুন',
    'WatchNow': 'এখনই পর্যবেক্ষণ করুন',
    'Directions': 'দিকনির্দেশ',
    'FindStore': 'Store খুঁজুন',
    'SwitchNow': 'এখনই স্যুইচ করুন',
    'VisitStore': 'Store-এ যান',
    'RenewNow': 'এখনই পুনর্নবীকরণ করুন',
    'Reorder': 'পুনরায় ক্রমসজ্জা করুন',
    'Buildnow': 'এখনই তৈরি করুন',
    'Dealers': 'ডিলাররা',
    'Getdemo': 'ডেমো পান',
    'Getnow': 'এখনই পান',
    'Gotodemo': 'ডেমোতে যান',
    'Seedemo': 'ডেমো দেখুন',
    'Seemodels': 'মডেলগুলি দেখুন',
    'Seeoffers': 'অফারগুলি দেখুন',
    'Viewdemo': 'ডেমো দেখুন',
    'CustomText': 'কাস্টম পাঠ্য',
    'Discover': 'আবিষ্কার করুন',
    'Dismiss': 'খারিজ করুন',
  },
  'Cambodian': {
    'ActNow': 'ធ្វើសកម្មភាពឥឡូវនេះ',
    'ApplyNow': 'អនុវត្តឥឡូវនេះ',
    'BetNow': 'ភ្នាល់ឥឡូវនេះ',
    'BidNow': 'ដេញថ្លៃឥឡូវនេះ',
    'BookACar': 'កក់ឡាន',
    'BookHotel': 'កក់សណ្ឋាគារ',
    'BookNow': 'កក់ឥឡូវនេះ',
    'Browse': 'រុករក',
    'BuyNow': 'ទិញឥឡូវនេះ',
    'ChatNow': 'ជជែកឥឡូវនេះ',
    'Compare': 'ប្រៀបធៀប',
    'ContactUs': 'ទាក់ទង​ពួក​យើង',
    'GetCoupon': 'យកគូប៉ុង',
    'Donate': 'បរិច្ចាគ',
    'Download': 'ទាញ​យក',
    'EmailNow': 'ផ្ញើអ៊ីម៉ែលឥឡូវនេះ',
    'EnrollNow': 'ចុះឈ្មោះឥឡូវនេះ',
    'Explore': 'ស្វែងយល់',
    'FileNow': 'ដាក់ឯកសារឥឡូវនេះ',
    'FindJob': 'ស្វែងរកការងារ',
    'FreePlay': 'លេងដោយឥតគិតថ្លៃ',
    'FreeQuote': 'ការដាក់តម្លៃឥតគិតថ្លៃ',
    'FreeTrial': 'សាកល្បង​ដោយឥតគិតថ្លៃ',
    'GetDeals': 'យកការព្រមព្រៀង',
    'GetOffer': 'យកការផ្តល់ជូន',
    'GetQuote': 'យកការដាក់តម្លៃ',
    'JoinNow': 'ចូលរួមឥឡូវនេះ',
    'LearnMore': 'ស្វែងយល់បន្ថែម',
    'ListenNow': 'ស្តាប់ឥឡូវនេះ',
    'LogIn': 'ចូលក្នុងប្រព័ន្ធ',
    'Message': 'សារ',
    'NewCars': 'ឡានថ្មី',
    'OrderNow': 'បញ្ជាទិញឥឡូវនេះ',
    'PlayGame': 'លេងហ្គេម',
    'PlayNow': 'លេងឥឡូវនេះ',
    'PostJob': 'សារដាក់ផ្សាយការងារ',
    'Register': 'ចុះឈ្មោះ',
    'RentACar': 'ជួលឡាន',
    'RentNow': 'ជួលឥឡូវនេះ',
    'Reserve': 'កក់ទុក',
    'SeeSale': 'មើលការលក់',
    'SaveNow': 'រក្សាទុកឥឡូវនេះ',
    'Schedule': 'កាលវិភាគ',
    'SeeMenu': 'មើលម៉ឺនុយ',
    'SeeMore': 'មើល​ច្រើនទៀត',
    'SeeOffer': 'មើលការផ្តល់ជូន',
    'SellNow': 'លក់ឥឡូវនេះ',
    'ShopNow': 'ទិញទំនិញឥឡូវនេះ',
    'Showtimes': 'ពេលបញ្ចាំង',
    'SignIn': 'ចុះ​ឈ្មោះ​ចូល',
    'SignUp': 'ចុះឈ្មោះប្រើ',
    'StartFree': 'ចាប់ផ្តើមដោយឥតគិតថ្លៃ',
    'StartNow': 'ចាប់ផ្តើមឥឡូវនេះ',
    'Subscribe': 'ជាវ',
    'TestDrive': 'បើកបរសាកល្បង',
    'TryNow': 'សាកល្បងប្រើឥឡូវនេះ',
    'UsedCars': 'ឡានប្រើរួច',
    'ViewCars': 'មើលឡាន',
    'ViewNow': 'មើលឥឡូវនេះ',
    'ViewPlans': 'មើលផែនការ',
    'VisitSite': 'ចូលទៅកាន់ទំព័រវិប',
    'VoteNow': 'បោះឆ្នោតឥឡូវនេះ',
    'Watch': 'មើល',
    'WatchMore': 'មើលច្រើនទៀត',
    'WatchNow': 'មើលឥឡូវនេះ',
    'Directions': 'ទិសដៅ',
    'FindStore': 'ស្វែងរកហាង',
    'SwitchNow': 'ប្ដូរឥឡូវនេះ',
    'VisitStore': 'មើលហាង',
    'RenewNow': 'បន្តឡើងវិញឥឡូវនេះ',
    'Reorder': 'រៀបតាមលំដាប់ឡើងវិញ',
    'Buildnow': 'បង្កើតឥឡូវនេះ',
    'Dealers': 'ឈ្មួញ',
    'Getdemo': 'យកការបង្ហាញ',
    'Getnow': 'យក​ឥឡូវនេះ',
    'Gotodemo': 'ចូលទៅកាន់ការសាកល្បង',
    'Seedemo': 'មើលការសាកល្បង',
    'Seemodels': 'មើលម៉ូដែល',
    'Seeoffers': 'មើលការផ្តល់ជូន',
    'Viewdemo': 'មើលការសាកល្បង',
    'CustomText': 'អត្ថបទផ្ទាល់ខ្លួន',
    'Discover': 'រកឃើញ',
    'Dismiss': 'បោះបង់',
  },
  'Galician': {
    'ActNow': 'Actuar agora',
    'ApplyNow': 'Aplicar agora',
    'BetNow': 'Apostar agora',
    'BidNow': 'Poxar agora',
    'BookACar': 'Reservar un coche',
    'BookHotel': 'Reservar hotel',
    'BookNow': 'Reservar agora',
    'Browse': 'Explorar',
    'BuyNow': 'Comprar agora',
    'ChatNow': 'Chatear agora',
    'Compare': 'Comparar',
    'ContactUs': 'Ponte en contacto connosco',
    'GetCoupon': 'Obter cupón',
    'Donate': 'Doar',
    'Download': 'Descargar',
    'EmailNow': 'Enviar correo electrónico agora',
    'EnrollNow': 'Matricularse agora',
    'Explore': 'Explorar',
    'FileNow': 'Arquivar agora',
    'FindJob': 'Buscar traballo',
    'FreePlay': 'Xogo gratis',
    'FreeQuote': 'Orzamento gratis',
    'FreeTrial': 'Proba gratuíta',
    'GetDeals': 'Obter ofertas',
    'GetOffer': 'Obter oferta',
    'GetQuote': 'Obter orzamento',
    'JoinNow': 'Unirse agora',
    'LearnMore': 'Máis información',
    'ListenNow': 'Escoitar agora',
    'LogIn': 'Iniciar sesión',
    'Message': 'Mensaxe',
    'NewCars': 'Novos coches',
    'OrderNow': 'Pedir agora',
    'PlayGame': 'Xogar',
    'PlayNow': 'Xogar agora',
    'PostJob': 'Publicar traballo',
    'Register': 'Rexistrarse',
    'RentACar': 'Alugar un coche',
    'RentNow': 'Alugar agora',
    'Reserve': 'Reservar',
    'SeeSale': 'Ver rebaixa',
    'SaveNow': 'Gardar agora',
    'Schedule': 'Programar',
    'SeeMenu': 'Ver menú',
    'SeeMore': 'Ver máis',
    'SeeOffer': 'Ver oferta',
    'SellNow': 'Vender agora',
    'ShopNow': 'Comprar agora',
    'Showtimes': 'Horarios',
    'SignIn': 'Iniciar sesión',
    'SignUp': 'Rexistrarse',
    'StartFree': 'Comezar gratis',
    'StartNow': 'Comezar agora',
    'Subscribe': 'Subscribirse',
    'TestDrive': 'Versión de proba',
    'TryNow': 'Probar agora',
    'UsedCars': 'Coches usados',
    'ViewCars': 'Ver coches',
    'ViewNow': 'Ver agora',
    'ViewPlans': 'Ver plans',
    'VisitSite': 'Visitar sitio',
    'VoteNow': 'Votar agora',
    'Watch': 'Ver',
    'WatchMore': 'Ver máis',
    'WatchNow': 'Ver agora',
    'Directions': 'Indicacións',
    'FindStore': 'Atopar tenda',
    'SwitchNow': 'Cambiar agora',
    'VisitStore': 'Visitar tenda',
    'RenewNow': 'Renovar agora',
    'Reorder': 'Volver facer o pedido',
    'Buildnow': 'Compilar agora',
    'Dealers': 'Distribuidores',
    'Getdemo': 'Obter demo',
    'Getnow': 'Obter agora',
    'Gotodemo': 'Ir á demo',
    'Seedemo': 'Ver demo',
    'Seemodels': 'Ver modelos',
    'Seeoffers': 'Ver ofertas',
    'Viewdemo': 'Ver demo',
    'CustomText': 'Texto personalizado',
    'Discover': 'Descubrir',
    'Dismiss': 'Rexeitar',
  },
  'Georgian': {
    'ActNow': 'იმოქმედეთ ახლა',
    'ApplyNow': 'გამოიყენეთ ახლა',
    'BetNow': 'ფსონის გაკეთება ახლა',
    'BidNow': 'ფსონის დადება ახლა',
    'BookACar': 'მანქანის დაჯავშნა',
    'BookHotel': 'სასტუმროს დაჯავშნა',
    'BookNow': 'დაჯავშნეთ ახლა',
    'Browse': 'დათვალიერება',
    'BuyNow': 'ახლავე ყიდვა',
    'ChatNow': 'საუბარი ახლა',
    'Compare': 'შედარება',
    'ContactUs': 'დაგვიკავშირდით',
    'GetCoupon': 'ვაუჩერის მიღება',
    'Donate': 'ქველმოქმედება',
    'Download': 'ჩამოტვირთვა',
    'EmailNow': 'ელწერილის გაგზავნა ახლა',
    'EnrollNow': 'დარეგისტრირდით ახლა',
    'Explore': 'დათვალიერება',
    'FileNow': 'ფაილის გაგზავნა ახლა',
    'FindJob': 'სამსახურის ძებნა',
    'FreePlay': 'უფასო თამაში',
    'FreeQuote': 'უფასო ციტატა',
    'FreeTrial': 'უფასო საცდელი ვერსია',
    'GetDeals': 'გარიგებების ჩატვირთვა',
    'GetOffer': 'შეთავაზების მიღება',
    'GetQuote': 'ციტატის ჩატვირთვა',
    'JoinNow': 'გაწევრიანება ახლა',
    'LearnMore': 'შეიტყვეთ მეტი',
    'ListenNow': 'მოუსმინეთ ახლა',
    'LogIn': 'ავტორიზაცია',
    'Message': 'შეტყობინება',
    'NewCars': 'ახალი მანქანები',
    'OrderNow': 'შეუკვეთეთ ახლა',
    'PlayGame': 'თამაშის თამაში',
    'PlayNow': 'ითამაშეთ ახლა',
    'PostJob': 'ვაკანსიის გამოქვეყნება',
    'Register': 'დარეგისტრირება',
    'RentACar': 'მანქანის დაქირავება',
    'RentNow': 'იქირავეთ ახლა',
    'Reserve': 'დაჯავშნა',
    'SeeSale': 'ფასდაკლების ნახვა',
    'SaveNow': 'შენახვა ახლა',
    'Schedule': 'გრაფიკი',
    'SeeMenu': 'მენიუს ნახვა',
    'SeeMore': 'მეტის ნახვა',
    'SeeOffer': 'შეთავაზების ნახვა',
    'SellNow': 'გაყიდეთ ახლა',
    'ShopNow': 'შეიძინეთ ახლა',
    'Showtimes': 'გადაცემის დროები',
    'SignIn': 'შესვლა',
    'SignUp': 'რეგისტრაცია',
    'StartFree': 'დაიწყეთ უფასოდ',
    'StartNow': 'დაიწყეთ ახლა',
    'Subscribe': 'გამოწერა',
    'TestDrive': 'სატესტო ტარება',
    'TryNow': 'სცადეთ ახლა',
    'UsedCars': 'მეორადი მანქანები',
    'ViewCars': 'მანქანების ნახვა',
    'ViewNow': 'ნახვა ახლა',
    'ViewPlans': 'გეგმების ნახვა',
    'VisitSite': 'ვებსაიტის მონახულება',
    'VoteNow': 'ხმის მიცემა ახლა',
    'Watch': 'ყურება',
    'WatchMore': 'მეტის ყურება',
    'WatchNow': 'ყურება ახლა',
    'Directions': 'მიმართულებები',
    'FindStore': 'მაღაზიის ძებნა',
    'SwitchNow': 'გადართვა ახლა',
    'VisitStore': 'მაღაზიის ნახვა',
    'RenewNow': 'განახლება ახლა',
    'Reorder': 'გადალაგება',
    'Buildnow': 'აწყობა ახლა',
    'Dealers': 'დილერები',
    'Getdemo': 'სადემონსტრაციო ვერსიის ჩატვირთვა',
    'Getnow': 'მიიღეთ ახლა',
    'Gotodemo': 'სადემონსტრაციო ვერსიაზე გადასვლა',
    'Seedemo': 'სადემონსტრაციო ვერსიის ნახვა',
    'Seemodels': 'მოდელების ნახვა',
    'Seeoffers': 'შეთავაზებების ნახვა',
    'Viewdemo': 'სადემონსტრაციო ვერსიის ნახვა',
    'CustomText': 'მორგებული ტექსტი',
    'Discover': 'აღმოაჩინეთ',
    'Dismiss': 'დახურვა',
  },
  'Gujarati': {
    'ActNow': 'હમણાં જ કાર્ય કરો',
    'ApplyNow': 'હમણાં જ લાગુ કરો',
    'BetNow': 'હમણાં જ બેટ કરો',
    'BidNow': 'હમણાં જ બિડ કરો',
    'BookACar': 'કાર બુક કરો',
    'BookHotel': 'હોટેલ બુક કરો',
    'BookNow': 'હમણાં જ બુક કરો',
    'Browse': 'બ્રાઉઝ કરો',
    'BuyNow': 'હમણાં જ ખરીદો',
    'ChatNow': 'હમણાં જ ચૅટ કરો',
    'Compare': 'તુલના કરો',
    'ContactUs': 'અમારો સંપર્ક કરો',
    'GetCoupon': 'કૂપન મેળવો',
    'Donate': 'દાન કરો',
    'Download': 'ડાઉનલોડ કરો',
    'EmailNow': 'હમણાં જ ઈમેલ કરો',
    'EnrollNow': 'હમણાં જ નોંધણી કરાવો',
    'Explore': 'એક્સપ્લોર કરો',
    'FileNow': 'હમણાં જ ફાઇલ કરો',
    'FindJob': 'જૉબ શોધો',
    'FreePlay': 'મફત ચલાવો',
    'FreeQuote': 'મફત ક્વોટ',
    'FreeTrial': 'મફત અજમાયશ',
    'GetDeals': 'ડિલ્સ મેળવો',
    'GetOffer': 'ઑફર મેળવો',
    'GetQuote': 'ક્વોટ મેળવો',
    'JoinNow': 'હમણાં જ જોડાઓ',
    'LearnMore': 'વધુ જાણો',
    'ListenNow': 'હમણાં જ સાંભળો',
    'LogIn': 'લૉગ ઇન કરો',
    'Message': 'સંદેશ',
    'NewCars': 'નવી કાર્સ',
    'OrderNow': 'હમણાં જ ઑર્ડર આપો',
    'PlayGame': 'રમત રમો',
    'PlayNow': 'હમણાં જ ચલાવો',
    'PostJob': 'જૉબ પોસ્ટ કરો',
    'Register': 'નોંધણી કરાવો',
    'RentACar': 'કાર ભાડે લો',
    'RentNow': 'હમણાં જ ભાડે લો',
    'Reserve': 'આરક્ષિત કરો',
    'SeeSale': 'વેચાણ જુઓ',
    'SaveNow': 'હમણાં જ સાચવો',
    'Schedule': 'શેડ્યૂલ કરો',
    'SeeMenu': 'મેનૂ જુઓ',
    'SeeMore': 'વધુ જુઓ',
    'SeeOffer': 'ઑફર જુઓ',
    'SellNow': 'હમણાં જ વેચો',
    'ShopNow': 'હમણાં જ ખરીદો',
    'Showtimes': 'શૉટાઇમ્સ',
    'SignIn': 'સાઇન ઇન કરો',
    'SignUp': 'સાઇન અપ કરો',
    'StartFree': 'મફતમાં પ્રારંભ કરો',
    'StartNow': 'હમણાં જ પ્રારંભ કરો',
    'Subscribe': 'સદસ્યતા લો',
    'TestDrive': 'ટેસ્ટ ડ્રાઇવ',
    'TryNow': 'હમણાં જ અજમાવો',
    'UsedCars': 'ઉપયોગમાં લેવાયેલ કાર્સ',
    'ViewCars': 'કાર્સ જુઓ',
    'ViewNow': 'હમણાં જ જુઓ',
    'ViewPlans': 'પ્લાન્સ જુઓ',
    'VisitSite': 'સાઇટની મુલાકાત લો',
    'VoteNow': 'હમણાં જ મત આપો',
    'Watch': 'જુઓ',
    'WatchMore': 'વધુ જુઓ',
    'WatchNow': 'હમણાં જ જુઓ',
    'Directions': 'દિશાનિર્દેશો',
    'FindStore': 'સ્ટોર શોધો',
    'SwitchNow': 'હમણાં જ સ્વિચ કરો',
    'VisitStore': 'સ્ટોરની મુલાકાત લો',
    'RenewNow': 'હમણાં જ નવીનીકૃત કરો',
    'Reorder': 'પુનઃક્રમાંકિત કરો',
    'Buildnow': 'હમણાં જ બનાવો',
    'Dealers': 'ડીલર્સ',
    'Getdemo': 'ડેમો મેળવો',
    'Getnow': 'હમણાં જ મેળવો',
    'Gotodemo': 'ડેમો પર જાઓ',
    'Seedemo': 'ડેમો જુઓ',
    'Seemodels': 'મૉડલ્સ જુઓ',
    'Seeoffers': 'ઑફર્સ જુઓ',
    'Viewdemo': 'ડેમો જુઓ',
    'CustomText': 'કસ્ટમ ટેક્સ્ટ',
    'Discover': 'શોધો',
    'Dismiss': 'કાઢી નાખો',
  },
  'Kannada': {
    'ActNow': 'ಈಗ ಕ್ರಮಕೈಗೊಳ್ಳಿ',
    'ApplyNow': 'ಈಗ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ',
    'BetNow': 'ಈಗ ಬೆಟ್ ಮಾಡಿ',
    'BidNow': 'ಈಗ ಬಿಡ್ ಮಾಡಿ',
    'BookACar': 'ಕಾರನ್ನು ಬುಕ್ ಮಾಡಿ',
    'BookHotel': 'ಹೋಟೆಲ್ ಬುಕ್‌ ಮಾಡಿ',
    'BookNow': 'ಈಗ ಬುಕ್ ಮಾಡಿ',
    'Browse': 'ಬ್ರೌಸ್ ಮಾಡಿ',
    'BuyNow': 'ಈಗ ಖರೀದಿಸಿ',
    'ChatNow': 'ಈಗ ಚಾಟ್ ಮಾಡಿ',
    'Compare': 'ಹೋಲಿಸಿ',
    'ContactUs': 'ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ',
    'GetCoupon': 'ಕೂಪನ್ ಪಡೆಯಿರಿ',
    'Donate': 'ದಾನ ಮಾಡಿ',
    'Download': 'ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
    'EmailNow': 'ಈಗ ಇಮೇಲ್ ಮಾಡಿ',
    'EnrollNow': 'ಈಗ ನೋಂದಾಯಿಸಿ',
    'Explore': 'ಅನ್ವೇಷಿಸಿ',
    'FileNow': 'ಈಗ ಫೈಲ್‌ ಮಾಡಿ',
    'FindJob': 'ಉದ್ಯೋಗ ಹುಡುಕಿ',
    'FreePlay': 'ಉಚಿತ ಆಟ',
    'FreeQuote': 'ಉಚಿತ ಕೋಟ್',
    'FreeTrial': 'ಉಚಿತ ಪ್ರಯೋಗ',
    'GetDeals': 'ಡೀಲ್‌ಗಳನ್ನು ಪಡೆಯಿರಿ',
    'GetOffer': 'ಕೊಡುಗೆ ಪಡೆಯಿರಿ',
    'GetQuote': 'ಕೋಟ್ ಪಡೆಯಿರಿ',
    'JoinNow': 'ಈಗ ಸೇರಿ',
    'LearnMore': 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
    'ListenNow': 'ಈಗ ಆಲಿಸಿ',
    'LogIn': 'ಲಾಗ್ ಇನ್ ಮಾಡಿ',
    'Message': 'ಸಂದೇಶ',
    'NewCars': 'ಹೊಸ ಕಾರುಗಳು',
    'OrderNow': 'ಈಗ ಆರ್ಡರ್‌ ಮಾಡಿ',
    'PlayGame': 'ಆಟ ಆಡಿ',
    'PlayNow': 'ಈಗ ಆಟ ಆಡಿ',
    'PostJob': 'ಉದ್ಯೋಗ ಪೋಸ್ಟ್‌ ಮಾಡಿ',
    'Register': 'ನೋಂದಾಯಿಸಿ',
    'RentACar': 'ಕಾರನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ',
    'RentNow': 'ಈಗ ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ',
    'Reserve': 'ಕಾಯ್ದಿರಿಸಿ',
    'SeeSale': 'ಮಾರಾಟ ನೋಡಿ',
    'SaveNow': 'ಈಗ ಉಳಿಸಿ',
    'Schedule': 'ವೇಳಾಪಟ್ಟಿ',
    'SeeMenu': 'ಮೆನು ನೋಡಿ',
    'SeeMore': 'ಇನ್ನಷ್ಟು ನೋಡಿ',
    'SeeOffer': 'ಕೊಡುಗೆ ನೋಡಿ',
    'SellNow': 'ಈಗ ಮಾರಾಟ ಮಾಡಿ',
    'ShopNow': 'ಈಗ ಶಾಪಿಂಗ್ ಮಾಡಿ',
    'Showtimes': 'Showtimes',
    'SignIn': 'ಸೈನ್ ಇನ್ ಮಾಡಿ',
    'SignUp': 'ಸೈನ್ ಅಪ್ ಮಾಡಿ',
    'StartFree': 'ಉಚಿತವಾಗಿ ಪ್ರಾರಂಭಿಸಿ',
    'StartNow': 'ಈಗ ಪ್ರಾರಂಭಿಸಿ',
    'Subscribe': 'ಚಂದಾದಾರರಾಗಿ',
    'TestDrive': 'ಟೆಸ್ಟ್ ಡ್ರೈವ್',
    'TryNow': 'ಈಗ ಪ್ರಯತ್ನಿಸಿ',
    'UsedCars': 'ಬಳಸಿದ ಕಾರುಗಳು',
    'ViewCars': 'ಕಾರುಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    'ViewNow': 'ಈಗ ವೀಕ್ಷಿಸಿ',
    'ViewPlans': 'ಯೋಜನೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
    'VisitSite': 'ಸೈಟ್‌ಗೆ ಭೇಟಿ ನೀಡಿ',
    'VoteNow': 'ಈಗ ಮತ ಚಲಾಯಿಸಿ',
    'Watch': 'ವೀಕ್ಷಿಸಿ',
    'WatchMore': 'ಇನ್ನಷ್ಟು ವೀಕ್ಷಿಸಿ',
    'WatchNow': 'ಈಗ ವೀಕ್ಷಿಸಿ',
    'Directions': 'ನಿರ್ದೇಶನಗಳು',
    'FindStore': 'ಸ್ಟೋರ್ ಹುಡುಕಿ',
    'SwitchNow': 'ಇದೀಗ ಬದಲಿಸಿ',
    'VisitStore': 'ಸ್ಟೋರ್‌ಗೆ ಭೇಟಿ ನೀಡಿ',
    'RenewNow': 'ಈಗ ನವೀಕರಿಸಿ',
    'Reorder': 'ಮರುಕ್ರಮಗೊಳಿಸಿ',
    'Buildnow': 'ಈಗ ನಿರ್ಮಿಸಿ',
    'Dealers': 'ಡೀಲರ್‌ಗಳು',
    'Getdemo': 'ಪ್ರಾತ್ಯಕ್ಷಿಕೆ ಪಡೆಯಿರಿ',
    'Getnow': 'ಈಗ ಪಡೆಯಿರಿ',
    'Gotodemo': 'ಪ್ರಾತ್ಯಕ್ಷಿಕೆಗೆ ಹೋಗಿ',
    'Seedemo': 'ಪ್ರಾತ್ಯಕ್ಷಿಕೆ ನೋಡಿ',
    'Seemodels': 'ಮಾದರಿಗಳನ್ನು ನೋಡಿ',
    'Seeoffers': 'ಕೊಡುಗೆಗಳನ್ನು ನೋಡಿ',
    'Viewdemo': 'ಪ್ರಾತ್ಯಕ್ಷಿಕೆ ವೀಕ್ಷಿಸಿ',
    'CustomText': 'ಕಸ್ಟಮ್‌ ಪಠ್ಯ',
    'Discover': 'ಅನ್ವೇಷಿಸಿ',
    'Dismiss': 'ವಜಾಗೊಳಿಸಿ',
  },
  'Kazakh': {
    'ActNow': 'Қазір әрекет ету',
    'ApplyNow': 'Қазір өтінім беру',
    'BetNow': 'Қазір бәс тігу',
    'BidNow': 'Қазір баға ұсыну',
    'BookACar': 'Көлікті брондау',
    'BookHotel': 'Қонақүйді брондау',
    'BookNow': 'Қазір брондау',
    'Browse': 'Шолу',
    'BuyNow': 'Қазір сатып алу',
    'ChatNow': 'Қазір сөйлесу',
    'Compare': 'Салыстыру',
    'ContactUs': 'Бізге хабарласу',
    'GetCoupon': 'Купон алу',
    'Donate': 'Жарна жіберу',
    'Download': 'Жүктеп алу',
    'EmailNow': 'Қазір электрондық хат жіберу',
    'EnrollNow': 'Қазір тіркелу',
    'Explore': 'Зерттеу',
    'FileNow': 'Қазір тіркеу',
    'FindJob': 'Жұмыс табу',
    'FreePlay': 'Тегін ойнау',
    'FreeQuote': 'Тегін баға ұсынысы',
    'FreeTrial': 'Тегін сынақ нұсқасы',
    'GetDeals': 'Мәмілелерді алу',
    'GetOffer': 'Ұсыныс алу',
    'GetQuote': 'Баға ұсынысын алу',
    'JoinNow': 'Қазір қосылу',
    'LearnMore': 'Қосымша мәліметтер',
    'ListenNow': 'Қазір тыңдау',
    'LogIn': 'Кіру',
    'Message': 'Хабар',
    'NewCars': 'Жаңа көліктер',
    'OrderNow': 'Қазір тапсырыс беру',
    'PlayGame': 'Ойын ойнау',
    'PlayNow': 'Қазір ойнау',
    'PostJob': 'Жұмысты жариялау',
    'Register': 'Тіркелу',
    'RentACar': 'Көлікті жалға алу',
    'RentNow': 'Қазір жалға алу',
    'Reserve': 'Резервтеу',
    'SeeSale': '“Сату” бөлімін көру',
    'SaveNow': 'Қазір сақтау',
    'Schedule': 'Кесте',
    'SeeMenu': 'Мәзірді көру',
    'SeeMore': 'Көбірек көру',
    'SeeOffer': 'Ұсынысты көру',
    'SellNow': 'Қазір сату',
    'ShopNow': 'Қазір сатыпы алу',
    'Showtimes': 'Көрсетілім уақыттары',
    'SignIn': 'Кіру',
    'SignUp': 'Тіркелу',
    'StartFree': 'Тегін бастау',
    'StartNow': 'Қазір бастау',
    'Subscribe': 'Жазылу',
    'TestDrive': 'Сынақ шығарылымы',
    'TryNow': 'Қазір қолданып көру',
    'UsedCars': 'Пайдаланылған көліктер',
    'ViewCars': 'Көліктерді көру',
    'ViewNow': 'Қазір көру',
    'ViewPlans': 'Жоспарларды көру',
    'VisitSite': 'Сайтқа кіру',
    'VoteNow': 'Қазір дауыс беру',
    'Watch': 'Көру',
    'WatchMore': 'Көбірек көру',
    'WatchNow': 'Қазір көру',
    'Directions': 'Бағыттар',
    'FindStore': 'Дүкенді табу',
    'SwitchNow': 'Қазір ауысу',
    'VisitStore': 'Дүкенге бару',
    'RenewNow': 'Қазір жаңарту',
    'Reorder': 'Ретін өзгерту',
    'Buildnow': 'Қазір құрастыру',
    'Dealers': 'Дилерлер',
    'Getdemo': 'Демо нұсқаны алу',
    'Getnow': 'Қазір алу',
    'Gotodemo': 'Демо нұсқаға өту',
    'Seedemo': 'Демо нұсқаны көру',
    'Seemodels': 'Үлгілерді көру',
    'Seeoffers': 'Ұсыныстарды көру',
    'Viewdemo': 'Демо нұсқаны көру',
    'CustomText': 'Реттелетін мәтін',
    'Discover': 'Анықтау',
    'Dismiss': 'Жабу',
  },
  'Laotian': {
    'ActNow': 'ດຳເນີນການດຽວນີ້',
    'ApplyNow': 'ນຳໃຊ້ດຽວນີ້',
    'BetNow': 'ເດີມພັນດຽວນີ້',
    'BidNow': 'ປະມູນດຽວນີ້',
    'BookACar': 'ຈອງລົດ',
    'BookHotel': 'ຈອງໂຮງແຮມ',
    'BookNow': 'ຈອງດຽວນີ້',
    'Browse': 'ເລືອກເບິ່ງ',
    'BuyNow': 'ຊື້ດຽວນີ້',
    'ChatNow': 'ແຊັດດຽວນີ້',
    'Compare': 'ປຽບ​ທຽບ',
    'ContactUs': 'ຕິດ​ຕໍ່​ພວກ​ເຮົາ',
    'GetCoupon': 'ຮັບຄູປ໋ອງ',
    'Donate': 'ບໍ​ລິ​ຈາກ',
    'Download': 'ດາວໂຫຼດ',
    'EmailNow': 'ສົ່ງອີເມວດຽວນີ້',
    'EnrollNow': 'ລົງທະບຽນດຽວນີ້',
    'Explore': 'ສຳຫຼວດ',
    'FileNow': 'ໄຟລ໌ດຽວນີ້',
    'FindJob': 'ຊອກ​ຫາວຽກ',
    'FreePlay': 'ຫຼິ້ນຟ​ຣີ',
    'FreeQuote': 'ໃບສະເຫນີຟ​ຣີ',
    'FreeTrial': 'ການທົດລອງໃຊ້',
    'GetDeals': 'ຮັບຂໍ້ສະເໜີ',
    'GetOffer': 'ຮັບຂໍ້ສະເຫນີ',
    'GetQuote': 'ຮັບໃບສະເຫນີລາຄາ',
    'JoinNow': 'ເຂົ້າ​ຮ່ວມ​ດຽວ​ນີ້',
    'LearnMore': 'ສຶກສາເພີ່ມເຕີມ',
    'ListenNow': 'ຟັງດຽວນີ້',
    'LogIn': 'ເຂົ້າ​ສູ່​ລະ​ບົບ',
    'Message': 'ຂໍ້ຄວາມ',
    'NewCars': 'ລົດໃໝ່',
    'OrderNow': 'ສັ່ງດຽວນີ້',
    'PlayGame': 'ຫຼີ້ນ​ເກມ',
    'PlayNow': 'ຫຼິ້ນດຽວນີ້',
    'PostJob': 'ປະກາດວຽກ',
    'Register': 'ລົງທະບຽນ',
    'RentACar': 'ເຊົ່າ​ລົດ',
    'RentNow': 'ເຊົ່າດຽວນີ້',
    'Reserve': 'ຈອງ',
    'SeeSale': 'ເບິ່ງການຂາຍ',
    'SaveNow': 'ບັນທຶກດຽວນີ້',
    'Schedule': 'ກຳນົດການ',
    'SeeMenu': 'ເບິ່ງເມນູ',
    'SeeMore': 'ເບິ່ງເພີ່ມເຕີມ',
    'SeeOffer': 'ເບິ່ງຂໍ້ສະເຫນີ',
    'SellNow': 'ຂາຍດຽວນີ້',
    'ShopNow': 'ຊື້ດຽວນີ້',
    'Showtimes': 'ເວລາສາຍ',
    'SignIn': 'ລົງຊື່ເຂົ້າໃຊ້',
    'SignUp': 'ລົງ​ທະ​ບຽນ',
    'StartFree': 'ເລີ່ມຟຣີ',
    'StartNow': 'ເລີ່ມ​ດຽວ​ນີ້',
    'Subscribe': 'ສະໝັກໃຊ້',
    'TestDrive': 'ທົດສອບຂັບ',
    'TryNow': 'ລອງດຽວນີ້',
    'UsedCars': 'ລົດມື​ສອງ',
    'ViewCars': 'ເບິ່ງລົດ',
    'ViewNow': 'ເບິ່ງຕອນນີ້',
    'ViewPlans': 'ເບິ່ງແຜນ',
    'VisitSite': 'ຢ້ຽມຢາມເວັບໄຊ',
    'VoteNow': 'ໂຫວດດຽວນີ້',
    'Watch': 'ເບິ່ງ',
    'WatchMore': 'ເບິ່ງເພີ່ມເຕີມ',
    'WatchNow': 'ເບິ່ງດຽວນີ້',
    'Directions': 'ທິດທາງ',
    'FindStore': 'ຊອກ​ຫາຮ້ານຄ້າ',
    'SwitchNow': 'ສັບປ່ຽນດຽວນີ້',
    'VisitStore': 'ເຂົ້າເບິ່ງຮ້ານຄ້າ',
    'RenewNow': 'ຕໍ່ອາຍຸດຽວນີ້',
    'Reorder': 'ຈັດຮຽງໃໝ່',
    'Buildnow': 'ສ້າງດຽວນີ້',
    'Dealers': 'ຕົວແທນຈໍາຫນ່າຍ',
    'Getdemo': 'ຮັບເດໂມ',
    'Getnow': 'ຮັບດຽວນີ້',
    'Gotodemo': 'ໄປທີ່ ເດໂມ',
    'Seedemo': 'ເບິ່ງເດໂມ',
    'Seemodels': 'ເບິ່ງໂມເດວ',
    'Seeoffers': 'ເບິ່ງຂໍ້ສະເຫນີ',
    'Viewdemo': 'ມຸມມອງເດໂມ',
    'CustomText': 'ຂໍ້ຄວາມກຳນົດເອງ',
    'Discover': 'ຄົ້ນພົບ',
    'Dismiss': 'ປ່ອຍໄປ',
  },
  'Malay': {
    'ActNow': 'Bertindak Sekarang',
    'ApplyNow': 'Gunakan Sekarang',
    'BetNow': 'Bertaruh Sekarang',
    'BidNow': 'Bida Sekarang',
    'BookACar': 'Tempah Kereta',
    'BookHotel': 'Tempah Hotel',
    'BookNow': 'Tempah Sekarang',
    'Browse': 'Semak Lalu',
    'BuyNow': 'Beli Sekarang',
    'ChatNow': 'Sembang Sekarang',
    'Compare': 'Bandingkan',
    'ContactUs': 'Hubungi Kami',
    'GetCoupon': 'Dapatkan Kupon',
    'Donate': 'Derma',
    'Download': 'Muat Turun',
    'EmailNow': 'E-mel Sekarang',
    'EnrollNow': 'Daftar Sekarang',
    'Explore': 'Jelajah',
    'FileNow': 'Failkan Sekarang',
    'FindJob': 'Cari Kerja',
    'FreePlay': 'Main Percuma',
    'FreeQuote': 'Petikan Percuma',
    'FreeTrial': 'Percubaan Percuma',
    'GetDeals': 'Dapatkan Tawaran',
    'GetOffer': 'Dapatkan Tawaran',
    'GetQuote': 'Dapatkan Petikan',
    'JoinNow': 'Sertai Sekarang',
    'LearnMore': 'Ketahui Lebih Lanjut',
    'ListenNow': 'Dengar Sekarang',
    'LogIn': 'Log Masuk',
    'Message': 'Mesej',
    'NewCars': 'Kereta Baharu',
    'OrderNow': 'Pesan Sekarang',
    'PlayGame': 'Main Permainan',
    'PlayNow': 'Main Sekarang',
    'PostJob': 'Siarkan Kerja',
    'Register': 'Daftar',
    'RentACar': 'Sewa Kereta',
    'RentNow': 'Sewa Sekarang',
    'Reserve': 'Tempah',
    'SeeSale': 'Lihat Jualan',
    'SaveNow': 'Simpan Sekarang',
    'Schedule': 'Jadual',
    'SeeMenu': 'Lihat Menu',
    'SeeMore': 'Lihat Lagi',
    'SeeOffer': 'Lihat Tawaran',
    'SellNow': 'Jual Sekarang',
    'ShopNow': 'Beli Sekarang',
    'Showtimes': 'Masa tayangan',
    'SignIn': 'Daftar Masuk',
    'SignUp': 'Mendaftar',
    'StartFree': 'Mulakan Secara Percuma',
    'StartNow': 'Mula Sekarang',
    'Subscribe': 'Melanggan',
    'TestDrive': 'Pandu Uji',
    'TryNow': 'Cuba Sekarang',
    'UsedCars': 'Kereta Terpakai',
    'ViewCars': 'Lihat Kereta',
    'ViewNow': 'Lihat Sekarang',
    'ViewPlans': 'Lihat Pelan',
    'VisitSite': 'Lawati Laman',
    'VoteNow': 'Undi Sekarang',
    'Watch': 'Tonton',
    'WatchMore': 'Tonton Lagi',
    'WatchNow': 'Tonton Sekarang',
    'Directions': 'Arahan',
    'FindStore': 'Cari Gedung',
    'SwitchNow': 'Bertukar Sekarang',
    'VisitStore': 'Lawati Gedung',
    'RenewNow': 'Perbaharui Sekarang',
    'Reorder': 'Susun semula',
    'Buildnow': 'Bina sekarang',
    'Dealers': 'Peniaga',
    'Getdemo': 'Dapatkan tunjuk cara',
    'Getnow': 'Bertaruh sekarang',
    'Gotodemo': 'Pergi ke tunjuk cara',
    'Seedemo': 'Lihat tunjuk cara',
    'Seemodels': 'Lihat model',
    'Seeoffers': 'Lihat tawaran',
    'Viewdemo': 'Lihat tunjuk cara',
    'CustomText': 'Teks Tersuai',
    'Discover': 'Terokai',
    'Dismiss': 'Tolak',
  },
  'Malayalam': {
    'ActNow': 'ഇപ്പോൾ പ്രവർത്തിക്കുക',
    'ApplyNow': 'ഇപ്പോൾ പ്രയോഗിക്കുക',
    'BetNow': 'ഇപ്പോൾ പന്തയം വെയ്ക്കുക',
    'BidNow': 'ഇപ്പോൾ ലേലത്തിലെടുക്കുക',
    'BookACar': 'ഒരു കാർ ബുക്കുചെയ്യുക',
    'BookHotel': 'ഹോട്ടൽ ബുക്കുചെയ്യുക',
    'BookNow': 'ഇപ്പോൾ ബുക്കുചെയ്യുക',
    'Browse': 'ബ്രൗസ് ചെയ്യുക',
    'BuyNow': 'ഇപ്പോൾ വാങ്ങുക',
    'ChatNow': 'ഇപ്പോൾ ചാറ്റ് ചെയ്യുക',
    'Compare': 'താരതമ്യം ചെയ്യുക',
    'ContactUs': 'ഞങ്ങളെ ബന്ധപ്പെടുക',
    'GetCoupon': 'കൂപ്പൺ നേടുക',
    'Donate': 'സംഭാവന ചെയ്യുക',
    'Download': 'ഡൗൺലോഡ് ചെയ്യുക',
    'EmailNow': 'ഇപ്പോൾ ഇമെയില്‍ ചെയ്യുക',
    'EnrollNow': 'ഇപ്പോൾ എൻറോൾ ചെയ്യുക',
    'Explore': 'പര്യവേക്ഷണം ചെയ്യുക',
    'FileNow': 'ഇപ്പോൾ ഫയൽ ചെയ്യുക',
    'FindJob': 'ജോലി കണ്ടെത്തുക',
    'FreePlay': 'സൗജന്യമായി പ്ലേചെയ്യുക',
    'FreeQuote': 'സൗജന്യ ഉദ്ധരണി',
    'FreeTrial': 'സൗജന്യ ട്രയൽ',
    'GetDeals': 'ഡീലുകൾ നേടുക',
    'GetOffer': 'ഓഫർ നേടുക',
    'GetQuote': 'ഉദ്ധരണി നേടുക',
    'JoinNow': 'ഇപ്പോൾ ചേരുക',
    'LearnMore': 'കൂടുതലറിയുക',
    'ListenNow': 'ഇപ്പോൾ ശ്രദ്ധിക്കുക',
    'LogIn': 'ലോഗ് ഓണ്‍ ചെയ്യുക',
    'Message': 'സന്ദേശം',
    'NewCars': 'പുതിയ കാറുകൾ',
    'OrderNow': 'ഇപ്പോൾ ഓർഡർ ചെയ്യുക',
    'PlayGame': 'ഗെയിം പ്ലേചെയ്യുക',
    'PlayNow': 'ഇപ്പോൾ പ്ലേചെയ്യുക',
    'PostJob': 'പോസ്റ്റ് ജോലി',
    'Register': 'രജിസ്റ്റർ ചെയ്യുക',
    'RentACar': 'ഒരു കാർ വാടകയ്‌ക്കെടുക്കുക',
    'RentNow': 'ഇപ്പോൾ വാടകയ്‌ക്കെടുക്കുക',
    'Reserve': 'റിസർവ് ചെയ്യുക',
    'SeeSale': 'വിൽപ്പന കാണുക',
    'SaveNow': 'ഇപ്പോൾ സംരക്ഷിക്കുക',
    'Schedule': 'ഷെഡ്യൂൾ ചെയ്യുക',
    'SeeMenu': 'മെനു കാണുക',
    'SeeMore': 'കൂടുതൽ കാണുക',
    'SeeOffer': 'ഓഫർ കാണുക',
    'SellNow': 'ഇപ്പോൾ വിൽക്കുക',
    'ShopNow': 'ഇപ്പോൾ ഷോപ്പ് ചെയ്യുക',
    'Showtimes': 'പ്രദർശന സമയങ്ങൾ',
    'SignIn': 'സൈന്‍ ഇന്‍ ചെയ്യുക',
    'SignUp': 'സൈൻ അപ്പ് ചെയ്യുക',
    'StartFree': 'സൗജന്യമായി ആരംഭിക്കുക',
    'StartNow': 'ഇപ്പോൾ ആരംഭിക്കുക',
    'Subscribe': 'സബ്‌സ്‌ക്രൈബ് ചെയ്യുക',
    'TestDrive': 'ടെസ്റ്റ് ഡ്രൈവ്',
    'TryNow': 'ഇപ്പോൾ ശ്രമിക്കുക',
    'UsedCars': 'ഉപയോഗിച്ച കാറുകൾ',
    'ViewCars': 'കാറുകൾ കാണിക്കുക',
    'ViewNow': 'ഇപ്പോൾ കാണിക്കുക',
    'ViewPlans': 'പ്ലാനുകൾ കാണിക്കുക',
    'VisitSite': 'സൈറ്റ് സന്ദർശിക്കുക',
    'VoteNow': 'ഇപ്പോൾ വോട്ട് ചെയ്യുക',
    'Watch': 'നിരീക്ഷിക്കുക',
    'WatchMore': 'കൂടുതൽ നിരീക്ഷിക്കുക',
    'WatchNow': 'ഇപ്പോൾ നിരീക്ഷിക്കുക',
    'Directions': 'ദിശാസൂചനകൾ',
    'FindStore': 'സ്റ്റോർ കണ്ടെത്തുക',
    'SwitchNow': 'ഇപ്പോൾ സ്വിച്ചുചെയ്യുക',
    'VisitStore': 'സ്റ്റോർ സന്ദർശിക്കുക',
    'RenewNow': 'ഇപ്പോൾ പുതുക്കുക',
    'Reorder': 'പുനഃക്രമീകരണം',
    'Buildnow': 'ഇപ്പോൾ ബില്‍ഡുചെയ്യുക',
    'Dealers': 'ഡീലർമാർ',
    'Getdemo': 'ഡെമോ നേടുക',
    'Getnow': 'ഇപ്പോൾ നേടുക',
    'Gotodemo': 'ഡെമോയിലേക്ക് പോകുക',
    'Seedemo': 'ഡെമോ കാണുക',
    'Seemodels': 'മോഡലുകൾ കാണുക',
    'Seeoffers': 'ഓഫറുകൾ കാണുക',
    'Viewdemo': 'ഡെമോ കാണുക',
    'CustomText': 'ഇച്ഛാനുസൃത ടെക്സ്റ്റ്',
    'Discover': 'കണ്ടെത്തുക',
    'Dismiss': 'ഡിസ്‍മിസ്',
  },
  'Maori': {
    'ActNow': 'Mahi Ināianei',
    'ApplyNow': 'Hoatu Ināianei',
    'BetNow': 'Peti Ināianei',
    'BidNow': 'Tono Ināianei',
    'BookACar': 'Tāpuitia he Motokā',
    'BookHotel': 'Tāpui Hōtera',
    'BookNow': 'Tāpui Ināianei',
    'Browse': 'Tirotiro',
    'BuyNow': 'Hoko Ināianei',
    'ChatNow': 'Kōrerorero Ināianei',
    'Compare': 'Whakataurite',
    'ContactUs': 'Whakapā Mai',
    'GetCoupon': 'Tiki Tīkitipati',
    'Donate': 'Takoha',
    'Download': 'Tikiake',
    'EmailNow': 'Īmēra Ināianei',
    'EnrollNow': 'Rēhita Mai Ināianei',
    'Explore': 'Hōpara',
    'FileNow': 'Kōnae Ināianei',
    'FindJob': 'Kimi Mahi',
    'FreePlay': 'Purei Koreutu',
    'FreeQuote': 'Whakatau Utu Koreutu',
    'FreeTrial': 'Whakamatautau Koreutu',
    'GetDeals': 'Tiki i Ngā Tukunga',
    'GetOffer': 'Tiki Tukunga',
    'GetQuote': 'Tiki Whakatau Utu',
    'JoinNow': 'Whakauru Ināianei',
    'LearnMore': 'Whiwhi Mōhio Atu Anō',
    'ListenNow': 'Whakarongo Ināianei',
    'LogIn': 'Takiuru',
    'Message': 'Karere',
    'NewCars': 'Ngā Motokā Hōu',
    'OrderNow': 'Ōta Ināianei',
    'PlayGame': 'Purei Kēmu',
    'PlayNow': 'Purei Ināianei',
    'PostJob': 'Pōhi Mahi',
    'Register': 'Rēhita',
    'RentACar': 'Rēti Waka',
    'RentNow': 'Rēti Ināianei',
    'Reserve': 'Rāhui',
    'SeeSale': 'Tirohia te Hoko',
    'SaveNow': 'Tiaki Ināianei',
    'Schedule': 'Hōtaka',
    'SeeMenu': 'Tirohia te Tahua',
    'SeeMore': 'Tirohia Ētahi Anō',
    'SeeOffer': 'Tirohia te Tukunga',
    'SellNow': 'Hokona Ināianei',
    'ShopNow': 'Hokohoko Ināianei',
    'Showtimes': 'Ngā Wā Whakaatu',
    'SignIn': 'Takiuru',
    'SignUp': 'Rēhita Mai',
    'StartFree': 'Tīmata Koreutu',
    'StartNow': 'Tīmata Ināianei',
    'Subscribe': 'Ohauru',
    'TestDrive': 'Puku Whakamātau',
    'TryNow': 'Ngana Ināianei',
    'UsedCars': 'Motukā Kua Whakamahia',
    'ViewCars': 'Tiro Motokā',
    'ViewNow': 'Tiro Ināianei',
    'ViewPlans': 'Tirohia Ngā Mahere',
    'VisitSite': 'Toroa te Pae',
    'VoteNow': 'Pōti Ināianei',
    'Watch': 'Mātaki',
    'WatchMore': 'Mātaki i Ētahi Atu Anō',
    'WatchNow': 'Mātaki Ināianei',
    'Directions': 'Ngā Tohutohu Ahunga',
    'FindStore': 'Kimi Pātaka',
    'SwitchNow': 'Whakawhiti Ināianei',
    'VisitStore': 'Toroa te Pātaka',
    'RenewNow': 'Whakahōu Anō Ināianei',
    'Reorder': 'Tono Anō',
    'Buildnow': 'Hanga ināianei',
    'Dealers': 'Ngā Kaihoko',
    'Getdemo': 'Tiki tauira',
    'Getnow': 'Tiki ināianei',
    'Gotodemo': 'Haere ki te whakatauira',
    'Seedemo': 'Tirohia te whakatauira',
    'Seemodels': 'Tirohia ngā whakatauira',
    'Seeoffers': 'Tirohia ngā tono',
    'Viewdemo': 'Tiro whakatauira',
    'CustomText': 'Kuputuhi Ritenga',
    'Discover': 'Tūhura',
    'Dismiss': 'Ākiri',
  },
  'Marathi': {
    'ActNow': 'आत्ता कृती करा',
    'ApplyNow': 'आत्ता प्रत्‍युत्‍तर द्या',
    'BetNow': 'आत्ता बेट लावा',
    'BidNow': 'आत्ता निविष्ट करा',
    'BookACar': 'कार बुक करा',
    'BookHotel': 'हॉटेल बुक करा',
    'BookNow': 'आत्ता बुक करा',
    'Browse': 'ब्राउझ करा',
    'BuyNow': 'आत्ता खरेदी करा',
    'ChatNow': 'आत्ता गप्पागोष्टी करा',
    'Compare': 'तुलना करा',
    'ContactUs': 'आमच्याशी संपर्क साधा',
    'GetCoupon': 'कूपन मिळवा',
    'Donate': 'दान करा',
    'Download': 'आत्ता डाउनलोड करा',
    'EmailNow': 'आत्ता ईमेल करा',
    'EnrollNow': 'आत्ता नावनोंदणी करा',
    'Explore': 'एक्सप्लोर करा',
    'FileNow': 'आत्ता फाइल करा',
    'FindJob': 'जॉब शोधा',
    'FreePlay': 'विनामूल्य प्ले',
    'FreeQuote': 'विनामूल्य कोट',
    'FreeTrial': 'विनामूल्य चाचणी',
    'GetDeals': 'डील्स मिळवा',
    'GetOffer': 'ऑफर मिळवा',
    'GetQuote': 'कोट मिळवा',
    'JoinNow': 'आत्ता सामील व्हा',
    'LearnMore': 'अधिक जाणून घ्या',
    'ListenNow': 'आत्ता ऐका',
    'LogIn': 'लॉग इन करा',
    'Message': 'संदेश',
    'NewCars': 'नवीन कार्स',
    'OrderNow': 'आत्ता क्रमवारी लावा',
    'PlayGame': 'गेम प्ले करा',
    'PlayNow': 'आत्ता प्ले करा',
    'PostJob': 'जॉब पोस्ट करा',
    'Register': 'नोंदणी करा',
    'RentACar': 'कार भाड्याने घ्या',
    'RentNow': 'आता भाडे द्या',
    'Reserve': 'आरक्षित करा',
    'SeeSale': 'विक्री पहा',
    'SaveNow': 'आत्ता सुरक्षित करा',
    'Schedule': 'शेड्युल',
    'SeeMenu': 'मेनू पहा',
    'SeeMore': 'अधिक पहा',
    'SeeOffer': 'ऑफर पहा',
    'SellNow': 'आत्ता विका',
    'ShopNow': 'आत्ता खरेदी करा',
    'Showtimes': 'शोटाइम',
    'SignIn': 'साइन इन करा',
    'SignUp': 'साइन अप करा',
    'StartFree': 'विनामूल्य प्रारंभ करा',
    'StartNow': 'आत्ता प्रारंभ करा',
    'Subscribe': 'सदस्यता घ्या',
    'TestDrive': 'चाचणी ड्राइव्ह',
    'TryNow': 'आत्ता वापरून पहा',
    'UsedCars': 'वापरलेल्या कार्स',
    'ViewCars': 'कार्स पहा',
    'ViewNow': 'आत्ता नूतनीकरण करा',
    'ViewPlans': 'योजना पहा',
    'VisitSite': 'साइटला भेट द्या',
    'VoteNow': 'आत्ता मतदान करा',
    'Watch': 'पहा',
    'WatchMore': 'अधिक पहा',
    'WatchNow': 'आत्ता पहा',
    'Directions': 'दिशानिर्देश',
    'FindStore': 'Store शोधा',
    'SwitchNow': 'आत्ता स्विच करा',
    'VisitStore': 'Store ला भेद द्या',
    'RenewNow': 'आत्ता नूतनीकरण करा',
    'Reorder': 'पुनर्क्रमित करा',
    'Buildnow': 'आता बिल्ड करा',
    'Dealers': 'डीलर्स',
    'Getdemo': 'डेमो घ्या',
    'Getnow': 'आत्ता घ्या',
    'Gotodemo': 'डेमोवर जा',
    'Seedemo': 'डेमो पहा',
    'Seemodels': 'मॉडेल्स पहा',
    'Seeoffers': 'ऑफर्स पहा',
    'Viewdemo': 'डेमो पहा',
    'CustomText': 'सानुकूल मजकूर',
    'Discover': 'शोधा',
    'Dismiss': 'डिसमिस करा',
  },
  'Nepali': {
    'ActNow': 'अहिले कारबाही गर्नुहोस्',
    'ApplyNow': 'अहिले लागू गर्नुहोस्',
    'BetNow': 'अहिले बाजी लगाउनुहोस्',
    'BidNow': 'अहिले बोली लगाउनुहोस्',
    'BookACar': 'कार बुक गर्नुहोस्',
    'BookHotel': 'होटल बुक गर्नुहोस्',
    'BookNow': 'अहिले बुक गर्नुहोस्',
    'Browse': 'ब्राउज गर्नुहोस्',
    'BuyNow': 'अहिले खरिद गर्नुहोस्‌',
    'ChatNow': 'अहिले च्याट गर्नुहोस्',
    'Compare': 'तुलना गर्नुहोस्',
    'ContactUs': 'हामीलाई सम्पर्क गर्नुहोस्',
    'GetCoupon': 'कुपन प्राप्त गर्नुहोस्',
    'Donate': 'दान गर्नुहोस्',
    'Download': 'डाउनलोड गर्नुहोस्',
    'EmailNow': 'अहिले इमेल गर्नुहोस्',
    'EnrollNow': 'अहिले भर्ना गर्नुहोस्',
    'Explore': 'अन्वेषण गर्नुहोस्',
    'FileNow': 'अहिले फाइल गर्नुहोस्',
    'FindJob': 'जागिर फेला पार्नुहोस्',
    'FreePlay': 'नि: शुल्क प्ले',
    'FreeQuote': 'नि: शुल्क उद्धरण',
    'FreeTrial': 'नि: शुल्क परीक्षण',
    'GetDeals': 'डिलहरू प्राप्त गर्नुहोस्',
    'GetOffer': 'अफर प्राप्त गर्नुहोस्',
    'GetQuote': 'उद्धरण प्राप्त गर्नुहोस्',
    'JoinNow': 'अहिले सामेल हुनुहोस्',
    'LearnMore': 'थप जान्नुहोस्‌',
    'ListenNow': 'अहिले सुन्नुहोस्',
    'LogIn': 'लग इन गर्नुहोस्',
    'Message': 'सन्देश',
    'NewCars': 'नयाँ कारहरू',
    'OrderNow': 'अहिले अर्डर गर्नुहोस्',
    'PlayGame': 'खेल खेल्नुहोस्',
    'PlayNow': 'अहिले प्ले गर्नुहोस्',
    'PostJob': 'जागिर पोस्ट गर्नुहोस्',
    'Register': 'दर्ता गर्नुहोस्',
    'RentACar': 'कार भाडामा लिनुहोस्',
    'RentNow': 'अहिले भाडामा लिनुहोस्',
    'Reserve': 'आरक्षण गर्नुहोस्',
    'SeeSale': 'बिक्री हेर्नुहोस्',
    'SaveNow': 'अहिले बचत गर्नुहोस्',
    'Schedule': 'अनुसूची बनाउनुहोस्',
    'SeeMenu': 'मेनु हेर्नुहोस्',
    'SeeMore': 'थप हेर्नुहोस्',
    'SeeOffer': 'अफर हेर्नुहोस्',
    'SellNow': 'अहिले बेच्नुहोस्',
    'ShopNow': 'अहिले किनमेल गर्नुहोस्',
    'Showtimes': 'शोटाइमहरू',
    'SignIn': 'साइन इन गर्नुहोस्',
    'SignUp': 'साइन अप गर्नुहोस्',
    'StartFree': 'नि: शुल्क सुरु गर्नुहोस्',
    'StartNow': 'अहिले सुरु गर्नुहोस्',
    'Subscribe': 'सदस्यता लिनुहोस्',
    'TestDrive': 'टेस्ट ड्राइभ गर्नुहोस्',
    'TryNow': 'अहिले प्रयास गर्नुहोस्',
    'UsedCars': 'प्रयोग गरिएका कारहरू',
    'ViewCars': 'कारहरू हेर्नुहोस्',
    'ViewNow': 'अहिले हेर्नुहोस्',
    'ViewPlans': 'योजनाहरू हेर्नुहोस्',
    'VisitSite': 'साइट भ्रमण गर्नुहोस्',
    'VoteNow': 'अहिले मतदान गर्नुहोस्',
    'Watch': 'हेर्नुहोस्',
    'WatchMore': 'थप हेर्नुहोस्',
    'WatchNow': 'अहिले हेर्नुहोस्',
    'Directions': 'दिशाहरू',
    'FindStore': 'स्टोर फेला पार्नुहोस्',
    'SwitchNow': 'अहिले परिवर्तन गर्नुहोस्',
    'VisitStore': 'स्टोरमा जानुहोस्',
    'RenewNow': 'अहिले नवीकरण गर्नुहोस्',
    'Reorder': 'पुन: अर्डर गर्नुहोस्',
    'Buildnow': 'अहिले निर्माण गर्नुहोस्',
    'Dealers': 'डिलरहरू',
    'Getdemo': 'डेमो प्राप्त गर्नुहोस्',
    'Getnow': 'अहिले प्राप्त गर्नुहोस्',
    'Gotodemo': 'डेमोमा जानुहोस्',
    'Seedemo': 'डेमो हेर्नुहोस्',
    'Seemodels': 'मोडेलहरू हेर्नुहोस्',
    'Seeoffers': 'अफरहरू हेर्नुहोस्',
    'Viewdemo': 'डेमो हेर्नुहोस्',
    'CustomText': 'अनुकूलित पाठ',
    'Discover': 'खोज गर्नुहोस्',
    'Dismiss': 'खारेज गर्नुहोस्',
  },
  'Oriya': {
    'ActNow': 'ବର୍ତ୍ତମାନ ଏକ୍ଟ କରନ୍ତୁ',
    'ApplyNow': 'ବର୍ତ୍ତମାନ ପ୍ରୟୋଗ କରନ୍ତୁ',
    'BetNow': 'ବର୍ତ୍ତମାନ ବେଟ୍‍ କରନ୍ତୁ',
    'BidNow': 'ବର୍ତ୍ତମାନ ବିଡ୍ କରନ୍ତୁ',
    'BookACar': 'ଏକ କାର୍ ବୁକ୍ କରନ୍ତୁ',
    'BookHotel': 'ହୋଟେଲ ବୁକ୍ କରନ୍ତୁ',
    'BookNow': 'ବର୍ତ୍ତମାନ ବୁକ୍‍ କରନ୍ତୁ',
    'Browse': 'ବ୍ରାଉଜ୍‍ କରନ୍ତୁ',
    'BuyNow': 'ବର୍ତ୍ତମାନ କ୍ରୟ କରନ୍ତୁ',
    'ChatNow': 'ବର୍ତ୍ତମାନ ଚାଟ୍‌ କରନ୍ତୁ',
    'Compare': 'ତୁଳନା କରନ୍ତୁ',
    'ContactUs': 'ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ',
    'GetCoupon': 'କୁପନ୍ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'Donate': 'ଦାନ କରନ୍ତୁ',
    'Download': 'ବର୍ତ୍ତମାନ ଡାଇନ୍‌ଲୋଡ କରନ୍ତୁ',
    'EmailNow': 'ବର୍ତ୍ତମାନ ଇମେଲ୍ କରନ୍ତୁ',
    'EnrollNow': 'ବର୍ତ୍ତମାନ ନାମ ଲେଖାନ୍ତୁ',
    'Explore': 'ଏକ୍ସପ୍ଲୋର୍‌ କରନ୍ତୁ',
    'FileNow': 'ବର୍ତ୍ତମାନ ଫାଇଲ୍ କରନ୍ତୁ',
    'FindJob': 'ଚାକିରି ସନ୍ଧାନ କରନ୍ତୁ',
    'FreePlay': 'ମୁକ୍ତ ଖେଳ',
    'FreeQuote': 'ମୁକ୍ତ କୋଟ୍‍',
    'FreeTrial': 'ମୁକ୍ତ ପରୀକ୍ଷା',
    'GetDeals': 'ଡିଲ୍ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'GetOffer': 'ଅଫର୍‍ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'GetQuote': 'କୋଟ୍‍ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'JoinNow': 'ବର୍ତ୍ତମାନ ଯୋଗ ଦିଅନ୍ତୁ',
    'LearnMore': 'ଅଧିକ ଜାଣନ୍ତୁ',
    'ListenNow': 'ଏବେ ଶୁଣନ୍ତୁ',
    'LogIn': 'ଲଗ୍‌ ଇନ୍‌ କରନ୍ତୁ',
    'Message': 'ବାର୍ତ୍ତା',
    'NewCars': 'ନୂଆ କାର୍‍',
    'OrderNow': 'ବର୍ତ୍ତମାନ ଅର୍ଡର କରନ୍ତୁ',
    'PlayGame': 'ଖେଳ ଖେଳନ୍ତୁ',
    'PlayNow': 'ବର୍ତ୍ତମାନ ଚାଳନ କରନ୍ତୁ',
    'PostJob': 'ଚାକିରି ପୋଷ୍ଟ କରନ୍ତୁ',
    'Register': 'ପଞ୍ଜିକରଣ କରନ୍ତୁ',
    'RentACar': 'ଏକ କାର୍ ଭଡ଼ା ଦିଅନ୍ତୁ',
    'RentNow': 'ବର୍ତ୍ତମାନ ଭଡ଼ାରେ ଦିଅନ୍ତୁ',
    'Reserve': 'ରିଜର୍ଭ କରନ୍ତୁ',
    'SeeSale': 'ବିକ୍ରୟ ଦେଖନ୍ତୁ',
    'SaveNow': 'ବର୍ତ୍ତମାନ ସଂରକ୍ଷଣ କରନ୍ତୁ',
    'Schedule': 'ଅନୁସୂଚୀ',
    'SeeMenu': 'ମେନ୍ୟୁ ଦେଖନ୍ତୁ',
    'SeeMore': 'ଅଧିକ ଦେଖନ୍ତୁ',
    'SeeOffer': 'ଅଫର୍ ଦେଖନ୍ତୁ',
    'SellNow': 'ଏବେ ବିକ୍ରି କରନ୍ତୁ',
    'ShopNow': 'ଏବେ କ୍ରୟ କରନ୍ତୁ',
    'Showtimes': 'Showtimes',
    'SignIn': 'ସାଇନ୍ ଇନ୍ କରନ୍ତୁ',
    'SignUp': 'ସାଇନ୍‌ ଅପ୍‌ କରନ୍ତୁ',
    'StartFree': 'ମୁକ୍ତରେ ଆରମ୍ଭ କରନ୍ତୁ',
    'StartNow': 'ବର୍ତ୍ତମାନ ଆରମ୍ଭ କରନ୍ତୁ',
    'Subscribe': 'ସବସ୍କ୍ରାଇବ କରନ୍ତୁ',
    'TestDrive': 'ଟେଷ୍ଟ ଡ୍ରାଇଭ୍',
    'TryNow': 'ବର୍ତ୍ତମାନ ଚେଷ୍ଟା କରନ୍ତୁ',
    'UsedCars': 'ବ୍ୟବହୃତ କାର୍',
    'ViewCars': 'କାର୍‍ ଦେଖନ୍ତୁ',
    'ViewNow': 'ବର୍ତ୍ତମାନ ଦେଖନ୍ତୁ',
    'ViewPlans': 'ଯୋଜନା ଦେଖନ୍ତୁ',
    'VisitSite': 'ସାଇଟ୍ ପରିଦର୍ଶନ କରନ୍ତୁ',
    'VoteNow': 'ଏବେ ଭୋଟ୍ ଦିଅନ୍ତୁ',
    'Watch': 'ଦେଖନ୍ତୁ',
    'WatchMore': 'ଅଧିକ ଦେଖନ୍ତୁ',
    'WatchNow': 'ବର୍ତ୍ତମାନ ଦେଖନ୍ତୁ',
    'Directions': 'ନିର୍ଦ୍ଦେଶନାମା',
    'FindStore': 'ଷ୍ଟୋର ସନ୍ଧାନ କରନ୍ତୁ',
    'SwitchNow': 'ବର୍ତ୍ତମାନ ସୁଇଚ୍‌ କରନ୍ତୁ',
    'VisitStore': 'ଷ୍ଟୋର ପରିଦର୍ଶନ କରନ୍ତୁ',
    'RenewNow': 'ବର୍ତ୍ତମାନ ନବୀକରଣ କରନ୍ତୁ',
    'Reorder': 'ପୁଣି ଅର୍ଡର୍‍ କରନ୍ତୁ',
    'Buildnow': 'ବର୍ତ୍ତମାନ ନିର୍ମାଣ କରନ୍ତୁ',
    'Dealers': 'ଡିଲରମାନେ',
    'Getdemo': 'ଡେମୋ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'Getnow': 'ବର୍ତ୍ତମାନ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'Gotodemo': 'ଡେମୋ ପ୍ରାପ୍ତ କରନ୍ତୁ',
    'Seedemo': 'ଡେମୋ ଦେଖନ୍ତୁ',
    'Seemodels': 'ମଡେଲ୍ ଦେଖନ୍ତୁ',
    'Seeoffers': 'ଅଫର୍‍‍ଗୁଡ଼ିକ ଦେଖନ୍ତୁ',
    'Viewdemo': 'ଡେମୋ ଦେଖନ୍ତୁ',
    'CustomText': 'ପାଠ୍ୟ କଷ୍ଟମ୍‍ କରନ୍ତୁ',
    'Discover': 'ଆବିଷ୍କାର କରନ୍ତୁ',
    'Dismiss': 'ବରଖାସ୍ତ କରନ୍ତୁ',
  },
  'Persian': {
    'ActNow': 'اکنون اقدام کنید',
    'ApplyNow': 'اکنون درخواست دهید',
    'BetNow': 'اکنون شرط‌بندی کنید',
    'BidNow': 'اکنون پیشنهاد دهید',
    'BookACar': 'خودرویی رزرو کنید',
    'BookHotel': 'رزرو هتل',
    'BookNow': 'اکنون رزرو کنید',
    'Browse': 'مرور',
    'BuyNow': 'اکنون خریداری کنید',
    'ChatNow': 'اکنون گپ بزنید',
    'Compare': 'مقایسه',
    'ContactUs': 'با ما تماس بگیرید',
    'GetCoupon': 'دریافت کوپن',
    'Donate': 'اهدای کمک مالی',
    'Download': 'دانلود',
    'EmailNow': 'اکنون ایمیل کنید',
    'EnrollNow': 'اکنون ثبت نام کنید',
    'Explore': 'کاوش',
    'FileNow': 'اکنون بایگانی کنید',
    'FindJob': 'یافتن کار',
    'FreePlay': 'پخش رایگان',
    'FreeQuote': 'نقل قول رایگان',
    'FreeTrial': 'نسخه آزمایشی رایگان',
    'GetDeals': 'دریافت فروش‌های ویژه',
    'GetOffer': 'دریافت پیشنهاد',
    'GetQuote': 'دریافت نقل قول',
    'JoinNow': 'اکنون بپیوندید',
    'LearnMore': 'بیشتر بدانید',
    'ListenNow': 'اکنون گوش دهید',
    'LogIn': 'ورود به سیستم',
    'Message': 'پیام',
    'NewCars': 'خودروهای جدید',
    'OrderNow': 'اکنون سفارش دهید',
    'PlayGame': 'بازی کردن',
    'PlayNow': 'اکنون بازی کنید',
    'PostJob': 'پست کار',
    'Register': 'ثبت',
    'RentACar': 'کرایه خودرو',
    'RentNow': 'اکنون کرایه کنید',
    'Reserve': 'رزرو',
    'SeeSale': 'مشاهده فروش',
    'SaveNow': 'اکنون ذخیره شود',
    'Schedule': 'زمان‌بندی',
    'SeeMenu': 'مشاهده منو',
    'SeeMore': 'مشاهده بیشتر',
    'SeeOffer': 'مشاهده پیشنهاد',
    'SellNow': 'اکنون بفروشید',
    'ShopNow': 'اکنون بخرید',
    'Showtimes': 'زمان‌های نمایش',
    'SignIn': 'ورود به سیستم',
    'SignUp': 'ثبت نام',
    'StartFree': 'شروع رایگان',
    'StartNow': 'اکنون شروع کنید',
    'Subscribe': 'مشترک شدن',
    'TestDrive': 'رانندگی آزمایشی',
    'TryNow': 'همین حالا امتحان کنید',
    'UsedCars': 'خودروهای کارکرده',
    'ViewCars': 'مشاهده خودروها',
    'ViewNow': 'اکنون مشاهده کنید',
    'ViewPlans': 'مشاهده طرح‌ها',
    'VisitSite': 'بازدید از سایت',
    'VoteNow': 'اکنون رأی بدهید',
    'Watch': 'تماشا',
    'WatchMore': 'تماشای موارد بیشتر',
    'WatchNow': 'اکنون تماشا کنید',
    'Directions': 'مسیرها',
    'FindStore': 'یافتن فروشگاه',
    'SwitchNow': 'اکنون تغییر وضعیت دهید',
    'VisitStore': 'بازدید از فروشگاه',
    'RenewNow': 'اکنون تمدید کنید',
    'Reorder': 'تغییر ترتیب',
    'Buildnow': 'اکنون بسازید',
    'Dealers': 'نمایندگان فروش',
    'Getdemo': 'دریافت نسخه نمایشی',
    'Getnow': 'اکنون دریافت کنید',
    'Gotodemo': 'رفتن به نسخه نمایشی',
    'Seedemo': 'مشاهده نسخه نمایشی',
    'Seemodels': 'مشاهده مدل‌ها',
    'Seeoffers': 'مشاهده پیشنهادها',
    'Viewdemo': 'مشاهده نسخه نمایشی',
    'CustomText': 'متن سفارشی',
    'Discover': 'کشف',
    'Dismiss': 'بستن',
  },
  'Punjabi': {
    'ActNow': 'ਹੁਣ ਕਿਰਿਆ ਕਰੋ',
    'ApplyNow': 'ਹੁਣੇ ਲਾਗੂ ਕਰੋ',
    'BetNow': 'ਹੁਣ ਸ਼ਰਤ ਲਗਾਓ',
    'BidNow': 'ਹੁਣ ਬੋਲੀ ਲਗਾਓ',
    'BookACar': 'ਇੱਕ ਕਾਰ ਬੁੱਕ ਕਰੋ',
    'BookHotel': 'ਹੋਟਲ ਬੁੱਕ ਕਰੋ',
    'BookNow': 'ਹੁਣ ਬੁੱਕ ਕਰੋ',
    'Browse': 'ਬ੍ਰਾਊਜ਼ ਕਰੋ',
    'BuyNow': 'ਹੁਣੇ ਖਰੀਦੋ',
    'ChatNow': 'ਹੂਣੇ ਚੈਟ ਕਰੋ',
    'Compare': 'ਤੁਲਨਾ ਕਰੋ',
    'ContactUs': 'ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ',
    'GetCoupon': 'ਕੂਪਨ ਪ੍ਰਾਪਤ ਕਰੋ',
    'Donate': 'ਦਾਨ',
    'Download': 'ਡਾਉਨਲੋਡ ਕਰੋ',
    'EmailNow': 'ਹੁਣ ਈਮੇਲ ਕਰੋ',
    'EnrollNow': 'ਹੁਣੇ ਦਾਖਲ ਕਰੋ',
    'Explore': 'ਐਕਸਪਲੋਰ ਕਰੋ',
    'FileNow': 'ਹੁਣੇ ਫਾਈਲ ਕਰੋ',
    'FindJob': 'ਕੰਮ ਲੱਭੋ',
    'FreePlay': 'ਫਰੀ ਚਲਾਓ',
    'FreeQuote': 'ਫਰੀ ਹਵਾਲਾ',
    'FreeTrial': 'ਮੁਫ਼ਤ ਟਰਾਇਲ',
    'GetDeals': 'ਸੌਦਿਆਂ ਨੂੰ ਪ੍ਰਾਪਤ ਕਰੋ',
    'GetOffer': 'ਪੇਸ਼ਕਸ਼ ਪ੍ਰਾਪਤ ਕਰੋ',
    'GetQuote': 'ਹਵਾਲਾ ਪ੍ਰਾਪਤ ਕਰੋ',
    'JoinNow': 'ਹੁਣੇ ਸ਼ਾਮਲ ਹੋਵੋ',
    'LearnMore': 'ਹੋਰ ਜਾਣੋ',
    'ListenNow': 'ਹੁਣੇ ਸੁਣੋ',
    'LogIn': 'ਲੌਗ ਇਨ ਕਰੋ',
    'Message': 'ਸੁਨੇਹਾ',
    'NewCars': 'ਨਵੀਆਂ ਕਾਰਾਂ',
    'OrderNow': 'ਹੁਣੇ ਆਰਡਰ ਕਰੋ',
    'PlayGame': 'ਗੇਮ ਚਲਾਓ',
    'PlayNow': 'ਹੁਣ ਚਲਾਓ',
    'PostJob': 'ਪੋਸਟ ਕੰਮ',
    'Register': 'ਰਜਿਸਟਰ ਕਰੋ',
    'RentACar': 'ਇੱਕ ਕਾਰ ਕਿਰਾਏ \'ਤੇ',
    'RentNow': 'ਹੁਣ ਕਿਰਾਏ \'ਤੇ',
    'Reserve': 'ਰਿਜ਼ਰਵ',
    'SeeSale': 'ਵਿਕਰੀ ਦੇਖੋ',
    'SaveNow': 'ਹੁਣੇ ਸੁਰੱਖਿਅਤ ਕਰੋ',
    'Schedule': 'ਸ਼ੈਡਿਊਲ',
    'SeeMenu': 'ਮੀਨੂ ਦੇਖੋ',
    'SeeMore': 'ਹੋਰ ਦੇਖੋ',
    'SeeOffer': 'ਪੇਸ਼ਕਸ਼ ਦੇਖੋ',
    'SellNow': 'ਹੁਣੇ ਵੇਚੋ',
    'ShopNow': 'ਹੁਣ ਖਰੀਦਦਾਰੀ ਕਰੋ',
    'Showtimes': 'ਸ਼ੋਅ ਦੇ ਸਮੇਂ',
    'SignIn': 'ਸਾਈਨ ਇਨ',
    'SignUp': 'ਸਾਈਨ ਅਪ',
    'StartFree': 'ਫਰੀ ਸ਼ੁਰੂ ਕਰੋ',
    'StartNow': 'ਹੁਣੇ ਸ਼ੁਰੂ ਕਰੋ',
    'Subscribe': 'ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ',
    'TestDrive': 'ਟੈਸਟ ਸੰਚਾਲਨ',
    'TryNow': 'ਹੁਣੇ ਅਜ਼ਮਾਓ',
    'UsedCars': 'ਵਰਤੀਆਂ ਹੋਈਆਂ ਕਾਰਾਂ',
    'ViewCars': 'ਕਾਰਾਂ ਦੇਖੋ',
    'ViewNow': 'ਹੁਣੇ ਦੇਖੋ',
    'ViewPlans': 'ਯੋਜਨਾਵਾਂ ਦੇਖੋ',
    'VisitSite': 'ਸਾਈਟ \'ਤੇ ਜਾਓ',
    'VoteNow': 'ਹੁਣ ਵੋਟ ਕਰੋ',
    'Watch': 'ਘੜੀ',
    'WatchMore': 'ਹੋਰ ਦੇਖੋ',
    'WatchNow': 'ਹੁਣੇ ਦੇਖੋ',
    'Directions': 'ਦਿਸ਼ਾਵਾਂ',
    'FindStore': 'ਸਟੋਰ ਲੱਭੋ',
    'SwitchNow': 'ਹੁਣ ਸਵਿੱਚ ਕਰੋ',
    'VisitStore': 'ਸਟੋਰ \'ਤੇ ਜਾਓ',
    'RenewNow': 'ਹੁਣੇ ਨਵਿਆਓ',
    'Reorder': 'ਮੁੜ ਆਰਡਰ ਕਰੋ',
    'Buildnow': 'ਹੁਣੇ ਬਿਲਡ ਕਰੋ',
    'Dealers': 'ਡੀਲਰ',
    'Getdemo': 'ਡੈਮੋ ਪ੍ਰਾਪਤ ਕਰੋ',
    'Getnow': 'ਹੁਣ ਪ੍ਰਾਪਤ ਕਰੋ',
    'Gotodemo': 'ਡੈਮੋ \'ਤੇ ਜਾਓ',
    'Seedemo': 'ਡੈਮੋ ਦੇਖੋ',
    'Seemodels': 'ਮੌਡਲ ਦੇਖੋ',
    'Seeoffers': 'ਪੇਸ਼ਕਸ਼ਾਂ ਦੇਖੋ',
    'Viewdemo': 'ਡੈਮੋ ਦੇਖੋ',
    'CustomText': 'ਕਸਟਮ ਟੈਕਸਟ',
    'Discover': 'ਖੋਜ',
    'Dismiss': 'ਖਾਰਿਜ ਕਰੋ',
  },
  'Quechua': {
    'ActNow': 'Kunan Kuyukachay',
    'ApplyNow': 'Kunan Ruwachiy',
    'BetNow': 'Kunan Makipuray',
    'BidNow': 'Munachikunikita Ruway',
    'BookACar': 'Carro Waqaychakuy',
    'BookHotel': 'Hotel Waqaychakuy',
    'BookNow': 'Kunan Waqaychakuy',
    'Browse': 'Qaway Maskay',
    'BuyNow': 'Kunan Rantiy',
    'ChatNow': 'Kunan Rimana',
    'Compare': 'Tupachinachiy',
    'ContactUs': 'Ñuqaykuwan Tupachikamuy',
    'GetCoupon': 'Cuponta Tariy',
    'Donate': 'Quy',
    'Download': 'Uraykachiy',
    'EmailNow': 'Kunan Correo Electronico',
    'EnrollNow': 'Kunan Listapi Churakuy',
    'Explore': 'Taqwiriy',
    'FileNow': 'Kuna Kipu',
    'FindJob': 'Llamkayta Tariy',
    'FreePlay': 'Kacharisqa Pukllay',
    'FreeQuote': 'Kacharisqa Chaninchay',
    'FreeTrial': 'Kacharisqa Malliy',
    'GetDeals': 'Munachikuykunata Tariy',
    'GetOffer': 'Munachikuyta Tariy',
    'GetQuote': 'Chaninta Tariy',
    'JoinNow': 'Kunan Huñusqakuy',
    'LearnMore': 'Aswan Yachay',
    'ListenNow': 'Kunan Uyariy',
    'LogIn': 'Yaykuy',
    'Message': 'Willay',
    'NewCars': 'Musuq Carrokuna',
    'OrderNow': 'Kunan Ñiqichay',
    'PlayGame': 'Huk Pukllayta Pukllay',
    'PlayNow': 'Kunan Puririchiy',
    'PostJob': 'Qipa Llamkay',
    'Register': 'Qillqachay',
    'RentACar': 'Carrota Alquilay',
    'RentNow': 'Kunan Alquilay',
    'Reserve': 'Waqaychakuy',
    'SeeSale': 'Puchuqta Qaway',
    'SaveNow': 'Kunan Waqaychay',
    'Schedule': 'Pacha patachay',
    'SeeMenu': 'Akllanata Qaway',
    'SeeMore': 'Aswanta Qaway',
    'SeeOffer': 'Munachikuyta Qaway',
    'SellNow': 'Kunan Rantikuy',
    'ShopNow': 'Kunan Rantiy',
    'Showtimes': 'Pacha Patachaykuna',
    'SignIn': 'Ruway Qallariy',
    'SignUp': 'Qillqachakuy',
    'StartFree': 'Kunan Kacharisqa',
    'StartNow': 'Kunan Qallariy',
    'Subscribe': 'Qillqachay',
    'TestDrive': 'Pusanapaq Malliy',
    'TryNow': 'Kunan Ruwapay',
    'UsedCars': 'Hapisqa Carrokuna',
    'ViewCars': 'Carrokuna Qaway',
    'ViewNow': 'Kunan Qawapay',
    'ViewPlans': 'Wakichnakunata Qaway',
    'VisitSite': 'Kiti Watukuy',
    'VoteNow': 'Kunan Akllay Kamachiqta',
    'Watch': 'Intiwatana',
    'WatchMore': 'Aswan Qaway',
    'WatchNow': 'Kunan Qaway',
    'Directions': 'Tarikuykuna',
    'FindStore': 'Qatunata Maskay',
    'SwitchNow': 'Kunan Tikray',
    'VisitStore': 'Qatunata Watukuy',
    'RenewNow': 'Kunan Musuqchay',
    'Reorder': 'Musuqmanta Ñiqichay',
    'Buildnow': 'Kunan wasichiy',
    'Dealers': 'Aypukuqkuna',
    'Getdemo': 'Riqsichiy tariy',
    'Getnow': 'Kunan tariy',
    'Gotodemo': 'Riqsichiyman riy',
    'Seedemo': 'Riqsichiyta qaway',
    'Seemodels': 'Qatipanakunata qaway',
    'Seeoffers': 'Munachikuyta qaway',
    'Viewdemo': 'Riqsichiyta qaway',
    'CustomText': 'Sapanchasqa Qillqa',
    'Discover': 'Taripay',
    'Dismiss': 'Wischuy',
  },
  'Tamil': {
    'ActNow': 'இப்போதே செயல்படவும்',
    'ApplyNow': 'இப்போதே விண்ணப்பிக்கவும்',
    'BetNow': 'இப்போது பந்தயம் கட்டவும்',
    'BidNow': 'இப்போதே ஏலம் எடுங்கள்',
    'BookACar': 'காரை முன்பதிவு செய்யுங்கள்',
    'BookHotel': 'ஹோட்டலை முன்பதிவு செய்யுங்கள்',
    'BookNow': 'இப்போதே முன்பதிவு செய்யுங்கள்',
    'Browse': 'உலாவுக',
    'BuyNow': 'இப்போதே வாங்குக',
    'ChatNow': 'இப்போது அரட்டை அடியுங்கள்',
    'Compare': 'ஒப்பிடுக',
    'ContactUs': 'எங்களைத் தொடர்பு கொள்க',
    'GetCoupon': 'கூப்பனைப் பெறுக',
    'Donate': 'நன்கொடையளிக்கவும்',
    'Download': 'பதிவிறக்கவும்',
    'EmailNow': 'இப்போதே மின்னஞ்சல்செய்க',
    'EnrollNow': 'இப்போதே பதிவுசெய்க',
    'Explore': 'ஆராயுங்கள்',
    'FileNow': 'இப்போதே தாக்கல் செய்யுங்கள்',
    'FindJob': 'பணியைத் தேடுக',
    'FreePlay': 'இலவச விளையாட்டு',
    'FreeQuote': 'இலவச மேற்கோள்',
    'FreeTrial': 'இலவச சோதனை',
    'GetDeals': 'ஒப்பந்தங்களைப் பெறுங்கள்',
    'GetOffer': 'சலுகை பெறுங்கள்',
    'GetQuote': 'மேற்கோள் பெறவும்',
    'JoinNow': 'இப்போதே சேருங்கள்',
    'LearnMore': 'மேலும் அறிக',
    'ListenNow': 'இப்போது கேளுங்கள்',
    'LogIn': 'உள்நுழைக',
    'Message': 'செய்தி',
    'NewCars': 'புதிய கார்கள்',
    'OrderNow': 'இப்போது ஆர்டர் செய்க',
    'PlayGame': 'விளையாட்டை விளையாடவும்',
    'PlayNow': 'இப்போது இயக்கவும்',
    'PostJob': 'பணியை இடுகையிடவும்',
    'Register': 'பதிவுசெய்க',
    'RentACar': 'ஒரு காரை வாடகைக்கு எடுக்கவும்',
    'RentNow': 'இப்போது வாடகைக்கு எடுக்கவும்',
    'Reserve': 'ஒதுக்கவும்',
    'SeeSale': 'விற்பனையைப் பார்க்கவும்',
    'SaveNow': 'இப்போது சேமிக்கவும்',
    'Schedule': 'திட்டமிடுக',
    'SeeMenu': 'மெனுவைப் பார்க்கவும்',
    'SeeMore': 'மேலும் காண்க',
    'SeeOffer': 'சலுகையைப் பார்க்கவும்',
    'SellNow': 'இப்போது விற்கவும்',
    'ShopNow': 'இப்போது ஷாப்பிங் செய்யவும்',
    'Showtimes': 'காட்சி நேரங்கள்',
    'SignIn': 'உள்நுழைக',
    'SignUp': 'பதிவுபெறுக',
    'StartFree': 'இலவசமாகத் தொடங்குங்கள்',
    'StartNow': 'இப்போதே தொடங்குங்கள்',
    'Subscribe': 'குழுவில் சேரவும்',
    'TestDrive': 'சோதனை ஓட்டம்',
    'TryNow': 'இப்போதே முயலவும்',
    'UsedCars': 'பயன்படுத்திய கார்கள்',
    'ViewCars': 'கார்களைப் பார்க்கவும்',
    'ViewNow': 'இப்போது பார்க்கவும்',
    'ViewPlans': 'திட்டங்களைக் காண்க',
    'VisitSite': 'தளத்தைப் பார்வையிடவும்',
    'VoteNow': 'இப்போதே வாக்களியுங்கள்',
    'Watch': 'பார்க்கவும்',
    'WatchMore': 'மேலும் பார்க்கவும்',
    'WatchNow': 'இப்போது பார்க்கவும்',
    'Directions': 'திசைகள்',
    'FindStore': 'ஸ்டோரைக் கண்டுபிடிக்கவும்',
    'SwitchNow': 'இப்போதே நிலைமாற்றவும்',
    'VisitStore': 'ஸ்டோரைப் பார்வையிடவும்',
    'RenewNow': 'இப்போது புதுப்பிக்கவும்',
    'Reorder': 'மீண்டும் ஆர்டர் செய்யுங்கள்',
    'Buildnow': 'இப்போது கட்டியெழுப்பவும்',
    'Dealers': 'டீலர்கள்',
    'Getdemo': 'செயல்விளக்கத்தைப் பெறுங்கள்',
    'Getnow': 'இப்போது பெறுங்கள்',
    'Gotodemo': 'செயல்விளக்கத்திற்குச் செல்லவும்',
    'Seedemo': 'செயல்விளக்கத்தைப் பார்க்கவும்',
    'Seemodels': 'மாதிரிகளைப் பார்க்கவும்',
    'Seeoffers': 'சலுகைகளைப் பார்க்கவும்',
    'Viewdemo': 'செயல்விளக்கத்தைப் பார்க்கவும்',
    'CustomText': 'விருப்ப உரை',
    'Discover': 'கண்டறிக',
    'Dismiss': 'நிராகரிக்கவும்',
  },
  'Telugu': {
    'ActNow': 'ఇప్పుడే పని చేయండి',
    'ApplyNow': 'ఇప్పుడే దరఖాస్తు చేసుకోండి',
    'BetNow': 'ఇప్పుడే పందెం వేయండి',
    'BidNow': 'ఇప్పుడే వేలం వేయండి',
    'BookACar': 'కారు బుక్ చేయండి',
    'BookHotel': 'హోటల్ బుక్ చేయండి',
    'BookNow': 'ఇప్పుడే బుకింగ్ చేయండి',
    'Browse': 'బ్రౌజ్ చేయండి',
    'BuyNow': 'ఇప్పుడే కొనుగోలు చేయండి',
    'ChatNow': 'ఇప్పుడే చాట్ చేయండి',
    'Compare': 'సరిపోల్చండి',
    'ContactUs': 'మమ్మల్ని సంప్రదించండి',
    'GetCoupon': 'కూపన్ పొందండి',
    'Donate': 'దానం చేయండి',
    'Download': 'డౌన్‌లోడ్ చేయండి',
    'EmailNow': 'ఇప్పుడే ఇమెయిల్ పంపండి',
    'EnrollNow': 'ఇప్పుడే నమోదు చేసుకోండి',
    'Explore': 'విశ్లేషించండి',
    'FileNow': 'ఇప్పుడే ఫైల్ చేయండి',
    'FindJob': 'పనిని కనుగొనండి',
    'FreePlay': 'ఉచిత ఆట',
    'FreeQuote': 'ఉచిత కోట్',
    'FreeTrial': 'ఉచిత ట్రయల్',
    'GetDeals': 'డీల్‌లు పొందండి',
    'GetOffer': 'ఆఫర్‌ను పొందండి',
    'GetQuote': 'కోట్ పొందండి',
    'JoinNow': 'ఇప్పుడే చేరండి',
    'LearnMore': 'మరింత తెలుసుకోండి',
    'ListenNow': 'ఇప్పుడే వినండి',
    'LogIn': 'లాగిన్ చేయండి',
    'Message': 'సందేశం',
    'NewCars': 'కొత్త కార్లు',
    'OrderNow': 'ఇప్పుడే ఆర్డర్ చేయండి',
    'PlayGame': 'ఆట ఆడండి',
    'PlayNow': 'ఇప్పుడే ఆడండి',
    'PostJob': 'పనిని పోస్ట్ చేయండి',
    'Register': 'రిజిస్టర్ చేసుకోండి',
    'RentACar': 'కారును అద్దెకు తీసుకోండి',
    'RentNow': 'ఇప్పుడే అద్దెకు తీసుకోండి',
    'Reserve': 'రిజర్వ్ చేయండి',
    'SeeSale': 'అమ్మకం చూడండి',
    'SaveNow': 'ఇప్పుడే సేవ్ చేయండి',
    'Schedule': 'షెడ్యూల్ చేయండి',
    'SeeMenu': 'మెను చూడండి',
    'SeeMore': 'మరిన్ని చూడండి',
    'SeeOffer': 'ఆఫర్ చూడండి',
    'SellNow': 'ఇప్పుడే అమ్మండి',
    'ShopNow': 'ఇప్పుడే షాపింగ్ చేయండి',
    'Showtimes': 'ప్రదర్శన సమయాలు',
    'SignIn': 'సైన్ ఇన్ చేయండి',
    'SignUp': 'సైన్ అప్ చేయండి',
    'StartFree': 'ఉచితంగా ప్రారంభించండి',
    'StartNow': 'ఇప్పుడే ప్రారంభించండి',
    'Subscribe': 'సభ్యత్వం పొందండి',
    'TestDrive': 'టెస్ట్ డ్రైవ్',
    'TryNow': 'ఇప్పుడే ప్రయత్నించండి',
    'UsedCars': 'ఉపయోగించిన కార్లు',
    'ViewCars': 'కార్లను వీక్షించండి',
    'ViewNow': 'ఇప్పుడే వీక్షించండి',
    'ViewPlans': 'ప్లాన్‌లను వీక్షించండి',
    'VisitSite': 'సైట్‌ను సందర్శించండి',
    'VoteNow': 'ఇప్పుడే ఓటు వేయండి',
    'Watch': 'చూడండి',
    'WatchMore': 'మరిన్ని చూడండి',
    'WatchNow': 'ఇప్పుడే చూడండి',
    'Directions': 'దిశలు',
    'FindStore': 'స్టోర్ కనుగొనండి',
    'SwitchNow': 'ఇప్పుడే మారండి',
    'VisitStore': 'స్టోర్‌ను సందర్శించండి',
    'RenewNow': 'ఇప్పుడే పునరుద్ధరించండి',
    'Reorder': 'మళ్లీ ఆర్డర్ చేయండి',
    'Buildnow': 'ఇప్పుడే నిర్మించండి',
    'Dealers': 'డీలర్‌లు',
    'Getdemo': 'డెమో పొందండి',
    'Getnow': 'ఇప్పుడే పొందండి',
    'Gotodemo': 'డెమోకి వెళ్లండి',
    'Seedemo': 'డెమో చూడండి',
    'Seemodels': 'మోడల్‌లు చూడండి',
    'Seeoffers': 'ఆఫర్‌లు చూడండి',
    'Viewdemo': 'డెమోను వీక్షించండి',
    'CustomText': 'అనుకూల టెక్స్ట్',
    'Discover': 'కనుగొనండి',
    'Dismiss': 'విస్మరించండి',
  },
  'Urdu': {
    'ActNow': 'ابھی اقدام کریں',
    'ApplyNow': 'ابھی درخواست دیں',
    'BetNow': 'ابھی شرط لگائیں',
    'BidNow': 'ابھی بولی دیں',
    'BookACar': 'کار بک کریں',
    'BookHotel': 'ہوٹل بک کریں',
    'BookNow': 'ابھی بک کریں',
    'Browse': 'براؤز کریں',
    'BuyNow': 'ابھی خریدیں',
    'ChatNow': 'ابھی بات چیت کریں',
    'Compare': 'موازنہ کریں',
    'ContactUs': 'ہم سے رابطہ کریں',
    'GetCoupon': 'کوپن حاصل کریں',
    'Donate': 'عطیہ کریں',
    'Download': 'ڈاؤن لوڈ کریں',
    'EmailNow': 'ابھی ای میل کریں',
    'EnrollNow': 'ابھی اندراج کروائیں',
    'Explore': 'دریافت کریں',
    'FileNow': 'ابھی فائل کریں',
    'FindJob': 'جاب ڈھونڈیں',
    'FreePlay': 'مفت میں کھیلیں',
    'FreeQuote': 'مفت کوٹیشن',
    'FreeTrial': 'مفت ٹرائل',
    'GetDeals': 'ڈیلز حاصل کریں',
    'GetOffer': 'پیشکش حاصل کریں',
    'GetQuote': 'کوٹیشن حاصل کریں',
    'JoinNow': 'ابھی شامل ہوں',
    'LearnMore': 'مزید جانیے',
    'ListenNow': 'ابھی سنیں',
    'LogIn': 'لاگ ان کریں',
    'Message': 'پیغام',
    'NewCars': 'نئی کاریں',
    'OrderNow': 'ابھی آرڈر کریں',
    'PlayGame': 'گیم کھیلیں',
    'PlayNow': 'ابھی کھیلیں',
    'PostJob': 'جاب پوسٹ کریں',
    'Register': 'رجسٹر ہوں',
    'RentACar': 'کار کرائے پر لیں',
    'RentNow': 'ابھی کرائے پر لیں',
    'Reserve': 'ریزرو کریں',
    'SeeSale': 'سیل دیکھیں',
    'SaveNow': 'ابھی بچت کریں',
    'Schedule': 'شیڈول',
    'SeeMenu': 'مینو دیکھیں',
    'SeeMore': 'مزید دیکھیں',
    'SeeOffer': 'پیشکش دیکھیں',
    'SellNow': 'ابھی بیچیں',
    'ShopNow': 'ابھی خریداری کریں',
    'Showtimes': 'شو کے اوقات',
    'SignIn': 'سائن ان کریں',
    'SignUp': 'سائن اپ کریں',
    'StartFree': 'مفت میں شروع کریں',
    'StartNow': 'ابھی شروع کریں',
    'Subscribe': 'سبسکرائب کریں',
    'TestDrive': 'ٹیسٹ ڈرائیو',
    'TryNow': 'ابھی آزمائیں',
    'UsedCars': 'استعمال شدہ کاریں',
    'ViewCars': 'کاریں دیکھیں',
    'ViewNow': 'ابھی دیکھیں',
    'ViewPlans': 'منصوبے دیکھیں',
    'VisitSite': 'سائٹ کا دورہ کریں',
    'VoteNow': 'ابھی ووٹ دیں',
    'Watch': 'دیکھیں',
    'WatchMore': 'مزید دیکھیں',
    'WatchNow': 'ابھی دیکھیں',
    'Directions': 'ہدایات',
    'FindStore': 'سٹور تلاش کریں',
    'SwitchNow': 'ابھی سوئچ کریں',
    'VisitStore': 'سٹور کا دورہ کریں',
    'RenewNow': 'ابھی تجدید کریں',
    'Reorder': 'ترتیب بدلیں',
    'Buildnow': 'ابھی تعمیر کریں',
    'Dealers': 'ڈیلرز',
    'Getdemo': 'ڈیمو حاصل کریں',
    'Getnow': 'ابھی حاصل کریں',
    'Gotodemo': 'ڈیمو پر جائیں',
    'Seedemo': 'ڈیمو دیکھیں',
    'Seemodels': 'ماڈلز دیکھیں',
    'Seeoffers': 'پیشکشیں دیکھیں',
    'Viewdemo': 'ڈیمو دیکھیں',
    'CustomText': 'تخصیص کردہ متن',
    'Discover': 'دریافت کریں',
    'Dismiss': 'برخاست کریں',
  },
  'Uzbek': {
    'ActNow': 'Hozir harakat qilish',
    'ApplyNow': 'Hozir tatbiq etish',
    'BetNow': 'Hozir pul tikish',
    'BidNow': 'Hozir narxlash',
    'BookACar': 'Avtomobil bandlash',
    'BookHotel': 'Mehmonxona bandlash',
    'BookNow': 'Hozir bandlash',
    'Browse': 'Tanlash',
    'BuyNow': 'Hozir sotib olish',
    'ChatNow': 'Hozir chatlashish',
    'Compare': 'Taqqoslash',
    'ContactUs': 'Biz bilan aloqa',
    'GetCoupon': 'Kupon olish',
    'Donate': 'Xayriya qilish',
    'Download': 'Yuklab olish',
    'EmailNow': 'Hozir xat yuborish',
    'EnrollNow': 'Hozir qayd qilish',
    'Explore': 'Tanishuv',
    'FileNow': 'Hozir saqlash',
    'FindJob': 'Ish topish',
    'FreePlay': 'Bepul oʻyin',
    'FreeQuote': 'Bepul iqtibos',
    'FreeTrial': 'Bepul sinov',
    'GetDeals': 'Takliflar olish',
    'GetOffer': 'Taklif olish',
    'GetQuote': 'Iqtibos olish',
    'JoinNow': 'Hozir qoʻshilish',
    'LearnMore': 'Batafsil',
    'ListenNow': 'Hozir tinglash',
    'LogIn': 'Kirish',
    'Message': 'Xabar',
    'NewCars': 'Yangi avtomobillar',
    'OrderNow': 'Hozir buyurtma berish',
    'PlayGame': 'Oʻyin boshlash',
    'PlayNow': 'Hozir oʻynash',
    'PostJob': 'Vakansiya joylash',
    'Register': 'Roʻyxatdan oʻtish',
    'RentACar': 'Avtomobilni ijaraga olish',
    'RentNow': 'Hozir ijaraga olish',
    'Reserve': 'Bandlash',
    'SeeSale': 'Chegirma',
    'SaveNow': 'Hozir saqlash',
    'Schedule': 'Jadval',
    'SeeMenu': 'Menyuni koʻrish',
    'SeeMore': 'Yana',
    'SeeOffer': 'Taklifni koʻrish',
    'SellNow': 'Hozir sotish',
    'ShopNow': 'Hozir xarid qilish',
    'Showtimes': 'Namoyish vaqtlari',
    'SignIn': 'Kirish',
    'SignUp': 'Yozilish',
    'StartFree': 'Bepul boshlash',
    'StartNow': 'Hozir boshlash',
    'Subscribe': 'Obuna bo‘lish',
    'TestDrive': 'Haydashni sinash',
    'TryNow': 'Hoziroq sinash',
    'UsedCars': 'Ishlatilgan avtomobillar',
    'ViewCars': 'Avtomobillarni koʻrish',
    'ViewNow': 'Hozir koʻrish',
    'ViewPlans': 'Tarif rejalari',
    'VisitSite': 'Saytga kirish',
    'VoteNow': 'Hozir ovoz berish',
    'Watch': 'Tomosha qilish',
    'WatchMore': 'Yana tomosha qilish',
    'WatchNow': 'Hozir tomosha qilish',
    'Directions': 'Yoʻnalishlar',
    'FindStore': 'Doʻkon topish',
    'SwitchNow': 'Hozir almashtirish',
    'VisitStore': 'Doʻkonga tashrif buyurish',
    'RenewNow': 'Hozir yangilash',
    'Reorder': 'Qayta buyurtma berish',
    'Buildnow': 'Hozir qurish',
    'Dealers': 'Dilerlar',
    'Getdemo': 'Demo olish',
    'Getnow': 'Hozir olish',
    'Gotodemo': 'Demoga oʻtish',
    'Seedemo': 'Demoni koʻrish',
    'Seemodels': 'Modellarni koʻrish',
    'Seeoffers': 'Takliflarni koʻrish',
    'Viewdemo': 'Demoni ochish',
    'CustomText': 'Maxsus matn',
    'Discover': 'Tanishish',
    'Dismiss': 'Yopish',
  },
  'Welsh': {
    'ActNow': 'Gweithredu Nawr',
    'ApplyNow': 'Defnyddio Nawr',
    'BetNow': 'Betio Nawr',
    'BidNow': 'Cynnig Nawr',
    'BookACar': 'Archebu Car',
    'BookHotel': 'Book Hotel',
    'BookNow': 'Archebu Nawr',
    'Browse': 'Pori',
    'BuyNow': 'Prynu Nawr',
    'ChatNow': 'Sgwrsio Nawr',
    'Compare': 'Cymharu',
    'ContactUs': 'Cysylltu â ni',
    'GetCoupon': 'Cael Cwpon',
    'Donate': 'Rhoi',
    'Download': 'Lawrlwytho',
    'EmailNow': 'E-bostio Nawr',
    'EnrollNow': 'Cofrestru Nawr',
    'Explore': 'Archwilio',
    'FileNow': 'Ffeilio Nawr',
    'FindJob': 'Canfod Tasg',
    'FreePlay': 'Chwarae Am Ddim',
    'FreeQuote': 'Dyfyniad Am Ddim',
    'FreeTrial': 'Treial am Ddim',
    'GetDeals': 'Cael Bargeinion',
    'GetOffer': 'Cael Cynnig',
    'GetQuote': 'Cael Dyfyniad',
    'JoinNow': 'Ymuno Nawr',
    'LearnMore': 'Dysgu Mwy',
    'ListenNow': 'Gwrando Nawr',
    'LogIn': 'Mewngofnodi',
    'Message': 'Neges',
    'NewCars': 'Ceir Newydd',
    'OrderNow': 'Archebu nawr',
    'PlayGame': 'Chwarae Gêm',
    'PlayNow': 'Chwarae Nawr',
    'PostJob': 'Postio Swydd',
    'Register': 'Cofrestr',
    'RentACar': 'Rhentu Car',
    'RentNow': 'Rhentu Nawr',
    'Reserve': 'Cadw',
    'SeeSale': 'Gweld Gwerthiant',
    'SaveNow': 'Cadw Nawr',
    'Schedule': 'Trefnu',
    'SeeMenu': 'Gweld Dewislen',
    'SeeMore': 'Gweld Rhagor',
    'SeeOffer': 'Gweld y Cynnig',
    'SellNow': 'Gwerthu Nawr',
    'ShopNow': 'Siopa Nawr',
    'Showtimes': 'Amseroedd y Sioe',
    'SignIn': 'Mewngofnodi',
    'SignUp': 'Cofrestru',
    'StartFree': 'Dechrau am Ddim',
    'StartNow': 'Dechrau Nawr',
    'Subscribe': 'Tanysgrifio',
    'TestDrive': 'Profi Gyrru',
    'TryNow': 'Rhowch Gynnig Arni Nawr',
    'UsedCars': 'Ceir Ail-law',
    'ViewCars': 'Gweld Ceir',
    'ViewNow': 'Gweld Nawr',
    'ViewPlans': 'Gweld y Cynlluniau',
    'VisitSite': 'Ymweld â\'r Wefan',
    'VoteNow': 'Pleidleisio Nawr',
    'Watch': 'Gwylio',
    'WatchMore': 'Gwylio Mwy',
    'WatchNow': 'Gwylio Nawr',
    'Directions': 'Cyfarwyddiadau',
    'FindStore': 'Canfod Siop',
    'SwitchNow': 'Newid Nawr',
    'VisitStore': 'Mynd i\'r Siop',
    'RenewNow': 'Adnewyddu Nawr',
    'Reorder': 'Ail-archeb',
    'Buildnow': 'Adeiladu nawr',
    'Dealers': 'Gwerthwyr',
    'Getdemo': 'Cael arddangosiad',
    'Getnow': 'Cael nawr',
    'Gotodemo': 'Mynd i\'r arddangosiad',
    'Seedemo': 'Gweld arddangosiad',
    'Seemodels': 'Gweld modelau',
    'Seeoffers': 'Gweld cynigion',
    'Viewdemo': 'Gweld arddangosiad',
    'CustomText': 'Testun Personol',
    'Discover': 'Darganfod',
    'Dismiss': 'Anwybyddu',
  },
  'Tagalog': {
    'ActNow': 'Kumilos Ngayon',
    'ApplyNow': 'I-apply Ngayon',
    'BetNow': 'Mag-bet Ngayon',
    'BidNow': 'Mag-bid Ngayon',
    'BookACar': 'Mag-book ng Kotse',
    'BookHotel': 'Mag-book ng Hotel',
    'BookNow': 'Mag-book Ngayon',
    'Browse': 'I-browse',
    'BuyNow': 'Bumili Ngayon',
    'ChatNow': 'Makipag-chat ngayon',
    'Compare': 'Ikumpara',
    'ContactUs': 'Makipag-ugnayan sa amin',
    'GetCoupon': 'Kumuha ng Coupon',
    'Donate': 'I-donate',
    'Download': 'I-download',
    'EmailNow': 'I-email Ngayon',
    'EnrollNow': 'Mag-enroll Ngayon',
    'Explore': 'I-explore',
    'FileNow': 'Mag-File Ngayon',
    'FindJob': 'Maghanap ng Trabaho',
    'FreePlay': 'Libreng Laro',
    'FreeQuote': 'Libreng Quote',
    'FreeTrial': 'Libreng Trial',
    'GetDeals': 'Kumuha Ng Mga Deal',
    'GetOffer': 'Kumuha ng Alok',
    'GetQuote': 'Kumuha ng Quote',
    'JoinNow': 'Sumali Ngayon',
    'LearnMore': 'Alamin Pa',
    'ListenNow': 'Makinig Ngayon',
    'LogIn': 'Mag log in',
    'Message': 'Mensahe',
    'NewCars': 'Mga Bagong Kotse',
    'OrderNow': 'Mag-order Ngayon',
    'PlayGame': 'Maglaro',
    'PlayNow': 'I-play Ngayon',
    'PostJob': 'I-post ang Trabaho',
    'Register': 'Magparehistro',
    'RentACar': 'Mag-rent ng kotse',
    'RentNow': 'I-rent Ngayon',
    'Reserve': 'Magreserba',
    'SeeSale': 'Tingnan ang Benta',
    'SaveNow': 'I-save Ngayon',
    'Schedule': 'Iskedyul',
    'SeeMenu': 'Tingnan ang Menu',
    'SeeMore': 'Tumingin Pa ng Marami',
    'SeeOffer': 'Tingnan ang Alok',
    'SellNow': 'Ibenta Ngayon',
    'ShopNow': 'Mamili Ngayon',
    'Showtimes': 'Mga Showtime',
    'SignIn': 'Mag-sign in',
    'SignUp': 'Mag-sign Up',
    'StartFree': 'Magsimula nang Libre',
    'StartNow': 'Magsimula Ngayon',
    'Subscribe': 'Mag-subscribe',
    'TestDrive': 'Sumubok Mag-Drive',
    'TryNow': 'Subukan Ngayon',
    'UsedCars': 'Mga Gamit na Kotse',
    'ViewCars': 'Tingnan ang Mga Kotse',
    'ViewNow': 'Tingnan Ngayon',
    'ViewPlans': 'Tingnan ang Mga Plano',
    'VisitSite': 'Bisitahin ang Site',
    'VoteNow': 'Bumoto Ngayon',
    'Watch': 'Relo',
    'WatchMore': 'Manood pa ng Marami',
    'WatchNow': 'Manood Ngayon',
    'Directions': 'Mga Direksyon',
    'FindStore': 'Humanap ng Store',
    'SwitchNow': 'Lumipat Ngayon',
    'VisitStore': 'Bisitahin ang Store',
    'RenewNow': 'I-renew ngayon',
    'Reorder': 'Pagsunud-sunurin',
    'CustomText': 'Custom na Text',
  },
};


export const newActionTextMapper = {
  'English': {
    'BuildNow': 'Build Now',
    'Dealers': 'Dealers',
    'GetDemo': 'Get Demo',
    'GetNow': 'Get Now',
    'GoToDemo': 'Go To Demo',
    'SeeDemo': 'See Demo',
    'SeeModels': 'See Models',
    'SeeOffers': 'See Offers',
    'ViewDemo': 'View Demo',
  },
  'Danish': {
    'BuildNow': 'Byg nu',
    'Dealers': 'Forhandlere',
    'GetDemo': 'Få demo',
    'GetNow': 'Få nu',
    'GoToDemo': 'Gå til demo',
    'SeeDemo': 'Se demo',
    'SeeModels': 'Se modeller',
    'SeeOffers': 'Se tilbud',
    'ViewDemo': 'Vis demo',
  },
  'German': {
    'BuildNow': 'Jetzt erstellen',
    'Dealers': 'Händler',
    'GetDemo': 'Demo erhalten',
    'GetNow': 'Jetzt erhalten',
    'GoToDemo': 'Zur Demo gehen',
    'SeeDemo': 'Demo ansehen',
    'SeeModels': 'Modelle anzeigen',
    'SeeOffers': 'Angebote ansehen',
    'ViewDemo': 'Demo anzeigen',

  },
  'Spanish': {
    'BuildNow': 'Compilar ahora',
    'Dealers': 'Agentes',
    'GetDemo': 'Obtener demo',
    'GetNow': 'Obtener ahora',
    'GoToDemo': 'Ir a demo',
    'SeeDemo': 'Consultar demo',
    'SeeModels': 'Ver modelos',
    'SeeOffers': 'Ver ofertas',
    'ViewDemo': 'Ver demos',
  },
  'Finnish': {
    'BuildNow': 'Luo nyt',
    'Dealers': 'Myyjät',
    'GetDemo': 'Hanki demo',
    'GetNow': 'Hanki nyt',
    'GoToDemo': 'Siirry demoon',
    'SeeDemo': 'Katso demo',
    'SeeModels': 'Katso mallit',
    'SeeOffers': 'Katso tarjoukset',
    'ViewDemo': 'Näytä demo',
  },
  'French': {
    'BuildNow': 'Créer',
    'Dealers': 'Revendeurs',
    'GetDemo': 'Obtenir la démo',
    'GetNow': 'Obtenir',
    'GoToDemo': 'Aller à la démo',
    'SeeDemo': 'Voir la démo',
    'SeeModels': 'Voir les modèles',
    'SeeOffers': 'Voir les offres',
    'ViewDemo': 'Afficher la démo',
  },
  'Italian': {
    'BuildNow': 'Crea ora',
    'Dealers': 'Concessionari',
    'GetDemo': 'Scarica demo',
    'GetNow': 'Scarica ora',
    'GoToDemo': 'Vai alla demo',
    'SeeDemo': 'Guarda demo',
    'SeeModels': 'Guarda modelli',
    'SeeOffers': 'Guarda offerte',
    'ViewDemo': 'Visualizza demo',
  },
  'Norwegian': {
    'BuildNow': 'Bygg nå',
    'Dealers': 'Forhandlere',
    'GetDemo': 'Få demo',
    'GetNow': 'Få nå',
    'GoToDemo': 'Gå til demo',
    'SeeDemo': 'Se demo',
    'SeeModels': 'Se modeller',
    'SeeOffers': 'Se tilbud',
    'ViewDemo': 'Vis demo',
  },
  'Dutch': {
    'BuildNow': 'Nu bouwen',
    'Dealers': 'Dealers',
    'GetDemo': 'Demo ophalen',
    'GetNow': 'Nu ophalen',
    'GoToDemo': 'Ga naar demo',
    'SeeDemo': 'Demo bekijken',
    'SeeModels': 'Bekijk modellen',
    'SeeOffers': 'Bekijk aanbied.',
    'ViewDemo': 'Demo weergeven',
  },
  'Portuguese': {
    'BuildNow': 'Construir Agora',
    'Dealers': 'Concessionárias',
    'GetDemo': 'Obter demo',
    'GetNow': 'Obter agora',
    'GoToDemo': 'Ir para demo',
    'SeeDemo': 'Ver demo',
    'SeeModels': 'Ver modelos',
    'SeeOffers': 'Ver ofertas',
    'ViewDemo': 'Exibir demo',
  },
  'Swedish': {
    'BuildNow': 'Bygg nu',
    'Dealers': 'Handlare',
    'GetDemo': 'Hämta demo',
    'GetNow': 'Hämta nu',
    'GoToDemo': 'Gå till demo',
    'SeeDemo': 'Se demo',
    'SeeModels': 'Se modeller',
    'SeeOffers': 'Se erbjudanden',
    'ViewDemo': 'Visa demo',

  },
  'TraditionalChinese': {
    'BuildNow': '立即建立',
    'Dealers': '經銷商',
    'GetDemo': '取得示範',
    'GetNow': '立即取得',
    'GoToDemo': '移至示範',
    'SeeDemo': '查看示範',
    'SeeModels': '查看型號',
    'SeeOffers': '查看優惠',
    'ViewDemo': '檢視示範',
  },
  'Polish': {
    'BuildNow': 'Buduj teraz',
    'Dealers': 'Sprzedawcy',
    'GetDemo': 'Pobierz pokaz',
    'GetNow': 'Pobierz teraz',
    'GoToDemo': 'Idź do pokazu',
    'SeeDemo': 'Zobacz pokaz',
    'SeeModels': 'Zobacz modele',
    'SeeOffers': 'Zobacz oferty',
    'ViewDemo': 'Wyświetl pokaz',
  },
  'Turkish': {
    'BuildNow': 'Hemen Oluştur',
    'Dealers': 'Bayiler',
    'GetDemo': 'Demo al',
    'GetNow': 'Hemen al',
    'GoToDemo': 'Demoya git',
    'SeeDemo': 'Demoyu gör',
    'SeeModels': 'Modelleri gör',
    'SeeOffers': 'Teklifleri gör',
    'ViewDemo': 'Demoyu görüntüle',
  },
  'Greek': {
    'BuildNow': 'Χτίστε τώρα',
    'Dealers': 'Αντιπροσωπείες',
    'GetDemo': 'Λήψη επίδειξης',
    'GetNow': 'Λήψη τώρα',
    'GoToDemo': 'Επίδειξη',
    'SeeDemo': 'Εμφάν. επίδειξης',
    'SeeModels': 'Εμφάν. μοντέλων',
    'SeeOffers': 'Εμφάν. προσφορών',
    'ViewDemo': 'Προβ. επίδειξης',
  },
  'Bulgarian': {
    'BuildNow': 'Изградете сега',
    'Dealers': 'Търговци',
    'GetDemo': 'Получете демо',
    'GetNow': 'Получете сега',
    'GoToDemo': 'Към демо',
    'SeeDemo': 'Вижте демо',
    'SeeModels': 'Вижте модели',
    'SeeOffers': 'Вижте оферти',
    'ViewDemo': 'Преглед на демо',
  },
  'Croatian': {
    'BuildNow': 'Izradi odmah',
    'Dealers': 'Ovlašteni distr.',
    'GetDemo': 'Dohvati pok. ver',
    'GetNow': 'Dohvati odmah',
    'GoToDemo': 'Idi na pok. ver.',
    'SeeDemo': 'Pogl. pok. ver.',
    'SeeModels': 'Pogl. modele',
    'SeeOffers': 'Pogl. ponude',
    'ViewDemo': 'Prikaz pok. ver.',
  },
  'Czech': {
    'BuildNow': 'Sestavit',
    'Dealers': 'Dealeři',
    'GetDemo': 'Získat ukázku',
    'GetNow': 'Získat',
    'GoToDemo': 'Přejít k ukázce',
    'SeeDemo': 'Zobrazit ukázku',
    'SeeModels': 'Zobrazit modely',
    'SeeOffers': 'Zobrazit nabídky',
    'ViewDemo': 'Zhlédnout ukázku',
  },
  'Estonian': {
    'BuildNow': 'Praegune vers.',
    'Dealers': 'Edasimüüjad',
    'GetDemo': 'Hangi demo',
    'GetNow': 'Hangi kohe',
    'GoToDemo': 'Mine demosse',
    'SeeDemo': 'Vaata demot',
    'SeeModels': 'Vaata mudeleid',
    'SeeOffers': 'Vaata pakkumisi',
    'ViewDemo': 'Demo vaatamine',
  },
  'Hungarian': {
    'BuildNow': 'Létrehozás most',
    'Dealers': 'Kereskedők',
    'GetDemo': 'Demó beszerzése',
    'GetNow': 'Beszerzés most',
    'GoToDemo': 'Ugrás a demóra',
    'SeeDemo': 'Demó megnézése',
    'SeeModels': 'Modellek megtek.',
    'SeeOffers': 'Ajánl. megtek.',
    'ViewDemo': 'Demó megtekint.',
  },
  'Latvian': {
    'BuildNow': 'Veidot tagad',
    'Dealers': 'Dīleri',
    'GetDemo': 'Iegūt demo',
    'GetNow': 'Iegūt tagad',
    'GoToDemo': 'Doties uz demo',
    'SeeDemo': 'Skatīt demo',
    'SeeModels': 'Skatīt modeļus',
    'SeeOffers': 'Skatīt piedāvāj.',
    'ViewDemo': 'Apskatīt demo',
  },
  'Lithuanian': {
    'BuildNow': 'Kurti dabar',
    'Dealers': 'Platintojai',
    'GetDemo': 'Gauti dem. ver.',
    'GetNow': 'Gauti dabar',
    'GoToDemo': 'Eiti į dem. ver.',
    'SeeDemo': 'Žr. dem. ver.',
    'SeeModels': 'Žr. modelius',
    'SeeOffers': 'Perž. pasiūlymus',
    'ViewDemo': 'Perž. dem. ver.',
  },
  'Maltese': {
    'BuildNow': 'Ibni Issa',
    'Dealers': 'Negozjanti',
    'GetDemo': 'Ikseb Wirja',
    'GetNow': 'Ikseb issa',
    'GoToDemo': 'Mur għall-wirja',
    'SeeDemo': 'Ara l-wirja',
    'SeeModels': 'Ara l-mudelli',
    'SeeOffers': 'Ara l-offerti',
    'ViewDemo': 'Eżamina l-wirja',
  },
  'Romanian': {
    'BuildNow': 'Compilați acum',
    'Dealers': 'Furnizori',
    'GetDemo': 'Obțineți demo',
    'GetNow': 'Obțineți acum',
    'GoToDemo': 'Accesați demo',
    'SeeDemo': 'Vedeți demo',
    'SeeModels': 'Vedeți modele',
    'SeeOffers': 'Vedeți oferte',
    'ViewDemo': 'Vizualizați demo',
  },
  'Slovak': {
    'BuildNow': 'Zostaviť',
    'Dealers': 'Predajcovia',
    'GetDemo': 'Získať ukážku',
    'GetNow': 'Získať',
    'GoToDemo': 'Prejsť na ukážku',
    'SeeDemo': 'Otvoriť ukážku',
    'SeeModels': 'Zobraziť modely',
    'SeeOffers': 'Zobraziť ponuky',
    'ViewDemo': 'Zobraziť ukážku',
  },
  'Slovenian': {
    'BuildNow': 'Zgradi zdaj',
    'Dealers': 'Prodajalci',
    'GetDemo': 'Prenesi predst.',
    'GetNow': 'Prenesi zdaj',
    'GoToDemo': 'Pojdi na predst.',
    'SeeDemo': 'Ogled predstav.',
    'SeeModels': 'Ogled modelov',
    'SeeOffers': 'Ogled ponudb',
    'ViewDemo': 'Prikaz predstav.',
  },
  'Albanian': {
    'BuildNow': 'Krijo tani',
    'Dealers': 'Shitësit',
    'GetDemo': 'Merr demo',
    'GetNow': 'Merr tani',
    'GoToDemo': 'Shko te demo',
    'SeeDemo': 'Shiko demo',
    'SeeModels': 'Shiko modelet',
    'SeeOffers': 'Shiko ofertat',
    'ViewDemo': 'Shfaq demo',
  },
  'Bosnian': {
    'BuildNow': 'Napravi sada',
    'Dealers': 'Prodavači',
    'GetDemo': 'Pokazna verzija',
    'GetNow': 'Preuzmi sada',
    'GoToDemo': 'Idi na pokazno',
    'SeeDemo': 'Prikaži pokazno',
    'SeeModels': 'Prikaži modele',
    'SeeOffers': 'Prikaži ponude',
    'ViewDemo': 'Pokazni prikaz',
  },
  'Icelandic': {
    'BuildNow': 'Smíða núna',
    'Dealers': 'Söluaðilar',
    'GetDemo': 'Sækja sýnidæmi',
    'GetNow': 'Sækja núna',
    'GoToDemo': 'Fara í sýnidæmi',
    'SeeDemo': 'Sjá sýnishorn',
    'SeeModels': 'Skoða líkön',
    'SeeOffers': 'Skoða tilboð',
    'ViewDemo': 'Sjá sýnidæmi',
  },
  'Macedonian': {
    'BuildNow': 'Изгради сега',
    'Dealers': 'Продавачи',
    'GetDemo': 'Добиј демо',
    'GetNow': 'Добиј сега',
    'GoToDemo': 'Оди на демо',
    'SeeDemo': 'Види демо',
    'SeeModels': 'Види модели',
    'SeeOffers': 'Види понуди',
    'ViewDemo': 'Прегледај демо',
  },
  'Serbian': {
    'BuildNow': 'Napravi odmah',
    'Dealers': 'Prodavci',
    'GetDemo': 'Nabavi demo',
    'GetNow': 'Nabavi odmah',
    'GoToDemo': 'Idi na demo',
    'SeeDemo': 'Pogledajte demo',
    'SeeModels': 'Prikaži modele',
    'SeeOffers': 'Prikaži ponude',
    'ViewDemo': 'Prikaži demo',
  },
  'Japanese': {
    'BuildNow': '今すぐビルド',
    'Dealers': 'ディーラー',
    'GetDemo': 'デモを入手',
    'GetNow': '今すぐ入手',
    'GoToDemo': 'デモに移動',
    'SeeDemo': 'デモを見る',
    'SeeModels': 'モデルの表示',
    'SeeOffers': 'オファーを見る',
    'ViewDemo': 'デモの表示',
  },
  'Russian': {
    'BuildNow': 'Построить сейчас',
    'Dealers': 'Дилеры',
    'GetDemo': 'Получить демо',
    'GetNow': 'Получить сейчас',
    'GoToDemo': 'Перейти к демо',
    'SeeDemo': 'Смотреть демо',
    'SeeModels': 'Смотреть модели',
    'SeeOffers': 'Предложения',
    'ViewDemo': 'Просмотреть демо',
  },
  'Arabic': {
    'BuildNow': 'الإنشاء الآن',
    'Dealers': 'الموزّعون',
    'GetDemo': 'احصل على نسخة تجريبية',
    'GetNow': 'الحصول على الآن',
    'GoToDemo': 'إنتقال إلى العرض',
    'SeeDemo': 'عرض العرض',
    'SeeModels': 'عرض النماذج',
    'SeeOffers': 'مشاهدة العروض',
    'ViewDemo': 'مشاهدة العرض',
  },
  'Hebrew': {
    'BuildNow': 'בנה עכשיו',
    'Dealers': 'סוכנים',
    'GetDemo': 'השג הדגמה',
    'GetNow': 'השג עכשיו',
    'GoToDemo': 'עבור אל הדגמה',
    'SeeDemo': 'ראה הדגמה',
    'SeeModels': 'ראה מודלים',
    'SeeOffers': 'ראה הצעות',
    'ViewDemo': 'סרטון הדגמה',
  },
  'SimplifiedChinese': {
    'BuildNow': '立即生成',
    'Dealers': '经销商',
    'GetDemo': '获取演示',
    'GetNow': '立即获取',
    'GoToDemo': '转到演示',
    'SeeDemo': '请参阅演示',
    'SeeModels': '查看模型',
    'SeeOffers': '查看产品',
    'ViewDemo': '查看演示',
  },
  'Hindi': {
    'BuildNow': 'अभी बनाएँ',
    'Dealers': 'डीलर्स',
    'GetDemo': 'डेमो प्राप्त करें',
    'GoToDemo': 'डेमो पर जाएँ',
    'GetNow': 'अभी प्राप्त करें',
    'SeeDemo': 'डेमो देखें',
    'SeeModels': 'मॉडल देखें',
    'SeeOffers': 'ऑफ़र देखें',
    'ViewDemo': 'डेमो देखें',
  },
  'Indonesian': {
    'BuildNow': 'Buat sekarang',
    'Dealers': 'Dealer',
    'GetDemo': 'Dapatkan demo',
    'GoToDemo': 'Buka demo',
    'GetNow': 'Dapatkan sekarang',
    'SeeDemo': 'Lihat demo',
    'SeeModels': 'Lihat model',
    'SeeOffers': 'Lihat penawaran',
    'ViewDemo': 'Tampilkan demo',
  },
  'Thai': {
    'BuildNow': 'สร้างทันที',
    'Dealers': 'ตัวแทนจำหน่าย',
    'GetDemo': 'รับการสาธิต',
    'GoToDemo': 'ไปที่การสาธิต',
    'GetNow': 'รับทันที',
    'SeeDemo': 'ดูการสาธิต',
    'SeeModels': 'ดูโมเดล',
    'SeeOffers': 'ดูข้อเสนอ',
    'ViewDemo': 'ดูการสาธิต',
  },
  'Vietnamese': {
    'BuildNow': 'Dựng ngay',
    'Dealers': 'Đại lý',
    'GetDemo': 'Lấy bản demo',
    'GoToDemo': 'Đến bản demo',
    'GetNow': 'Lấy ngay',
    'SeeDemo': 'Xem bản demo',
    'SeeModels': 'Xem mẫu',
    'SeeOffers': 'Xem chào hàng',
    'ViewDemo': 'Xem bản demo',
  },
  'Tagalog': {
    'BuildNow': 'Bumuo ngayon',
    'Dealers': 'Mga Dealer',
    'GetDemo': 'Kunin ang demo',
    'GetNow': 'Kunin ngayon',
    'GoToDemo': 'Pumunta sa demo',
    'SeeDemo': 'Tingnan ang demo',
    'SeeModels': 'Tingnan ang mga modelo',
    'SeeOffers': 'Tingnan ang mga alok',
    'ViewDemo': 'Tingnan ang demo',
  },
  'Malay': {
    'BuildNow': 'Bina sekarang',
    'Dealers': 'Peniaga',
    'GetDemo': 'Dapatkan tunjuk cara',
    'GetNow': 'Bertaruh sekarang',
    'GoToDemo': 'Pergi ke tunjuk cara',
    'SeeDemo': 'Lihat tunjuk cara',
    'SeeModels': 'Lihat model',
    'SeeOffers': 'Lihat tawaran',
    'ViewDemo': 'Lihat tunjuk cara',
  },
};
